export const LANGUAGE_MESSAGES = {
  "en-GB": {
    common: {
      back: "Back",
      cancel: "Cancel",
      change: "Change",
      close: "Close",
      continue: "Continue",
      discard: "Discard",
      changesSaved: "Changes saved",
      keepEditing: "Keep editing",
      no: "No",
      save: "Save",
      saving: "Saving...",
      yes: "Yes",
      loggingOut: "Logging out...",
      logout: "Log out",
      loading: "Loading...",
      manage: "Manage",
      open: "Open",
      comingSoon: "Coming soon",
      legal: {
        terms: "Terms & Conditions",
        privacy: "Privacy Policy",
        dataDeletion: "Data Deletion",
        copyright: "© {year} AfriMed™ Telehealth",
      },
    },
    routeFallback: {
      checkingSession: "Sitzung wird gepruft...",
      loadingLogin: "Anmeldung wird geladen...",
      finishingSignIn: "Anmeldung wird abgeschlossen...",
      loadingOnboarding: "Onboarding wird geladen...",
      loadingPatientProfile: "Patientenprofil wird geladen...",
      loadingDoctorProfile: "Arztprofil wird geladen...",
      loadingProfile: "Profil wird geladen...",
      loadingNotification: "Benachrichtigung wird geladen...",
      loadingPatientSettings: "Patienteneinstellungen werden geladen...",
      loadingDoctorSettings: "Arzteinstellungen werden geladen...",
      loadingKyc: "KYC wird geladen...",
    },
    routeFallback: {
      checkingSession: "Verification de la session...",
      loadingLogin: "Chargement de la connexion...",
      finishingSignIn: "Finalisation de la connexion...",
      loadingOnboarding: "Chargement de l'onboarding...",
      loadingPatientProfile: "Chargement du profil patient...",
      loadingDoctorProfile: "Chargement du profil medecin...",
      loadingProfile: "Chargement du profil...",
      loadingNotification: "Chargement de la notification...",
      loadingPatientSettings: "Chargement des parametres patient...",
      loadingDoctorSettings: "Chargement des parametres medecin...",
      loadingKyc: "Chargement du KYC...",
    },
    routeFallback: {
      checkingSession: "A verificar sessao...",
      loadingLogin: "A carregar acesso...",
      finishingSignIn: "A concluir inicio de sessao...",
      loadingOnboarding: "A carregar onboarding...",
      loadingPatientProfile: "A carregar perfil do paciente...",
      loadingDoctorProfile: "A carregar perfil do medico...",
      loadingProfile: "A carregar perfil...",
      loadingNotification: "A carregar notificacao...",
      loadingPatientSettings: "A carregar definicoes do paciente...",
      loadingDoctorSettings: "A carregar definicoes do medico...",
      loadingKyc: "A carregar KYC...",
    },
    routeFallback: {
      checkingSession: "Checking session...",
      loadingLogin: "Loading login...",
      finishingSignIn: "Finishing sign-in...",
      loadingOnboarding: "Loading onboarding...",
      loadingPatientProfile: "Loading patient profile...",
      loadingDoctorProfile: "Loading doctor profile...",
      loadingProfile: "Loading profile...",
      loadingNotification: "Loading notification...",
      loadingPatientSettings: "Loading patient settings...",
      loadingDoctorSettings: "Loading doctor settings...",
      loadingKyc: "Loading KYC...",
    },
    auth: {
      login: {
        sheetMethodLabel: "Choose sign-in method",
        methods: {
          email: "Email",
          phone: "Phone",
        },
        sheet: {
          email: "Email",
          emailPlaceholder: "you@example.com",
          sendMagicLink: "Email me a secure sign-in link",
          sending: "Sending...",
          phoneLabel: "Country code, Phone number",
          continue: "Continue",
          phoneSaved:
            "Saved as pending verification. Now sign in with email to continue.",
          phoneHint: "We'll verify this number later via WhatsApp.",
          invalidPhone: "Enter a valid SADC/Diaspora phone number.",
          invalidPhoneLength: "Please enter a valid phone number (7-12 digits).",
          cooldown: "You can request a new link in {seconds}s.",
          waitBeforeRetry: "Please wait {seconds}s before requesting another link.",
          rateLimit: "Too many requests. Please wait 1 minute, then try again.",
          loginOnlyMode:
            "We couldn't sign you in from that link. Please request a fresh secure sign-in link and open the latest email.",
          emailUnavailable:
            "Email sign-in is temporarily unavailable. Please try again shortly or use Google/Facebook.",
          networkIssue: "Network issue while sending link. Please retry.",
          linkSent:
            "We sent you a sign-in link. Open it on this same browser/device.",
          close: "Close",
          manageCookies: "Manage cookies",
          complianceLine: "HIPAA & GDPR Compliant Digital Health Infrastructure.",
        },
        landing: {
          title: "Welcome to AfriMed™",
          line1: "Let's take the journey to better",
          line2: "health-together!",
          registerEmail: "Sign up with email",
          registerFacebook: "Sign up with Facebook",
          registerGoogle: "Sign up with Google",
          login: "Log in",
          trouble: "Trouble logging in?",
          trial: "Start a 14-day free trial",
          journey: "Your journey to care starts here!",
        },
      },
      resetPassword: {
        invalidLink: "This link is invalid or expired. Please request a new one.",
        missingLink: "Recovery link missing or invalid.",
        updateError: "We couldn't update your password. Please try again.",
        title: "Set new password",
        intro: "Create a new password for your account.",
        successTitle: "Password reset",
        successIntro:
          "Your password has been updated. You can now log in with your email and password.",
        newPassword: "New password",
        newPasswordHelper: "At least 8 characters",
        confirmPassword: "Confirm password",
        saving: "Saving...",
        save: "Save new password",
        requestNewLink: "Request new reset link",
        backToLogin: "Back to login",
      },
      demo: {
        title: "Demo access",
        intro: "Use a pre-filled account to explore AfriMed™.",
        form: {
          emailRequired: "Email address is required",
          passwordRequired: "Password is required",
          signInError: "Could not sign in.",
          networkError:
            "Network error. Please check your connection and try again.",
          errorTitle: "Authentication Failed",
          copyError: "Copy error message",
          dismiss: "Dismiss",
          emailLabel: "Email Address",
          emailPlaceholder: "Enter your email address",
          passwordLabel: "Password",
          passwordPlaceholder: "Enter your password",
          rememberMe: "Remember me",
          forgotPassword: "Forgot password?",
          signingIn: "Signing In...",
          signIn: "Sign In",
          demoTitle: "Demo Credentials Available",
          demoIntro: "Use these demo accounts to test the platform",
          doctorAccount: "Doctor Account",
          patientAccount: "Patient Account",
          patientJane: "Patient Account (Jane)",
        },
      },
      signUp: {
        title: "Welcome to AfriMed™",
        subtitle: "Create your account to continue.",
        rolePatient: "Patient",
        roleDoctor: "Doctor",
        continueWithGoogle: "Continue with Google",
        continueWithEmail: "or continue with email",
        email: "Email",
        emailPlaceholder: "you@domain.com",
        password: "Password",
        passwordPlaceholder: "Strong password",
        createAccount: "Create account",
        existingAccount: "Already have an account?",
        forgotPassword: "Forgot password?",
      },
      forgotPassword: {
        title: "Reset your password",
        intro: "Enter your email and we’ll send you a secure link to create a new password.",
        email: "Email",
        emailPlaceholder: "you@example.com",
        sendLink: "Send reset link",
        sending: "Sending...",
        sendError: "We couldn't send the password reset link. Please try again.",
        backToLogin: "Back to login",
        usePhoneInstead: "Use phone instead",
        checkEmail: "Check your email for a secure password reset link.",
      },
      idleLogout: {
        title: "Are you still there?",
        bodyLead: "For your security, we'll log you out in",
        bodyEnd: "if there's no activity.",
        logOut: "Log out",
        staySignedIn: "Stay signed in",
      },
    },
    home: {
      patient: {
        welcome: "Welcome, {firstName}!",
        actions: {
          openProfile: "Open profile",
          notifications: "Notifications",
          viewAll: "View all",
        },
        appointments: {
          title: "Your Appointments",
          tabs: {
            upcoming: "Upcoming",
            past: "Past",
            pending: "Pending for approval",
          },
          empty: {
            title: "No appointments yet",
            body: "Book a doctor to get started with care.",
          },
          bookAction: "Book appointment",
          error: "We're loading your appointments. Please try again in a moment.",
        },
        serviceCategories: {
          title: "Service categories",
          doctors: "Clinicians",
          hospitals: "Hospitals",
          pharmacies: "Pharmacies",
          ambulances: "Ambulances",
        },
        popularServices: {
          title: "Popular services",
          action: "All services",
        },
        nearby: {
          title: "Healthcare near you",
          action: "Find healthcare near me",
          selectedFacility: "Selected facility",
          seeDoctors: "See clinicians at this facility",
          loading: "Loading nearby facilities...",
          findDoctors: "Find clinicians",
          searchPlaceholder: "Search facilities",
          clearSearch: "Clear search",
          showingNear: "Showing facilities near",
          clearSelectedFacility: "Clear selected facility",
          defaultFacilityName: "Healthcare facility",
        },
        verifyIdentity: {
          title: "Verify your identity",
          body: "Verified profiles generate more trust.",
          pending: "Pending review",
          action: "Verify now",
        },
      },
      doctor: {
        fallbackName: "Doctor",
        patientFallback: "Patient",
        consultancyFallback: "Consultancy",
        welcome: "Welcome {doctorName}",
        specialtyFallback: "Doctor",
        actions: {
          openProfile: "Open profile",
          dashboard: "Dashboard",
          notifications: "Notifications",
          viewAll: "View all",
        },
        appointments: {
          title: "Your Appointments",
          loading: "Loading appointments...",
          loadingError: "We are loading your appointments. Please refresh shortly.",
          error: "Could not load appointments.",
          emptyTitle: "You don't have any scheduled appointments.",
          emptyBody: "Approved appointments will appear here once patients confirm them.",
          tabs: {
            today: "Today",
            todayCount: "Today {count}",
            upcoming: "Upcoming",
            upcomingCount: "Upcoming {count}",
            pending: "Pending for approval",
            pendingCount: "Pending for approval {count}",
          },
        },
        elevate: {
          title: "Elevate your Consultancy",
        },
        gallery: {
          title: "Make your profile standout",
          body: "Add images about your consultancy",
          notNow: "Not now",
        },
        regional: {
          title: "Regional health",
          headline: "Stay informed of the region's",
          defaultSummary: "health trends and conditions",
          facilitySummary: "{count} mapped facilities and trends",
        },
      },
    },
    settings: {
      home: {
        title: "Settings",
        userFallback: "User",
        loginSecurity: "Account & Security",
        language: "Language",
        availability: "Availability",
        notifications: "Notifications",
        preferences: "Preferences",
        legal: "Legal",
        faq: "FAQ",
        logoutDialog: {
          title: "Are you sure you want to log out?",
          body: "You'll need to sign in again to continue.",
        },
      },
      welcome: {
        fallbackName: "there",
        title: "Welcome {name} to your Settings",
        doctorBody:
          "Settings is your control centre where you set your profile picture, appointment schedules and manage everything in your account, payments, notifications and much more.",
        patientBody:
          "Settings is your control centre where you set your profile picture and manage security, payments, notifications and more.",
      },
      subflows: {
        patientEhr: {
          title: "My Health Record",
          subtitle:
            "Your visits, prescriptions, referrals, tests and clinician notes — secured in one place.",
          unlockTitle: "Unlock My Health Record",
          unlockBody: "Enter your AfriMed™ password to open your health record.",
          unlockPasswordLabel: "Password",
          unlockAction: "Unlock record",
        },
      },
      password: {
        createTitle: "Create your password",
        createCopy: "Use at least 8 characters with uppercase, lowercase, number and symbol.",
        createSignOutNotice:
          "After creating your password, you’ll be signed out. Please sign back in with your new password.",
        createAction: "Create password",
        generateAction: "Generate strong password",
        changeTitle: "Change your password",
        changeCopy: "Use at least 8 characters with uppercase, lowercase, number and symbol.",
        currentLabel: "Current password",
        newLabel: "New password",
        confirmLabel: "Confirm password",
        updateAction: "Update password",
        forgotPassword: "Forgot password",
        showPassword: "Show password",
        hidePassword: "Hide password",
        enterAndConfirm: "Enter and confirm your new password.",
        minLength: "Use at least 8 characters with uppercase, lowercase, number and symbol.",
        mismatch: "Passwords do not match. Try again.",
        created: "Password created",
        updated: "Password updated",
        verifyError: "We could not verify your password. Please try again.",
        samePasswordError: "This password is already in use. Please choose a different password.",
        sessionExpiredError:
          "Your session has expired. Please sign in again and create your password.",
        weakPasswordError:
          "Please choose a less predictable password. Try adding more words, numbers, or mixed characters.",
        strongHelpTitle: "Use a strong password",
        requirementsLabel: "Password requirements",
        requirementUppercase: "Uppercase",
        requirementLowercase: "Lowercase",
        requirementNumber: "Number",
        requirementSymbol: "Symbol",
        requirementMinLength: "Minimum 8 characters",
        saveError: "We could not save your password right now. Please try again.",
        reset: {
          title: "Reset your health record password",
          subtitle:
            "Enter your email and we’ll send instructions to reset the password used to access your health record.",
          emailLabel: "Email",
          action: "Send reset instructions",
          requestError: "We couldn’t send reset instructions right now. Please try again.",
          confirmTitle: "Check your inbox",
          confirmSubtitle:
            "We sent a password reset email with instructions. Please open the email and follow the secure link to choose a new health record password.",
          backToEhr: "Back to My Health Record",
          backToSecurity: "Back to Account Security",
          confirm: {
            title: "Choose a new health record password",
            subtitle:
              "Use at least 8 characters with uppercase, lowercase, number and symbol.",
            newLabel: "New password",
            confirmLabel: "Confirm password",
            action: "Save password",
            minLength:
              "Use at least 8 characters with uppercase, lowercase, number and symbol.",
            policy:
              "Use at least 8 characters with uppercase, lowercase, number and symbol.",
            successTitle: "Password saved",
            successSubtitle: "Your health record password has been reset.",
            mismatch: "Passwords do not match. Try again.",
            missingToken: "This reset link is missing or invalid.",
            saveError:
              "We couldn’t reset your health record password. Please request a new link and try again.",
          },
        },
      },
      passcode: {
        createTitle: "Create a passcode",
        createCopy: "Protect your AfriMed™ account with a 6-digit passcode.",
        changeTitle: "Choose a new passcode",
        changeCopy:
          "Use a 6-digit code that's easy for you to remember but hard for others to guess.",
        newLabel: "New passcode",
        confirmLabel: "Confirm passcode",
        createAction: "Create passcode",
        saveAction: "Save passcode",
        created: "Passcode created",
        updated: "Passcode updated",
        errors: {
          enterBoth: "Enter a 6-digit code in both fields.",
          mismatch: "The codes don’t match. Check and try again.",
          save: "We couldn’t update your passcode right now. Please try again.",
        },
      },
      profile: {
        doctor: {
          servicesPricing: "Services & pricing",
        },
      },
      practiceMode: {
        title: "Practice mode",
        notSelected: "Not selected",
        question: "How do you want to consult on AfriMed™?",
        intentOnly:
          "This records your consultation model only. Verification, booking readiness, and discovery rules remain unchanged.",
        loading: "Loading practice mode...",
        saved: "Practice mode saved",
        helpers: {
          virtual:
            "Virtual consultations can run without displaying a physical practice address.",
          physical: "In-person consultations use your clinic locations and availability.",
          hybrid:
            "Patients can book either virtual or in-person consultations where available.",
        },
        options: {
          virtual: {
            label: "Virtual only",
            description:
              "Offer secure online consultations without showing a physical practice address.",
          },
          physical: {
            label: "Physical practice",
            description:
              "Offer in-person consultations at one or more clinic locations.",
          },
          hybrid: {
            label: "Hybrid",
            description: "Offer both virtual and in-person consultations.",
          },
        },
        errors: {
          load: "We couldn’t load your practice mode. Please try again.",
          save: "We couldn’t save your practice mode. Please try again.",
        },
      },
      practiceTeam: {
        title: "Practice Team",
        preferenceSubtitle: "Invite trusted staff to help you manage your consultation.",
        intro:
          "Invite trusted members of staff to help manage appointments, patient communication, billing follow-up and day-to-day practice administration.",
        addCta: "Add team member",
        empty: {
          title: "No team members yet",
          body:
            "Add a practice assistant, receptionist or manager to help keep your practice running smoothly.",
        },
        status: {
          pending_invite: "Pending invite",
          active: "Active",
          suspended: "Suspended",
          removed: "Removed",
        },
        actions: {
          resend: "Resend",
          sending: "Sending...",
          suspend: "Suspend",
          remove: "Remove",
          restore: "Restore",
          removed: "Removed",
        },
        messages: {
          proofSent: "Invitation proof sent.",
          liveSent: "Invitation sent.",
          active: "Team member restored.",
          suspended: "Team member suspended.",
          removed: "Team member removed.",
        },
        errors: {
          load: "We could not load your practice team right now.",
          update: "We could not update this team member right now.",
          resend: "We could not send this invitation right now. Please try again.",
        },
        add: {
          title: "Add team member",
          intro:
            "Choose the role they will support, then send an invitation to join your practice team.",
          accessTitle: "Access while AfriMed™ is in staging",
          accessBody:
            "Practice team members can be invited now so clinicians can review the workflow. Access to sensitive patient records and clinical actions remains protected until delegated permissions are fully reviewed.",
          firstName: "First name",
          firstNamePlaceholder: "First name",
          familyName: "Family name",
          familyNamePlaceholder: "Family name",
          email: "Email",
          emailPlaceholder: "email@example.com",
          role: "Role",
          rolePlaceholder: "Select role",
          note: "Short note / invitation message",
          notePlaceholder: "Optional message for the invitation proof",
          submit: "Send invitation",
          sending: "Sending...",
          success: "Pending invitation created and proof email sent.",
          errors: {
            duplicate: "This team member already has a pending or active invitation.",
            save:
              "We could not create this practice team invitation. Please try again.",
          },
        },
        roleGuide: {
          title: "Role guide",
          body:
            "Choose the responsibility set that matches the trusted person. One person can carry multiple responsibilities; you do not need separate people for every role.",
        },
        invite: {
          title: "Practice Team invitation",
          subtitle:
            "Review your AfriMed™ Practice Team invite. Access remains limited while delegated practice support is in staging.",
          body:
            "This invitation prepares your Practice Team access only. It does not grant access to patient records, messages, appointments, payments, prescriptions or clinical actions.",
          proofCopy:
            "This is a proof link for founder review. No Practice Team access will be activated from this proof.",
          emailLabel: "Invited email",
          emailMissing: "No invited email was attached to this link.",
          cta: "Continue to sign in",
          proofCta: "Return to Practice Team",
        },
        roles: {
          practiceAssistant: {
            label: "Practice Assistant",
            description:
              "Helps with day-to-day patient and appointment administration.",
          },
          receptionist: {
            label: "Receptionist",
            description:
              "Includes Practice Assistant permissions, plus bookings, appointment coordination and patient communication.",
          },
          practiceManager: {
            label: "Practice Manager",
            description:
              "Includes Receptionist permissions, plus wider practice operations and administrative follow-up.",
          },
          billingAdministrator: {
            label: "Billing Administrator",
            description:
              "Includes relevant administration permissions, plus payment follow-up and billing administration.",
          },
        },
      },
      verificationTrust: {
        reassurance:
          "AfriMed™ uses Supabase infrastructure with TLS encryption in transit and AES-256 encryption at rest. Supabase maintains SOC 2 Type 2 and ISO 27001 controls. Your information remains pending until AfriMed™ completes protected verification review.",
      },
      specialtyEdit: {
        title: "Specialty",
        subtitle: "Search or add your specialty if it is not listed.",
        search: "Search or add",
        clearSearch: "Clear search",
        addSpecialty: "Add specialty",
        empty: "No matches. Tap + to add “{query}”.",
        updated: "Specialty updated",
        saveFailed: "Could not save changes. Please try again.",
        catalogHidden:
          "Specialty catalogue is not available right now. You can still add your specialty manually.",
      },
      loginSecurity: {
        password: {
          label: "Password",
          aria: "Change password",
        },
        passcode: {
          label: "Passcode",
          aria: "Change passcode",
        },
        twoFactor: {
          label: "Two factor authentication",
          aria: "Two factor authentication",
          comingSoon: "Coming soon",
        },
      },
      twoFactor: {
        title: "Two-factor authentication",
        intro: "Add an extra layer of security to your AfriMed™ account.",
        stagingNotice:
          "Two-factor authentication is coming soon and is not active in this staging build yet.",
        sms: {
          title: "Text message",
          support:
            "Use your verified mobile phone to receive a text message with an authentication code for AfriMed™.",
          loadingStatus: "Loading SMS status...",
          enabled: "SMS codes are enabled.",
          enabledForPhone: "SMS codes are enabled for {phone}.",
          needsVerifiedPhone:
            "Add and verify your phone number before enabling SMS 2FA.",
          setupAction: "Set up",
          setupTitle: "Set up SMS",
          setupHeading: "Secure your account with SMS",
          setupIntro:
            "We will send a 6-digit code to your verified phone number.",
          verifiedPhoneLabel: "Verified phone",
          noVerifiedPhone: "No verified phone on file",
          needsVerifiedPhoneSetup:
            "SMS 2FA needs a verified phone number before it can be enabled.",
          sendCode: "Send code",
          codeLabel: "6-digit code",
          enterCodePrefix: "Enter the code sent to",
          verifyAndEnable: "Verify and enable",
          resendCode: "Resend code",
        },
        flow: {
          noVerifiedPhone: "No verified phone on file",
          enterSixDigitCode: "Enter the 6-digit code.",
          authAppComingSoon: "Authenticator app setup is coming soon.",
          codeCopied: "Code copied",
          setupKeyCopied: "Setup key copied",
          copyFailed: "Copy failed. You can use the manual key above.",
          welcomeBack: "Welcome back!",
          welcomeCopy:
            "Once enabled, AfriMed™ will use this number to verify your identity during secure access flows.",
          authAppWelcomeCopy:
            "Once enabled, AfriMed™ will use this app to verify your identity during secure access flows.",
          verifyWith: "Enable two-factor protection with",
          smsLabel: "SMS",
          googleAuthenticator: "Google Authenticator",
          authAppValue: "You'll find the code in the app",
          comingSoon: "Coming soon",
          deviceRegistrationComing: "Register new device is coming soon.",
          registerNewDevice: "Register new device",
          authAppStartOver: "Start over",
          authAppStartOverCopy:
            "This will discard the unfinished authenticator setup and create a new setup key.",
          sentCodePrefix: "We've sent a verification code to",
          checkMessagingApp: "Please check your messaging app.",
          resendCodeIn: "Resend code in",
          sentNewCode: "We've sent a new code.",
          setUpGoogleAuthenticator: "Set Up Google Authenticator",
          scanQrCode: "Scan QR code",
          scanQrCopy:
            "Scan the QR code above with an authenticator app on your separate device, or tap \"Can't scan QR code\" to reveal the manual key below.",
          cantScanQrCode: "Can't scan QR code",
          code: "Code",
          setupKey: "Setup key",
          manualKeyNoSpaces:
            "Copy and paste this key without spaces if your authenticator app asks for a setup key.",
          issuer: "Issuer",
          account: "Account",
          copy: "Copy",
          successTitle: "You're in!",
          successCopy: "You've successfully secured your AfriMed™ account.",
        },
        authApp: {
          title: "Authentication app",
          support:
            "Once enabled, AfriMed™ will use this app to verify your identity during secure access flows.",
        },
        errors: {
          loadSettings: "Could not load two-factor settings.",
          loadPhone: "Could not load your verified phone.",
          sendCode: "Could not send the SMS code.",
          verifyCode: "We couldn't verify that code.",
          authAppChallengeExpired:
            "That verification challenge expired. Enter the latest 6-digit code and try again.",
          authAppFactorMissing:
            "This authenticator setup is no longer available. Start over to create a new setup key.",
          authAppSave:
            "Authenticator verified, but we couldn't update your security settings. Please try again.",
          authAppVerifyUnexpected:
            "We couldn't finish authenticator verification. Please try again.",
          authAppUnfinishedSetup:
            "An authenticator setup is already in progress. You can start over to create a new setup key.",
          authAppFinishCurrentSetup:
            "Finish this authenticator setup first. We won't remove it automatically.",
          authAppResetFailed:
            "We couldn't reset the unfinished authenticator setup. Please contact support if you need it reset.",
        },
      },
      preferences: {
        title: "Preferences",
        sections: {
          app: "App",
          account: "Account",
        },
        appearance: {
          title: "Appearance",
          subtitle: "Use system theme, light or dark",
        },
        language: {
          title: "Language",
        },
        news: {
          title: "News & updates",
          subtitle: "Email & Push preferences",
        },
        notifications: {
          title: "Notifications",
          subtitle: "News, updates & local regulations",
        },
        notificationInbox: {
          title: "Notification inbox",
          subtitle: "Urgent, unread & appointment updates",
        },
        accessibility: {
          title: "Accessibility & Fola",
          subtitle: "Assistive options and AI support",
        },
        plans: {
          title: "Plans & Subscriptions",
          subtitle: "Your AfriMedTM plan and add-ons",
        },
        transactions: {
          title: "Transactions & invoices",
          subtitle: "View history and download receipts",
        },
        downloads: {
          title: "Downloads",
          subtitle: "Export data, reports and summaries",
        },
        closeAccount: {
          title: "Close, Pause or Delete Account",
          subtitle: "We will guide you through safer options first",
        },
      },
      language: {
        title: "Language",
        changedTo: "Language changed to {language}",
      },
      edit: {
        common: {
          saveFailed: "Could not save changes. Please try again.",
          sessionNotReady: "Your session isn't ready yet. Please try again.",
        },
        name: {
          title: "Edit Name",
          subtitle:
            "Make sure this matches the name on your official government issued ID. Select the correct title to be addressed by.",
          salutationLabel: "Title",
          salutationPlaceholder: "Dr.",
          firstLabel: "First name on ID",
          firstPlaceholder: "First name/s on ID",
          lastLabel: "Family name on ID",
          lastPlaceholder: "Family name/s on ID",
          clearFirst: "Clear first name",
          clearLast: "Clear family name",
          updated: "Name updated",
        },
        phone: {
          title: "Edit your phone number",
          subtitle: "Add your phone number so we can contact you when needed",
          invalidPhone: "Please enter a valid phone number first.",
          mustAccept: "Please accept the terms first.",
          invalidPhoneLength: "Please enter a valid phone number (7-12 digits).",
          timeout: "Saving is taking too long. Please tap Save again.",
          saveFailed: "We couldn't save the phone number. Please try again.",
          updated: "Phone number saved",
          savePhone: "Save phone",
          savedReady: "Phone number saved",
          savedReadyCopy:
            "Send a verification code to continue verifying {phone}.",
          sendCode: "Send verification code",
          verified: "This phone number is already verified.",
          verifiedToast: "Phone number verified",
          codeSent: "Verification code sent",
          enterCode: "Enter verification code",
          codeSentTo:
            "We sent a 6-digit code to {phone}. It expires in 5 minutes.",
          verify: "Verify",
          verifying: "Verifying...",
          resend: "Resend",
          sending: "Sending...",
          sendFailed:
            "We couldn't send a verification code. Please try again.",
          invalidCode:
            "That code didn't verify. Please check it and try again.",
          rateLimited: "Please wait before requesting another code.",
          termsLead:
            "By checking this box, I confirm that I have read and agree to the",
          termsLink: "Terms of Service",
          termsJoiner: "and",
          privacyLink: "Privacy Policy",
          termsEnd: ".",
          verifyLater: "",
        },
        dob: {
          title: "Edit date of birth",
          subtitle:
            "Make sure this matches your date of birth on your government issued ID.",
          label: "Date of birth",
          placeholder: "DD MMM, YYYY",
          updated: "Date of birth updated",
        },
        about: {
          title: "About you",
          subtitle: "Introduce yourself to your patients",
          label: "About you",
          placeholder:
            "Tell patients a bit about your background, experience and approach.",
          counter: "{count}/{max} characters",
          minimum: "Minimum {min} characters required",
          updated: "About section updated",
          folaTitle: "Can I help you write a professional biography today?",
          folaLoading: "Analysing your credentials...",
          folaApply: "Apply Fola's Draft",
        },
        organDonor: {
          title: "Organ donor",
          subtitle:
            "Choose whether you are registered as an organ donor. You can change this preference anytime and discuss it with your doctor.",
          discardTitle: "Discard changes?",
          discardBody:
            "You have unsaved organ donor preference changes. Are you sure you want to close without saving?",
        },
        email: {
          title: "Edit your Email",
          subtitleLink: "We'll send a verification link to confirm this email.",
          subtitleCode: "We'll send a 6-digit code to confirm this email.",
          label: "Email",
          placeholder: "you@example.com",
          verified: "This email is already verified.",
          enterEmail: "Enter an email address.",
          invalidEmail: "Enter a valid email address.",
          sendFailed: "We couldn't send the email. Please try again.",
          linkSent: "We sent a verification link to {email}",
          checkInbox: "Check your email and open the verification link we sent to",
          sendVerificationLink: "Send verification link",
          sending: "Sending...",
          checking: "Checking...",
          verifiedAction: "I've verified",
          updated: "Email verified",
          notVerifiedYet:
            "Not verified yet. Please open the link in your email, then try again.",
          notAuthenticated: "Not authenticated. Please log in again.",
          sendCodeFailed: "We couldn't send the code. Please try again.",
          forbidden: "Forbidden (server policy). We need to fix the backend rule.",
          enterCode: "Enter the 6-digit code.",
          codeExpired: "This code has expired. Please resend a new one.",
          incorrectCode: "Incorrect code. Please try again.",
          verifyFailed: "Verification failed. Please try again.",
          stillSending: "Still sending...",
          waitBeforeResend: "Please wait {seconds}s before resending.",
          sendDisabled: "Send is currently disabled.",
          resendIn: "Resend in {seconds}s",
          sendCode: "Send code",
          enterSentCode: "Enter the 6-digit code sent to",
          codeLabel: "Verification code",
          codePlaceholder: "123456",
          verifying: "Verifying...",
          verify: "Verify",
        },
        address: {
          title: "Edit Address",
          subtitle: "Make sure you enter your address correctly.",
          locationUnavailable: "Location is not available in this browser.",
          lookupFailed:
            "Location found, but address lookup failed. You can edit manually.",
          permissionDenied:
            "Location permission denied. Enable location access to quick fill.",
          locationTimeout: "Location request timed out. Please try again.",
          locationFailed: "Could not get your location.",
          signInRequired: "Please sign in to save your address.",
          saveFailed: "We couldn't save your address. Please try again.",
          locating: "Locating...",
          useCurrentLocation: "Use my current location",
          line1Label: "Address",
          line1Placeholder: "Number, Street",
          line2Label: "Address (line 2)",
          line2Placeholder: "City, Suburb",
          postalLabel: "Postal code",
          postalPlaceholder: "Post code",
          countryLabel: "Country",
          quickFillTitle: "Fill address automatically?",
          quickFillBodyPatient:
            "We can use your current location to quickly fill in your home address so you don't have to type it manually.",
          quickFillBodyDoctor:
            "We can use your current location to quickly fill in your address and show facilities near you.",
          quickFillAction: "Yes, quick fill",
          locationNameLabel: "Location name",
          locationNamePlaceholder: "Start typing facility name...",
          buildingTypeLabel: "Building type",
          buildingTypePlaceholder: "Hospital",
          doctorLine1Placeholder: "Seogoditshane Way, 5th floor, 507",
          cityLabel: "City",
          cityPlaceholder: "Gaborone",
          buildingTypeDescription:
            "Choose the building type that describes best your location.",
          addBuildingTypeLabel: "Add building type",
          addBuildingTypePlaceholder: "e.g. Diagnostic lab",
          permissionsBlocked:
            "Consultancy address cannot be updated right now due to permissions. Data was not saved to the database.",
        },
        idPassport: {
          submitted: "ID / Passport submitted for verification",
          signInRequired: "You need to be signed in.",
          statusReadFailed: "Could not read verification status.",
          awaitingReview: "Document received. Awaiting review.",
        },
        registrationUpload: {
          title: "Registration document",
          subtitle: "Upload a clear copy of your council registration",
          securityReassurance:
            "AfriMed™ uses Supabase infrastructure with TLS encryption in transit and AES-256 encryption at rest. Supabase maintains SOC 2 Type 2 and ISO 27001 controls. Your upload remains pending until AfriMed™ completes verification review.",
          addTitle: "Add your Registration Document",
          addAction: "Add",
          changeFile: "Change file",
          addMore: "Add more",
          existingNotice:
            "Existing registration document on file from {date}. Upload a new one to replace it.",
          status: {
            done: "Registration Recognised",
            failed: "Verification Failed",
          },
          saveOcrFailed: "Could not save OCR results.",
          analysisFailed: "Document analysis failed. Please try another file.",
          statusReadFailed: "Could not read verification status.",
          summary: {
            registrationNumber: "Registration No.",
            practitionerName: "Full Name (Practitioner)",
            specialty: "Specialty / Category",
            practitionerFallback: "Practitioner",
          },
          retention: "Stored until {date}.",
          consent:
            "By uploading, you consent to AfriMed™ storing this document in protected verification storage for review. It will be retained for up to 90 days.",
          alt: {
            verified: "Verified",
            documentPreview: "Registration document preview",
          },
        },
        registrationDetails: {
          title: "Registration details",
          subtitle: "Keep your registration information up to date.",
          signInRequired: "You need to be signed in.",
          saveFailed: "Could not save registration details.",
          savedPending: "Changes saved (pending verification)",
          expiryPast:
            "Expiry date can't be in the past. Please choose today or a future date.",
          yearsRange: "Enter a value from 1 to 60.",
          suggestions: {
            other: "Other",
          },
          fields: {
            number: {
              label: "Registration number",
              placeholder: "e.g. BMD 12345",
            },
            issuer: {
              label: "Issuing Authority",
              placeholder: "Select or type issuer",
            },
            issueDate: {
              label: "Issue Date",
            },
            expiryDate: {
              label: "Expiry Date",
            },
            datePlaceholder: "DD MMM, YYYY",
            yearsExperience: {
              label: "Years of experience",
              placeholder: "e.g. 12",
            },
          },
        },
      },
    },
    messages: {
      loadingConversation: "Loading conversation...",
      noMessagesYet: "No messages yet.",
      writeMessage: "Write a message...",
      composeModal: {
        title: "New Conversation",
        addParticipants: "Add Participants",
        close: "Close",
        types: {
          doctorPatient: "Clinician-Patient",
          doctorDoctor: "Clinician-Clinician",
          group: "Group Chat",
        },
        typeDescriptions: {
          doctorPatient:
            "Secure communication with patients for medical consultations",
          doctorDoctor:
            "Professional collaboration with fellow healthcare providers",
          group: "Multi-participant discussions for team coordination",
        },
        conversationTitle: "Conversation Title (Optional)",
        conversationTitlePlaceholder: "Enter a title for this conversation...",
        autoGenerateHint: "Leave empty to auto-generate based on participants",
        searchUsers: "Search Users",
        searchPlaceholder: "Search by name...",
        selectedParticipants: "Selected Participants ({count})",
        searchResults: "Search Results",
        unknownUserInitial: "U",
        unknownUser: "Unknown User",
        noUsersFound: "No users found",
        startTyping: "Start typing to search for users",
        back: "Back",
        cancel: "Cancel",
        nextAddParticipants: "Next: Add Participants",
        createConversation: "Create Conversation",
        chatWith: "Chat with {name}",
        groupChatMembers: "Group Chat ({count} members)",
      },
      inbox: {
        search: "Search",
        searchRecipients: "Search recipients",
        clearSearch: "Clear search",
        openFola: "Open Fola conversation",
        newMessage: "New message",
        title: "Messages",
        composeTitle: "New message",
        loadingRecipientsTitle: "Loading recipients",
        loadingRecipientsBody:
          "Please wait while we load people you can message.",
        opening: "Opening...",
        new: "New",
        noRecipientsMatch: "No recipients match your search.",
        noRecipientsTitle: "No recipients yet",
        noRecipientsBody:
          "Recipients will appear here once you have an appointment or existing conversation.",
        noConversationsMatch: "No conversations match your search.",
        loadingMessagesTitle: "Loading messages",
        loadingMessagesBody:
          "Please wait while we fetch your latest conversations.",
        emptyTitle: "No messages to display",
        emptyBody: "Your inbox is currently empty. Check back later!",
        noMessagesPreview: "No messages yet.",
      },
      conversation: {
        now: "Now",
        deletedForMe: "You deleted this message",
        deletedBySender: "Sender deleted message",
        deleteDialog: {
          close: "Close delete dialog",
          title: "Delete message?",
          body:
            "Delete this message for you only, or remove it for both participants. This action cannot be undone.",
          deleting: "Deleting...",
          forMe: "Delete for me",
          forBoth: "Delete for both",
        },
        toast: {
          dismiss: "OK",
          undo: "Undo",
          deletedForMe: "Message deleted for me",
          deletedForBoth: "Message deleted for both",
          deleteError: "Could not delete the message right now.",
        },
        composer: {
          all: "All",
          attach: "Attach photo",
          send: "Send message",
          thinking: "Fola is thinking",
          selectedAttachmentAlt: "Selected attachment",
        },
        topBar: {
          back: "Back to messages",
          openFola: "Open Fola conversation",
          compose: "Compose message",
        },
      },
    },
    appointments: {
      nearby: {
        pageTitle: "Appointments",
      },
      book: {
        title: "Choose a date and time",
        doctorMissing:
          "Doctor not found. Please go back and select a doctor again.",
        backToDoctors: "Back to clinicians",
        sections: {
          service: "Select a service",
          date: "Date",
          time: "Time",
          payment: "Select your payment method",
        },
        selectDate: "Select date",
        minutesShort: "{count} min",
        loading: {
          services: "Loading doctor services...",
          dates: "Loading available dates...",
          times: "Loading available times...",
          payments: "Loading doctor payment methods...",
        },
        empty: {
          services: "This doctor has not added services yet.",
          dates: "This doctor has not opened any appointment days yet.",
          unavailableDay: "This doctor is not available on the selected day.",
          noTimes: "No available appointment times remain for this day.",
          payments: "This doctor has not set payment methods yet.",
        },
        errors: {
          loadServices: "Unable to load doctor services.",
          loadDates: "Unable to load bookable dates.",
          loadTimes: "Unable to load available times.",
          loadPayments: "Unable to load payment methods.",
        },
        confirm: "Confirm",
        fallbackServices: {
          evisit: "Virtual consultation",
          consultation: "Consultation",
        },
      },
      edit: {
        title: "Edit appointments",
        notFound: "Appointment not found. Please go back and open it again.",
        backToAppointments: "Back to appointments",
        paymentMethodFallback: "Debit / Credit cards",
        chooseFacility: "Choose a facility",
        chooseFacilityError: "Please choose a facility for an in-person appointment.",
        virtualVisitNotice: "This appointment will be a virtual visit.",
        selectDate: "Select date",
        confirm: "Confirm",
        mode: {
          inPerson: "In-person",
          eVisit: "Virtual",
        },
        sections: {
          type: "Type",
          location: "Location",
          date: "Date",
          time: "Time",
          payment: "Payment method",
        },
        loading: {
          dates: "Loading available dates...",
          times: "Loading available times...",
        },
        empty: {
          dates: "This doctor has not opened any appointment days yet.",
          unavailableDay: "This doctor is not available on the selected day.",
          noTimes: "No available appointment times remain for this day.",
        },
        errors: {
          loadDates: "Unable to load available dates.",
          loadTimes: "Unable to load available times.",
        },
      },
      editMenu: {
        change: {
          title: "Change appointment",
          subtitle: "Select a new date and time",
        },
        location: {
          title: "Change location",
          subtitle: "Choose a facility",
        },
        delete: {
          title: "Delete appointment",
          subtitle: "This will remove this appointment",
        },
        deleteDialog: {
          title: "Are you sure you want to delete this medical appointment?",
          description:
            "After deleting the medical appointment record, you will not be able to recover it.",
          confirm: "Delete",
        },
      },
      editLocation: {
        title: "Change location",
        searchPlaceholder: "Search hospitals or clinics",
        evisitSubtitle: "Switch this appointment to a virtual consultation",
        selectEvisit: "Select Virtual",
        selectFacility: "Select {name}",
        empty: "No facilities found.",
        facilityFallback: "Facility",
        errors: {
          loadCsv: "Failed to load facilities CSV",
          emptyCsv: "Facilities CSV is empty",
          load: "Failed to load facilities",
        },
      },
      confirm: {
        title: "Appointment summary",
        confirm: "Confirm",
        confirming: "Confirming...",
        newTimeRequest: "New time request",
        schedule: "Schedule",
        patientFallback: "Patient",
        doctorFallback: "Doctor",
        serviceFallback: "Consultation",
        firstConsultancy: "First time consultancy",
        videoConsultation: "Video consultation",
        facilityFallback: "Life Gaborone Private Hospital",
        inPersonLower: "in-person",
        payment: {
          credit: "Credit / Debit cards",
          bank: "Bank transfers",
          cash: "Cash on service",
          eft: "Instant EFT",
          wallet: "E-wallets",
          fallback: "Payment method",
        },
        fields: {
          doctor: "Clinician",
          service: "Service",
          date: "Date",
          time: "Time",
          amountPaid: "Amount paid",
        },
        errors: {
          invalidDateTime: "Invalid appointment date/time.",
          createFailed: "Failed to create appointment.",
          confirm: "Unable to confirm appointment. Please try again.",
          update: "Unable to update appointment.",
        },
        notifications: {
          selectedTime: "the selected time",
          newAppointmentTitle: "New appointment",
          newAppointmentMessage: "{name} requested an appointment, on {datetime}.",
          newTimeRequestTitle: "New time request",
          appointmentUpdateTitle: "Appointment update",
          appointmentUpdateMessage:
            "Your doctor proposed a new appointment time. Review and confirm the change.",
          modeChangeLead: "requested to change from",
          modeChangeTo: "to",
          newTimeLead: "requested a new appointment time.",
          pendingApproval: "Pending for approval.",
        },
      },
      details: {
        title: "Appointment details",
        loading: "Loading appointment...",
        notFound: "Appointment not found. Please go back and open it again.",
        backToAppointments: "Back to appointments",
        visitType: {
          evisit: "Virtual",
        },
        meetLabel: "AfriMed™ video",
        videoRoomLabel: "Secure AfriMed™ consultation room",
        join: "Join",
        message: "Message",
        call: "Call",
        ehr: {
          granted: "Access granted",
          grant: "Grant access",
          granting: "Granting...",
        },
        sections: {
          time: "Appointment time",
          payment: "Payment method",
        },
        cancelVisit: "Cancel visit",
        editVisit: "Edit visit",
        cancelDialog: {
          title: "Cancel appointment?",
          description: "Are you sure you want to cancel this appointment?",
          confirm: "Yes, cancel",
        },
        deleteDialog: {
          title: "Are you sure you want to delete this medical appointment?",
          description:
            "After deleting the medical appointment record, you will not be able to recover it.",
          confirm: "Delete",
        },
        toast: {
          rescheduleRequested: "New time request sent. Pending for approval.",
          confirmed: "Appointment confirmed",
          updated: "Appointment updated",
          deleted: "Your appointment was deleted",
          ehrGranted: "EHR access granted",
        },
        errors: {
          load: "Unable to load appointment.",
          ehrMissing: "Missing appointment details for EHR access.",
          verifyAccount: "Could not verify your account.",
          ehrGrant: "Could not grant EHR access right now.",
          cancel: "Unable to cancel appointment.",
        },
      },
      call: {
        loading: "Loading consultation...",
        phase: {
          connecting: "Connecting...",
          ringing: "Ringing...",
          reconnecting: "Reconnecting...",
        },
        controls: {
          shrink: "Shrink",
          switchCamera: "Switch camera",
          maximize: "Maximize",
          more: "More",
          join: "Join",
          speaker: "Speaker",
          mic: "Mic",
          end: "End",
        },
        toast: {
          linkUnavailable: "Consultation link not available yet.",
          copyUnavailable: "Clipboard is not available on this device.",
          copyFailed: "Unable to copy the consultation link.",
          openedMeet: "Google Meet opened in a new tab.",
          speakerReady: "Speaker ready.",
          speakerMuted: "Speaker muted for preview.",
          micReady: "Microphone ready.",
          micMuted: "Microphone muted.",
          fullscreenDesktop: "Fullscreen is available on desktop.",
          fullscreenUnavailable: "Fullscreen is not available here.",
          returnAfterMeet: "Return here after your Google Meet session.",
          switchCameraVideoOnly: "Switch camera is available in video consultations.",
          linkCopied: "Consultation link copied.",
        },
        sheet: {
          title: "Call options",
          openMeet: "Open Google Meet",
          openMeetDescription: "Join this consultation in a secure Meet tab.",
          copyLink: "Copy consultation link",
          copyLinkDescription: "Copy the appointment Meet link.",
          speakerPreference: "Speaker preference",
          speakerDescriptionOn: "Mute the speaker preview state.",
          speakerDescriptionOff: "Enable the speaker preview state.",
          micPreference: "Microphone preference",
          micDescriptionOn: "Mute the microphone preview state.",
          micDescriptionOff: "Enable the microphone preview state.",
          fullscreen: "Fullscreen",
          fullscreenDescription: "Expand this consultation surface on desktop.",
        },
      },
      video: {
        sheet: {
          title: "Consultation options",
          cameraPreview: "Camera preview",
          cameraPreviewOn: "Turn your camera preview off.",
          cameraPreviewOff: "Turn your camera preview on.",
          switchCameraDescription: "Swap between available front and rear cameras.",
        },
        toast: {
          previewUnavailable: "Camera preview is not available on this device.",
          cameraOptional: "Camera access is optional until you join Google Meet.",
          cameraReady: "Camera ready.",
          cameraOff: "Camera off.",
          switchUnavailable: "Switch camera is not available on this device.",
          singleCamera: "Only one camera is available.",
          cameraSwitched: "Camera switched.",
          switchFailed: "Unable to switch camera.",
        },
      },
      summary: {
        title: "Consultation complete",
        subtitle: "Appointment #{id}",
        patientFallback: "Patient",
        doctorFallback: "Doctor",
        finishedWith: "You just finished your appointment with",
        endedAt: "Ended: {datetime}",
        vitalRepStatus: "VitalRep™ status",
        status: {
          readyTitle: "Notes ready",
          updatingTitle: "Updating EHR...",
          generatingTitle: "Generating notes...",
          readyBodyDoctor: "Your consultation notes are ready. You can now review the patient EHR.",
          readyBodyPatient: "Your consultation notes are ready. You can now view your EHR update.",
          updatingBodyDoctor: "Notes completed. We’re now updating the patient EHR.",
          updatingBodyPatient: "Notes completed. We’re now updating your EHR.",
          generatingBody: "This can take a moment. You can continue; we’ll update this status.",
        },
        steps: {
          ended: "Call ended",
          notes: "VitalRep™ notes generating",
          ehr: "EHR updated",
          prescription: "Prescription ready",
        },
        actions: {
          viewPatientEhr: "View patient EHR",
          viewEhrUpdate: "View EHR update",
          backToAppointments: "Back to Appointments",
          opening: "Opening...",
          prescription: "Prescription",
          viewPrescription: "View prescription",
          goHome: "Go home",
        },
        errors: {
          prescriptionUnavailable: "Prescription not yet available for this appointment.",
          openPrescription: "Unable to open prescription right now.",
        },
      },
      success: {
        confirmationTitle: "Appointment confirmation",
        title: "Appointment completed",
        body: "Your booking has been created. You can open it from your appointments now.",
      },
      past: {
        common: {
          doctorFallback: "Doctor",
          unknownValue: "—",
          unknownDate: "—",
          monthFallback: "Month {year}",
        },
        list: {
          title: "Past appointments",
          searchPlaceholder: "Search",
          clearSearch: "Clear",
          loading: "Loading...",
          empty: "No past appointments found.",
          tabs: {
            upcoming: "Upcoming ({count})",
            past: "Past ({count})",
            pending: "Pending for approval ({count})",
          },
        },
        details: {
          title: "Past appointments",
          loading: "Loading past appointment...",
          notFound: "Past appointment not found.",
          descriptionFallback: "No diagnosis or notes were added for this appointment.",
          videoConsultation: "Video consultation",
          locationFallback: "Consultation location",
          paymentFallback: "Debit / Credit cards",
          bookAgain: "Book again",
          mode: {
            inPerson: "In-person",
            virtual: "Virtual",
          },
          sections: {
            time: "Appointment time",
            description: "Appointment description",
            payment: "Payment method",
          },
        },
      },
      doctorIndex: {
        defaultFacilityName: "Primary facility not set",
        patientFallback: "Patient",
        errorLoad: "Unable to load appointments.",
        loading: "Loading appointments...",
        emptyTitle: "No appointments to display",
        emptyBody: "Your inbox is currently empty. Check back later!",
        selectDay: "Select day {day}",
        viewMode: {
          label: "View mode",
          day: "Day",
          week: "Week",
          month: "Month",
          list: "List",
        },
        list: {
          freeSchedule: "Free schedule",
          allDay: "All day",
        },
        snackbar: {
          rescheduled:
            "The appointment was moved to {date}. Pending for patient acceptance.",
          review: "Review",
          cancelled: "Appointment cancelled",
        },
      },
      directory: {
        common: {
          filter: "Filter",
          loading: "Loading...",
          centerMap: "Center map",
        },
        hospitals: {
          search: "Search hospitals",
          nearby: "Nearby",
          empty: "No hospitals found.",
          favoriteAria: "Favourite hospital",
        },
        pharmacies: {
          title: "Pharmacies",
          subtitle: "Pharmacies near you",
          search: "Search pharmacies",
          empty: "No pharmacies found.",
          favoriteAria: "Favourite pharmacy",
          filter: {
            data: "Data",
            payment: "Payment methods",
            apply: "Apply",
            options: {
              "best-rating": "Best rating",
              "near-you": "Near you",
              cards: "Credit & Debit cards",
              "bank-transfer": "Bank transfers",
              ewallet: "E-wallets",
              "instant-eft": "Instant EFT",
            },
          },
        },
        ambulances: {
          title: "Ambulance",
          subtitle: "Ambulances near you",
          favoriteAria: "Favourite ambulance",
          filter: {
            data: "Data",
            payment: "Payment methods",
            apply: "Apply",
            options: {
              "best-rating": "Best rating",
              "near-you": "Near you",
              cards: "Credit & Debit cards",
              "bank-transfer": "Bank transfers",
              ewallet: "E-wallets",
              "instant-eft": "Instant EFT",
            },
          },
        },
      },
    },
    helpSupport: {
      title: "Help & support",
      eyebrow: "Help Centre support",
      subtitle:
        "Get help with your AfriMed™ account, appointments, messages, prescriptions, payments, and access.",
      loading: "Loading support requests...",
      common: {
        recently: "Recently",
      },
      auth: {
        title: "Authentication required",
        body: "Please sign in to access help and support.",
        signIn: "Sign in",
      },
      actions: {
        back: "Back",
        newRequest: "New support request",
        closeRequest: "Close request form",
        browseHelpCentre: "Browse Help Centre",
        browseKnowledgeBase: "Browse Help Centre",
        supportPending: "Support access pending",
        supportPendingTitle: "Support requests are not enabled for this account yet.",
      },
      stats: {
        total: "Total tickets",
        open: "Open",
        inProgress: "In progress",
        resolved: "Resolved",
        closed: "Closed",
      },
      contact: {
        title: "Contact AfriMed™ support",
        address: "AfriMed™ Telehealth, Cape Town, South Africa",
      },
      quickLinks: {
        title: "Help Centre links",
        helpCentre: "Help Centre",
        knowledgeBase: "Help Centre",
        gettingStarted: "Getting started",
        technicalSupport: "Technical support",
        technicalAssistance: "Technical support",
        messagesFola: "Messages & Fola",
      },
      filters: {
        searchPlaceholder: "Search requests",
        all: "All requests",
        open: "Open",
        inProgress: "In progress",
        resolved: "Resolved",
        closed: "Closed",
      },
      empty: {
        title: "No support requests yet.",
        filteredTitle: "No matching requests",
        filtered: "No requests match your current search or filter.",
        default: "You can create one when support access is available.",
      },
      errors: {
        permission:
          "Support requests are still being enabled for this account. You can continue using Help Centre guidance while we complete access.",
        loadData: "Failed to load support data.",
        loadInformation: "Failed to load support information.",
        requiredFields: "Please fill in all required fields.",
        createTicket: "Failed to create support request.",
      },
      accessPending: {
        title: "Support access pending",
      },
      notice: {
        title: "Support notice",
      },
      supportOptions: {
        title: "What do you need help with?",
        description:
          "Choose the area closest to your issue. AfriMed™ support helps with access, records, appointments, payments, and technical questions.",
      },
      categories: {
        account: {
          title: "Account access",
          description:
            "For login, OTP, password, email, or phone verification issues.",
        },
        appointments: {
          title: "Appointments",
          description:
            "For booking, changing, video visit, clinician, or dependant appointment support.",
        },
        ehr: {
          title: "Prescriptions & myEHR",
          description:
            "For prescription access, health record visibility, verification, or download questions.",
        },
        payments: {
          title: "Payments & insurance",
          description:
            "For payment method, sponsor link, receipt, invoice, or insurance-selection questions.",
        },
        messages: {
          title: "Messages & Fola",
          description:
            "For message threads, Fola support, language support, and what Fola can or cannot do.",
        },
        technical: {
          title: "Technical support",
          description:
            "For browser, device, notification, upload, or display issues.",
        },
      },
      escalation: {
        title: "Still need help?",
        body:
          "If the guidance does not solve the issue, send AfriMed™ support a request. We’ll review it as soon as support access is enabled for your account.",
      },
      requests: {
        title: "Your support requests",
        description:
          "Requests appear here after support access is available and a request has been created.",
      },
      safety: {
        body:
          "Fola does not replace clinicians. Emergency or urgent clinical symptoms should use emergency services or clinician contact, not support requests.",
      },
      ticket: {
        createTitle: "New support request",
        createBody:
          "Tell us what is blocking you and we’ll route it to the right team.",
        creating: "Creating...",
        createAction: "Create support request",
        issueType: "Type of issue",
        priority: "Priority",
        subject: "Subject",
        subjectPlaceholder: "Briefly describe the issue",
        description: "Description",
        descriptionPlaceholder:
          "Share what you tried, what you expected, and what you are seeing now.",
        safetyNote:
          "For urgent clinical symptoms, contact emergency services or your clinician directly. Support requests are for access, records, appointments, payments, and technical issues.",
        created: "Created {date}",
        updated: "Updated {date}",
        messages: "{count} messages",
        priorityLabel: "{priority} priority",
        status: {
          open: "Open",
          in_progress: "In progress",
          resolved: "Resolved",
          closed: "Closed",
        },
        types: {
          technical_issue: { label: "Technical Issue" },
          billing_inquiry: { label: "Billing Inquiry" },
          account_access: { label: "Account Access" },
          consultation_support: { label: "Consultation Support" },
          general_inquiry: { label: "General Inquiry" },
          feature_request: { label: "Feature Request" },
        },
        priorities: {
          low: { label: "Low" },
          medium: { label: "Medium" },
          high: { label: "High" },
          urgent: { label: "Urgent" },
        },
      },
    },
    regionalHealth: {
      title: "Regional health",
      loading: "Loading regional feed...",
      newAlert: "New Alert",
      diseaseFallback: "Coronavirus",
      actions: {
        resetView: "Reset view",
      },
      source: {
        live: "Live regional feed",
        demo: "Demo regional feed",
      },
      metrics: {
        patients: "{count} patients",
        patientsTitle: "{count} Patients",
        update: "Update",
      },
      errors: {
        mapTokenMissing: "Map token missing",
      },
      status: {
        good: "Good",
        acceptable: "Acceptable",
        caution: "Caution",
        critical: "Critical",
      },
      updated: {
        today: "Today",
        yesterday: "Yesterday",
      },
    },
    knowledgeBase: {
      title: "Knowledge base",
      loading: "Loading knowledge base...",
      hero: {
        title: "AfriMed™ Knowledge Base",
        subtitle:
          "Find clear guides for onboarding, appointments, virtual consultations, payments, records, and everyday AfriMed™ workflows.",
      },
      common: {
        recently: "Recently",
        general: "General",
        featured: "Featured",
        noExcerpt: "Open this article to read the full guide.",
      },
      actions: {
        back: "Back",
        clear: "Clear filters",
        clearSearch: "Clear search",
        reset: "Reset",
        tryAgain: "Try again",
        openArticle: "Open article",
        showFeatured: "Show featured guides",
        backToKnowledgeBase: "Back to knowledge base",
      },
      search: {
        placeholder: "Search AfriMed help articles",
        submit: "Search",
        searching: "Searching...",
      },
      categories: {
        title: "Categories",
        count: "{count} articles",
      },
      view: {
        title: "View",
        grid: "Grid",
        list: "List",
      },
      tips: {
        title: "Find answers faster",
        body:
          "Search with simple task phrases like “book a virtual consultation”, “change appointment”, or “patient records”.",
      },
      results: {
        search: 'Search results for "{query}"',
        category: "{category} guides",
        featured: "Featured guides",
        count: "{count} articles found",
        filteredHint: "Showing articles for your current search or category.",
      },
      metrics: {
        views: "{count} views",
        helpful: "{count} helpful",
      },
      empty: {
        title: "No articles found",
        filtered: "Try a broader search term or switch to another category.",
        default:
          "Knowledge base articles will appear here as soon as content is published.",
      },
      errors: {
        title: "Unable to load articles",
        permission:
          "Knowledge base content is being prepared for this account. We’re keeping the experience available while access is completed.",
        loadContent: "Failed to load knowledge base content.",
        search: "Search failed. Please try again.",
        loadArticle: "Failed to load article.",
      },
      article: {
        loading: "Loading article...",
        unavailable: "Article unavailable",
        notFound: "Article not found.",
        authorFallback: "AfriMed™ Team",
        voteFailed: "We couldn’t save your feedback.",
        tags: "Tags",
        feedbackTitle: "Was this article helpful?",
        feedbackBody:
          "Your feedback helps us improve AfriMed™ guidance for everyone.",
        helpfulYes: "Yes",
        helpfulNo: "No",
        shareTitle: "Share this guide",
        shareBody:
          "Copy or share this article when a patient, doctor, or teammate needs the same answer.",
        shareAction: "Share article",
        related: "Related articles",
        linkCopied: "Article link copied.",
        linkCopyFailed: "Unable to share this link.",
      },
    },
    onboarding: {
      category: {
        continue: "Continue",
        options: {
          doctor: {
            title: "Clinician",
            desc: "Join as a licensed physician, psychiatrist, nurse practitioner, physician assistant, or other qualified healthcare professional and provide expert care on AfriMed™.",
          },
          patient: {
            title: "Patient",
            desc: "Sign up to access trusted clinicians, your electronic records and electronic prescriptions.",
          },
          research: {
            title: "Research • Public health",
            desc: "Join as a researcher, public-health professional, community health worker, programme staff or field team member to support governed research and population-health programmes on AfriMed™.",
          },
          employer: {
            title: "Employer",
            desc: "Give your employees access to quality healthcare. A healthy workforce powers a healthy organisation.",
          },
          moh: {
            title: "Ministry of Health",
            desc: "Advance Universal Health Coverage by onboarding citizens on AfriMed™.",
          },
        },
      },
      email: {
        title: "Email",
        subtitle:
          "Enter your email correctly to receive updates and notifications.",
        placeholder: "Email",
        continue: "Continue",
      },
      emailEdit: {
        title: "Your Email address",
        subtitle:
          "We'll use this email for updates and notifications, only when necessary. If you need to change it later, you can do so in Settings.",
        saveContinue: "Save & continue",
        label: "Email",
        placeholder: "you@example.com",
        verified: "Verified",
      },
      name: {
        title: "Your full names",
        subtitle:
          "Make sure this matches the name on your official government issued ID. Select the correct title to be addressed by.",
        saving: "Saving...",
        continue: "Continue",
        salutationLabel: "Title",
        salutationPlaceholder: "Dr.",
        firstLabel: "First Name",
        firstPlaceholder: "First Name/s on ID",
        lastLabel: "Family name on ID",
        lastPlaceholder: "Family Name/s on ID",
        clearFirst: "Clear first name",
        clearLast: "Clear family name",
        sessionNotReady: "Your session isn't ready yet. Please try again.",
        saveError: "Could not save. Please try again.",
        saveRequest: "Save name",
      },
      phone: {
        title: "Your phone number",
        saving: "Saving...",
        continue: "Continue",
        invalidPhone: "Enter a valid phone number.",
        invalidPhoneLength: "Please enter a valid phone number (7-12 digits).",
        mustAccept: "Please accept Terms and Privacy Policy to continue.",
        termsLead:
          "By checking this box, I confirm that I have read and agree to the",
        termsLink: "Terms of Service",
        termsJoiner: "and",
        privacyLink: "Privacy Policy",
        termsEnd: ".",
      },
      otp: {
        title: "Phone verification",
        subtitle:
          "Enter the verification code from your SMS to verify your phone.",
        subtitleStaging:
          "Enter the verification code from your SMS to verify your phone.",
        enterCode: "Enter verification code",
        stagingHelper:
          "Enter the 6-digit code sent to {phone}.",
        productionHelper: "Enter the 6-digit code for {phone}.",
        addPhoneFirst: "Add your phone number before requesting a code.",
        continue: "Continue",
        verifying: "Verifying...",
        autoVerifyHint:
          "AfriMed™ verifies automatically when all 6 digits are entered.",
        phoneNumber: "Phone number",
        notProvided: "Not provided",
        missingPhone: "Add your phone number before verification.",
        sessionNotReady: "Your session isn't ready yet. Please try again.",
        sending: "Requesting code...",
        requestAccepted: "Verification request submitted.",
        requestAcceptedStaging:
          "Verification code requested. It should arrive by SMS shortly.",
        ready: "Request a verification code to continue.",
        stagingStatus: "Enter the code when it arrives, or request a new one.",
        resend: "Resend",
        resendIn: "Resend in {seconds}s",
        sendFailed:
          "We couldn't send a verification code. Please try again.",
        resendFailedStaging:
          "SMS delivery did not complete for this number. Please try again or use a supported phone route.",
        invalidCode:
          "That code didn't verify. Please check it and try again.",
        rateLimited: "Please wait before requesting another code.",
        note: "Phone verification can be completed later in Settings.",
      },
      passcodeConfirm: {
        title: "Pass code",
        subtitle: "Protect your account with a security code",
        saving: "Saving...",
        continue: "Continue",
        confirm: "Confirm passcode",
        mismatch: "Passcodes do not match. Please try again.",
        sessionExpired: "Session expired. Please log in again.",
        saveError: "Failed to save passcode",
      },
      passcodeCreate: {
        title: "Pass code",
        subtitle: "Protect your account with a security code",
        continue: "Continue",
        create: "Create passcode",
      },
      dob: {
        title: "Date of birth",
        subtitle:
          "Make sure this matches your date of birth on your government issued ID.",
        saving: "Saving...",
        continue: "Continue",
        label: "Date of birth",
        placeholder: "DD-MM-YYYY",
        done: "Done",
        saveError: "Could not save. Please try again.",
        timeout:
          "Network timeout while saving. Please try again (or switch network).",
      },
      idPassport: {
        title: "National ID • Passport",
        subtitle: "Enter your ID/Passport number or MRZ (30-char line).",
        continue: "Continue",
        verifying: "Verifying...",
        label: "ID / Passport",
        placeholder: "A12345678  ·  or MRZ line",
        done: "Done",
        invalidHint: "Use a passport number or paste a 30-character MRZ line.",
        processingTitle: "ID Processing",
        processingPending: "Analysing your document...",
        processingIdle: "Capture a photo or upload a clear scan",
        working: "Working...",
        retake: "Retake",
        camera: "Camera",
        uploadFile: "Upload File",
        aiProcessing: "AI Processing",
        sessionNotReady: "Session not ready yet. Please log in again.",
        fileTooLarge: "File too large. Please upload an image under 5MB.",
        uploading: "Uploading document...",
        receivedExtracting: "Document received. Extracting details...",
        uploadFailed: "Upload failed. Please try again.",
        retention: "Privacy: Encrypted storage expires {date}.",
        status: {
          pending: "Analysing Document...",
          done: "Identity Received",
          failed: "Processing Failed",
          received: "Document Received",
          idle: "Processing...",
        },
        alt: {
          passed: "Passed",
          failed: "Failed",
          received: "Received",
        },
        summary: {
          surname: "Surname",
          idNumber: "ID No.",
          dob: "Date of Birth",
          expiry: "Expiry Date",
          givenNames: "Given Names",
        },
      },
      specialty: {
        title: "What is your Specialty?",
        searchOrAddHint: "Search or add your specialty if it is not listed.",
        searchPlaceholder: "Search or add",
        addSpecialty: "Add specialty",
        noMatchesAdd: "No matches. Tap + to add “{query}”.",
      },
      subspecialty: {
        title: "What is your Subspecialty?",
        searchOrAddHint: "Search or add your specialty if it is not listed.",
        searchPlaceholder: "Search or add",
        addSubspecialty: "Add sub-specialty",
        noMatchesAdd: "No matches. Tap + to add “{query}”.",
      },
      languages: {
        title: "Add languages",
        searchPlaceholder: "Search or add",
        clearSearch: "Clear search",
        addLanguage: "Add language",
        helper: "Select as many as you speak.",
        noMatches: "No languages match your search.",
        continue: "Continue",
        saving: "Saving...",
        sessionExpired: "Session expired",
        saveError: "Could not save languages",
      },
    },
    doctors: {
      appointmentDetails: {
        title: "Appointment details",
        loading: "Loading appointment details...",
        notFound: "Appointment not found. Please go back and open it again.",
        backToAppointments: "Back to appointments",
        patientFallback: "Patient",
        doctorFallback: "Doctor",
        yearsOld: "{count} Years old",
        facilityFallback: "Life Gaborone Private Hospital",
        firstAppointment: "First appointment",
        diagnosisTitleFallback: "Diagnosis & Notes",
        meetPending: "Secure AfriMed™ consultation room",
        eVisit: "E-Kuonana",
        notesEmpty: "No notes yet.",
        photosEmpty: "No patient photos shared yet.",
        notesPlaceholder: "Add notes...",
        notesAutosave: "Notes auto-save when you leave this field.",
        status: {
          pending: "Pending",
          scheduled: "Scheduled",
          inProgress: "In progress",
          completed: "Completed",
          cancelled: "Cancelled",
          confirmed: "Confirmed",
        },
        startsIn: {
          default: "Starts in 1 hour",
          minutes: "Starts in {count} min",
          hours: "Starts in {count} hour{suffix}",
        },
        sections: {
          diagnosis: "Diagnosis",
          prescription: "Prescription",
          testsAndLabs: "Tests & Lab results",
          testsAndDocuments: "Tests & Documents",
          notes: "Notes",
          photos: "Patient Photos",
          ehr: "EHR",
          support: "Support and reschedule",
        },
        fields: {
          bloodType: "Blood type",
          allergies: "Allergies",
          chronicConditions: "Chronic Conditions",
          organDonor: "Organ Donor",
        },
        requestEhr: {
          title: "Request EHR",
          body: "Provide better care by accessing your patient Electronic Health Record",
        },
        ehr: {
          accessGranted: "Access granted",
          accessRequested: "Access requested",
        },
        about: {
          title: "About {name}",
          rating: "{count} rating",
          noRatingYet: "No rating yet",
          joinedRecently: "Joined AfriMed recently",
          joined: "Joined AfriMed",
        },
        actions: {
          profile: "Profile",
          editDiagnosis: "Edit diagnosis",
          add: "Add",
          view: "View",
          request: "Request",
          showAll: "Show all",
          message: "Message",
          call: "Call",
          join: "Join",
          updating: "Updating...",
          details: "Details",
          changeAppointment: "Change, reschedule or cancel appointment",
          startConsultation: "Start consultation",
          markInProgress: "Mark in progress",
          completeConsultation: "Complete consultation",
        },
        cancelDialog: {
          title: "Cancel appointment?",
          description: "Please remember to reach out to the patient before proceeding.",
          confirm: "Yes, cancel",
        },
        deleteDialog: {
          title: "Are you sure you want to delete this medical appointment?",
          description: "After deleting the medical appointment record, you will not be able to recover it.",
          confirm: "Delete",
        },
        changeSheet: {
          title: "Change • update appointment",
          requestNewTime: "Request new time",
          cancelAppointment: "Cancel Appointment",
        },
        errors: {
          update: "Could not update appointment right now.",
          requestEhr: "Could not request EHR access right now.",
        },
      },
      patientEhr: {
        title: "EHR",
        patientFallback: "Patient",
        yearsOld: "{count} Years old",
        accessRequested: "Access requested",
        accessNotGranted: "Access not granted",
        goToRequest: "Go to request",
        sections: {
          information: "Information",
          conditions: "Conditions",
          record: "Record",
        },
        fields: {
          dob: "Date of birth",
          language: "Primary Language",
          heightWeight: "Height & Weight",
          bloodType: "Blood type",
          medications: "Medications",
          allergies: "Allergies",
          chronic: "Chronic Conditions",
          organDonor: "Organ Donor",
          pastAppointments: "Past Appointments",
        },
      },
      patientPastAppointments: {
        title: "Past Appointments",
        loading: "Loading past appointments...",
        empty: "No past appointments found.",
        unknownDate: "Unknown date",
        doctorFallback: "Doctor",
        specialtyFallback: "General practitioner",
        diagnosisFallback: "No diagnosis recorded",
        diagnosisLabel: "Diagnosis",
        errors: {
          load: "Failed to load past appointments.",
        },
      },
      pastAppointmentDetails: {
        title: "Appointment details",
        loading: "Loading appointment details...",
        notFound: "Past appointment not found.",
        doctorFallback: "Doctor",
        specialtyFallback: "Dermatologist",
        diagnosisFallback: "No diagnosis recorded",
        diagnosisBodyFallback: "No diagnosis notes were added for this appointment.",
        prescriptionNone: "No prescription issued",
        prescriptionGuidanceFallback: "No prescription instructions recorded.",
        patientNotesFallback: "No patient notes recorded.",
        labsFallback: "No tests or lab results recorded",
        photosEmpty: "No patient photos shared yet.",
        showAll: "Show all",
        sections: {
          diagnosis: "Diagnosis",
          labs: "Tests & Lab results",
          prescription: "Prescription",
          notes: "Patient Notes",
          photos: "Patient Photos",
        },
        errors: {
          auth: "Authentication required.",
          load: "Failed to load past appointment details.",
        },
      },
    },
    fola: {
      widget: {
        title: "Fola - AfriMed Assistant",
        greeting:
          "Hi, I am Fola. I can help with OTP, magic links, and settings.",
        placeholder: "Ask Fola...",
        send: "Send",
        error: "Sorry, I hit a snag. Try again.",
      },
    },
  },
  pt: {
    common: {
      back: "Voltar",
      cancel: "Cancelar",
      change: "Alterar",
      close: "Fechar",
      continue: "Continuar",
      discard: "Descartar",
      changesSaved: "Alteracoes guardadas",
      keepEditing: "Continuar a editar",
      no: "Nao",
      save: "Guardar",
      saving: "A guardar...",
      yes: "Sim",
      loggingOut: "A terminar sessao...",
      logout: "Terminar sessao",
      loading: "A carregar...",
      manage: "Gerir",
      open: "Abrir",
      comingSoon: "Em breve",
      legal: {
        terms: "Termos e Condicoes",
        privacy: "Politica de Privacidade",
        dataDeletion: "Eliminacao de Dados",
        copyright: "© {year} AfriMed™ Telehealth",
      },
    },
    auth: {
      login: {
        sheetMethodLabel: "Escolha o metodo de acesso",
        methods: {
          email: "Email",
          phone: "Telefone",
        },
        sheet: {
          email: "Email",
          emailPlaceholder: "voce@exemplo.com",
          sendMagicLink: "Enviar link seguro de acesso por email",
          sending: "A enviar...",
          phoneLabel: "Codigo do pais, numero de telefone",
          continue: "Continuar",
          phoneSaved:
            "Guardado como verificacao pendente. Agora entre com email para continuar.",
          phoneHint: "A verificacao por telefone esta temporariamente indisponivel.",
          invalidPhone: "Introduza um numero SADC/Diaspora valido.",
          invalidPhoneLength:
            "Introduza um numero de telefone valido (7-12 digitos).",
          cooldown: "Pode pedir um novo link em {seconds}s.",
          waitBeforeRetry: "Aguarde {seconds}s antes de pedir outro link.",
          rateLimit:
            "Pedidos a mais. Aguarde 1 minuto e tente novamente.",
          loginOnlyMode:
            "Nao foi possivel iniciar sessao com esse link. Peca um novo link seguro de acesso e abra o email mais recente.",
          emailUnavailable:
            "O acesso por email esta temporariamente indisponivel. Tente novamente em breve ou use Google/Facebook.",
          networkIssue:
            "Problema de rede ao enviar o link. Tente novamente.",
          linkSent:
            "Enviamos um link de acesso. Abra-o neste mesmo navegador/dispositivo.",
          close: "Fechar",
          manageCookies: "Gerir cookies",
          complianceLine: "Infraestrutura digital de saude compativel com HIPAA e GDPR.",
        },
        landing: {
          title: "Bem-vindo a AfriMed™",
          line1: "Vamos fazer a jornada para uma",
          line2: "saude melhor-juntos!",
          registerEmail: "Registar com email",
          registerFacebook: "Registar com Facebook",
          registerGoogle: "Registar com Google",
          login: "Entrar",
          trouble: "Problemas para entrar?",
          trial: "Comecar um teste gratis de 14 dias",
          journey: "A sua jornada para o cuidado",
        },
      },
      resetPassword: {
        invalidLink:
          "Este link e invalido ou expirou. Peça um novo.",
        missingLink: "Link de recuperacao em falta ou invalido.",
        updateError:
          "Nao foi possivel atualizar a sua palavra-passe. Tente novamente.",
        title: "Definir nova palavra-passe",
        intro: "Crie uma nova palavra-passe para a sua conta.",
        successTitle: "Palavra-passe redefinida",
        successIntro:
          "A sua palavra-passe foi atualizada. Agora pode entrar com email e palavra-passe.",
        newPassword: "Nova palavra-passe",
        newPasswordHelper: "Pelo menos 8 caracteres",
        confirmPassword: "Confirmar palavra-passe",
        saving: "A guardar...",
        save: "Guardar nova palavra-passe",
        requestNewLink: "Pedir novo link de redefinicao",
        backToLogin: "Voltar ao login",
      },
      demo: {
        title: "Acesso demo",
        intro: "Use uma conta pre-preenchida para explorar a AfriMed™.",
        form: {
          emailRequired: "O endereco de email e obrigatorio",
          passwordRequired: "A palavra-passe e obrigatoria",
          signInError: "Nao foi possivel entrar.",
          networkError:
            "Erro de rede. Verifique a sua ligacao e tente novamente.",
          errorTitle: "Falha de autenticacao",
          copyError: "Copiar mensagem de erro",
          dismiss: "Fechar",
          emailLabel: "Endereco de email",
          emailPlaceholder: "Introduza o seu email",
          passwordLabel: "Palavra-passe",
          passwordPlaceholder: "Introduza a sua palavra-passe",
          rememberMe: "Lembrar-me",
          forgotPassword: "Esqueceu-se da palavra-passe?",
          signingIn: "A entrar...",
          signIn: "Entrar",
          demoTitle: "Credenciais demo disponiveis",
          demoIntro: "Use estas contas demo para testar a plataforma",
          doctorAccount: "Conta de medico",
          patientAccount: "Conta de paciente",
          patientJane: "Conta de paciente (Jane)",
        },
      },
      signUp: {
        title: "Bem-vindo a AfriMed™",
        subtitle: "Crie a sua conta para continuar.",
        rolePatient: "Paciente",
        roleDoctor: "Medico",
        continueWithGoogle: "Continuar com Google",
        continueWithEmail: "ou continue com email",
        email: "Email",
        emailPlaceholder: "voce@dominio.com",
        password: "Palavra-passe",
        passwordPlaceholder: "Palavra-passe forte",
        createAccount: "Criar conta",
        existingAccount: "Ja tem conta?",
        forgotPassword: "Esqueceu-se da palavra-passe?",
      },
      forgotPassword: {
        title: "Redefinir a sua palavra-passe",
        intro: "Introduza o seu email e enviaremos um link seguro para criar uma nova palavra-passe.",
        email: "Email",
        emailPlaceholder: "voce@exemplo.com",
        sendLink: "Enviar link de redefinicao",
        sending: "A enviar...",
        sendError:
          "Nao foi possivel enviar o link de redefinicao da palavra-passe. Tente novamente.",
        backToLogin: "Voltar ao login",
        usePhoneInstead: "Usar telefone",
        checkEmail: "Verifique o seu email para um link seguro de redefinicao da palavra-passe.",
      },
      idleLogout: {
        title: "Ainda esta ai?",
        bodyLead: "Para sua seguranca, vamos terminar a sessao em",
        bodyEnd: "se nao houver atividade.",
        logOut: "Terminar sessao",
        staySignedIn: "Continuar com sessao iniciada",
      },
    },
    home: {
      patient: {
        welcome: "Bem-vindo, {firstName}!",
        actions: {
          openProfile: "Abrir perfil",
          notifications: "Notificacoes",
          viewAll: "Ver tudo",
        },
        appointments: {
          title: "As suas consultas",
          tabs: {
            upcoming: "Proximas",
            past: "Anteriores",
            pending: "Pendentes de aprovacao",
          },
          empty: {
            title: "Ainda nao tem consultas",
            body: "Marque um medico para comecar o seu cuidado.",
          },
          bookAction: "Marcar consulta",
          error:
            "Estamos a carregar as suas consultas. Tente novamente dentro de instantes.",
        },
        serviceCategories: {
          title: "Categorias de servico",
          doctors: "Medicos",
          hospitals: "Hospitais",
          pharmacies: "Farmacias",
          ambulances: "Ambulancias",
        },
        popularServices: {
          title: "Servicos populares",
          action: "Todos os servicos",
        },
        nearby: {
          title: "Cuidados de saude perto de si",
          action: "Encontrar cuidados de saude perto de mim",
          selectedFacility: "Instalacao selecionada",
          seeDoctors: "Ver medicos nesta instalacao",
          loading: "A carregar instalacoes proximas...",
          findDoctors: "Encontrar medicos",
          searchPlaceholder: "Pesquisar instalacoes",
          clearSearch: "Limpar pesquisa",
          showingNear: "A mostrar instalacoes perto de",
          clearSelectedFacility: "Limpar instalacao selecionada",
          defaultFacilityName: "Instalacao de saude",
        },
        verifyIdentity: {
          title: "Verifique a sua identidade",
          body: "Perfis verificados geram mais confianca.",
          pending: "Revisao pendente",
          action: "Verificar agora",
        },
      },
      doctor: {
        fallbackName: "Medico",
        patientFallback: "Paciente",
        consultancyFallback: "Consulta",
        welcome: "Bem-vindo Dr {surname}",
        specialtyFallback: "Medico",
        actions: {
          openProfile: "Abrir perfil",
          dashboard: "Painel",
          notifications: "Notificacoes",
          viewAll: "Ver tudo",
        },
        appointments: {
          title: "As suas consultas",
          loading: "A carregar consultas...",
          loadingError:
            "Estamos a carregar as suas consultas. Atualize dentro de instantes.",
          error: "Nao foi possivel carregar as consultas.",
          emptyTitle: "Nao tem consultas agendadas.",
          emptyBody:
            "As consultas aprovadas vao aparecer aqui assim que os pacientes as confirmarem.",
          tabs: {
            today: "Hoje",
            todayCount: "Hoje {count}",
            upcoming: "Proximas",
            upcomingCount: "Proximas {count}",
            pending: "Pendentes de aprovacao",
            pendingCount: "Pendentes de aprovacao {count}",
          },
        },
        elevate: {
          title: "Valorize a sua consulta",
        },
        gallery: {
          title: "Destaque o seu perfil",
          body: "Adicione imagens sobre a sua consulta",
          notNow: "Agora nao",
        },
        regional: {
          title: "Saude regional",
          headline: "Mantenha-se informado sobre os",
          defaultSummary: "tendencias e condicoes de saude",
          facilitySummary: "{count} instalacoes e tendencias mapeadas",
        },
      },
    },
    settings: {
      home: {
        title: "Definicoes",
        userFallback: "Utilizador",
        loginSecurity: "Inicio de sessao e seguranca",
        language: "Idioma",
        availability: "Disponibilidade",
        notifications: "Notificacoes",
        preferences: "Preferencias",
        legal: "Legal",
        faq: "FAQ",
        logoutDialog: {
          title: "Tem a certeza de que quer terminar a sessao?",
          body: "Vai precisar de iniciar sessao novamente para continuar.",
        },
      },
      welcome: {
        fallbackName: "ai",
        title: "Bem-vindo {name} as suas Definicoes",
        doctorBody:
          "As definicoes sao o seu centro de controlo onde define a sua foto de perfil, horarios de consultas e gere tudo na sua conta, pagamentos, notificacoes e muito mais.",
        patientBody:
          "As definicoes sao o seu centro de controlo onde define a sua foto de perfil e gere seguranca, pagamentos, notificacoes e muito mais.",
      },
      preferences: {
        title: "Preferencias",
        sections: {
          app: "Aplicacao",
          account: "Conta",
        },
        appearance: {
          title: "Aparencia",
          subtitle: "Usar tema do sistema, claro ou escuro",
        },
        language: {
          title: "Idioma",
        },
        news: {
          title: "Noticias e atualizacoes",
          subtitle: "Preferencias de email e push",
        },
        notifications: {
          title: "Notificacoes",
          subtitle: "Noticias, atualizacoes e regulamentos locais",
        },
        notificationInbox: {
          title: "Caixa de notificacoes",
          subtitle: "Urgentes, nao lidas e atualizacoes de consultas",
        },
        accessibility: {
          title: "Acessibilidade e Fola",
          subtitle: "Opcoes assistivas e apoio de IA",
        },
        plans: {
          title: "Planos e subscricoes",
          subtitle: "O seu plano AfriMedTM e extras",
        },
        transactions: {
          title: "Transacoes e faturas",
          subtitle: "Ver historico e descarregar recibos",
        },
        downloads: {
          title: "Transferencias",
          subtitle: "Exportar dados, relatorios e resumos",
        },
        closeAccount: {
          title: "Fechar, pausar ou eliminar conta",
          subtitle: "Vamos guiar opcoes mais seguras primeiro",
        },
      },
      language: {
        title: "Idioma",
        changedTo: "Idioma alterado para {language}",
      },
      edit: {
        common: {
          saveFailed: "Nao foi possivel guardar as alteracoes. Tente novamente.",
          sessionNotReady: "A sua sessao ainda nao esta pronta. Tente novamente.",
        },
        name: {
          title: "Editar nome",
          subtitle:
            "Certifique-se de que isto corresponde ao nome no seu documento oficial emitido pelo governo.",
          firstLabel: "Primeiro nome no documento",
          firstPlaceholder: "Primeiro nome/s no documento",
          lastLabel: "Apelido no documento",
          lastPlaceholder: "Apelido/s no documento",
          clearFirst: "Limpar primeiro nome",
          clearLast: "Limpar apelido",
          updated: "Nome atualizado",
        },
        phone: {
          title: "Editar o seu numero de telefone",
          subtitle: "Adicione o seu numero para podermos contacta-lo quando necessario",
          invalidPhone: "Introduza primeiro um numero de telefone valido.",
          mustAccept: "Aceite primeiro os termos.",
          invalidPhoneLength: "Introduza um numero de telefone valido (7-12 digitos).",
          timeout: "A gravacao esta a demorar demasiado. Toque em Guardar novamente.",
          saveFailed: "Nao foi possivel guardar o numero de telefone. Tente novamente.",
          updated: "Numero de telefone guardado",
          verified: "Este numero de telefone ja esta verificado.",
          termsLead:
            "Ao assinalar esta caixa, confirmo que li e concordo com os",
          termsLink: "Termos de Servico",
          termsJoiner: "e a",
          privacyLink: "Politica de Privacidade",
          termsEnd: ".",
          verifyLater: "",
        },
        dob: {
          title: "Editar data de nascimento",
          subtitle:
            "Certifique-se de que isto corresponde a sua data de nascimento no seu documento oficial emitido pelo governo.",
          label: "Data de nascimento",
          placeholder: "DD MMM, AAAA",
          updated: "Data de nascimento atualizada",
        },
        about: {
          title: "Sobre si",
          subtitle: "Apresente-se aos seus pacientes",
          label: "Sobre si",
          placeholder:
            "Diga aos pacientes um pouco sobre a sua formacao, experiencia e abordagem.",
          counter: "{count}/{max} caracteres",
          minimum: "Minimo de {min} caracteres obrigatorios",
          updated: "Secao sobre si atualizada",
          folaTitle: "Posso ajudar a escrever uma biografia profissional hoje?",
          folaLoading: "A analisar as suas credenciais...",
          folaApply: "Aplicar o rascunho da Fola",
        },
        organDonor: {
          title: "Dador de orgaos",
          subtitle:
            "Escolha se esta registado como dador de orgaos. Pode alterar esta preferencia a qualquer momento e falar sobre isso com o seu medico.",
          discardTitle: "Descartar alteracoes?",
          discardBody:
            "Tem alteracoes nao guardadas na preferencia de dador de orgaos. Tem a certeza de que pretende fechar sem guardar?",
        },
        email: {
          title: "Editar o seu email",
          subtitleLink: "Vamos enviar um link de verificacao para confirmar este email.",
          subtitleCode: "Vamos enviar um codigo de 6 digitos para confirmar este email.",
          label: "Email",
          placeholder: "voce@exemplo.com",
          verified: "Este email ja esta verificado.",
          enterEmail: "Introduza um endereco de email.",
          invalidEmail: "Introduza um endereco de email valido.",
          sendFailed: "Nao foi possivel enviar o email. Tente novamente.",
          linkSent: "Enviamos um link de verificacao para {email}",
          checkInbox: "Verifique o seu email e abra o link de verificacao enviado para",
          sendVerificationLink: "Enviar link de verificacao",
          sending: "A enviar...",
          checking: "A verificar...",
          verifiedAction: "Ja verifiquei",
          updated: "Email verificado",
          notVerifiedYet:
            "Ainda nao esta verificado. Abra o link no seu email e tente novamente.",
          notAuthenticated: "Nao autenticado. Inicie sessao novamente.",
          sendCodeFailed: "Nao foi possivel enviar o codigo. Tente novamente.",
          forbidden: "Proibido (politica do servidor). Precisamos de corrigir a regra no backend.",
          enterCode: "Introduza o codigo de 6 digitos.",
          codeExpired: "Este codigo expirou. Reenvie um novo.",
          incorrectCode: "Codigo incorreto. Tente novamente.",
          verifyFailed: "A verificacao falhou. Tente novamente.",
          stillSending: "Ainda a enviar...",
          waitBeforeResend: "Aguarde {seconds}s antes de reenviar.",
          sendDisabled: "O envio esta atualmente desativado.",
          resendIn: "Reenviar em {seconds}s",
          sendCode: "Enviar codigo",
          enterSentCode: "Introduza o codigo de 6 digitos enviado para",
          codeLabel: "Codigo de verificacao",
          codePlaceholder: "123456",
          verifying: "A verificar...",
          verify: "Verificar",
        },
        address: {
          title: "Editar endereco",
          subtitle: "Certifique-se de que introduz o seu endereco corretamente.",
          locationUnavailable: "A localizacao nao esta disponivel neste navegador.",
          lookupFailed:
            "Localizacao encontrada, mas a pesquisa do endereco falhou. Pode editar manualmente.",
          permissionDenied:
            "Permissao de localizacao negada. Ative o acesso a localizacao para preenchimento rapido.",
          locationTimeout: "O pedido de localizacao expirou. Tente novamente.",
          locationFailed: "Nao foi possivel obter a sua localizacao.",
          signInRequired: "Inicie sessao para guardar o seu endereco.",
          saveFailed: "Nao foi possivel guardar o seu endereco. Tente novamente.",
          locating: "A localizar...",
          useCurrentLocation: "Usar a minha localizacao atual",
          line1Label: "Endereco",
          line1Placeholder: "Numero, Rua",
          line2Label: "Endereco (linha 2)",
          line2Placeholder: "Cidade, Bairro",
          postalLabel: "Codigo postal",
          postalPlaceholder: "Codigo postal",
          countryLabel: "Pais",
          quickFillTitle: "Preencher endereco automaticamente?",
          quickFillBodyPatient:
            "Podemos usar a sua localizacao atual para preencher rapidamente o seu endereco de casa para nao ter de o escrever manualmente.",
          quickFillBodyDoctor:
            "Podemos usar a sua localizacao atual para preencher rapidamente o seu endereco e mostrar instalacoes perto de si.",
          quickFillAction: "Sim, preencher rapido",
          locationNameLabel: "Nome do local",
          locationNamePlaceholder: "Comece a escrever o nome da instalacao...",
          buildingTypeLabel: "Tipo de edificio",
          buildingTypePlaceholder: "Hospital",
          doctorLine1Placeholder: "Seogoditshane Way, 5th floor, 507",
          cityLabel: "Cidade",
          cityPlaceholder: "Gaborone",
          buildingTypeDescription:
            "Escolha o tipo de edificio que melhor descreve a sua localizacao.",
          addBuildingTypeLabel: "Adicionar tipo de edificio",
          addBuildingTypePlaceholder: "ex. laboratorio de diagnostico",
          permissionsBlocked:
            "O endereco da consultoria nao pode ser atualizado agora devido a permissoes. Os dados nao foram guardados na base de dados.",
        },
        idPassport: {
          submitted: "ID / Passaporte enviado para verificacao",
          signInRequired: "Tem de iniciar sessao.",
          statusReadFailed: "Nao foi possivel ler o estado da verificacao.",
          awaitingReview: "Documento recebido. A aguardar revisao.",
        },
        registrationUpload: {
          title: "Documento de registo",
          subtitle: "Carregue uma copia nitida do seu registo no conselho",
          addTitle: "Adicionar o seu documento de registo",
          addAction: "Adicionar",
          changeFile: "Alterar ficheiro",
          addMore: "Adicionar mais",
          existingNotice:
            "Ja existe um documento de registo guardado de {date}. Carregue um novo para o substituir.",
          status: {
            done: "Registo reconhecido",
            failed: "Verificacao falhou",
          },
          saveOcrFailed: "Nao foi possivel guardar os resultados do OCR.",
          analysisFailed:
            "A analise do documento falhou. Tente outro ficheiro.",
          statusReadFailed:
            "Nao foi possivel ler o estado da verificacao.",
          summary: {
            registrationNumber: "N.o de registo",
            practitionerName: "Nome completo (profissional)",
            specialty: "Especialidade / Categoria",
            practitionerFallback: "Profissional",
          },
          retention: "Guardado ate {date}.",
          consent:
            "Ao carregar, consente que a AfriMed armazene este documento com encriptacao ponta a ponta para verificacao. Sera retido por ate 90 dias.",
          alt: {
            verified: "Verificado",
            documentPreview: "Pre-visualizacao do documento de registo",
          },
        },
        registrationDetails: {
          title: "Detalhes do registo",
          subtitle: "Mantenha as informacoes do seu registo atualizadas.",
          signInRequired: "Tem de iniciar sessao.",
          saveFailed: "Nao foi possivel guardar os detalhes do registo.",
          savedPending: "Alteracoes guardadas (verificacao pendente)",
          expiryPast:
            "A data de validade nao pode estar no passado. Escolha hoje ou uma data futura.",
          yearsRange: "Introduza um valor entre 1 e 60.",
          suggestions: {
            other: "Outro",
          },
          fields: {
            number: {
              label: "Numero de registo",
              placeholder: "ex. BMD 12345",
            },
            issuer: {
              label: "Entidade emissora",
              placeholder: "Selecione ou escreva a entidade emissora",
            },
            issueDate: {
              label: "Data de emissao",
            },
            expiryDate: {
              label: "Data de validade",
            },
            datePlaceholder: "DD MMM, YYYY",
            yearsExperience: {
              label: "Anos de experiencia",
              placeholder: "ex. 12",
            },
          },
        },
      },
    },
    messages: {
      loadingConversation: "A carregar conversa...",
      noMessagesYet: "Ainda nao ha mensagens.",
      writeMessage: "Escreva uma mensagem...",
      composeModal: {
        title: "Nova conversa",
        addParticipants: "Adicionar participantes",
        close: "Fechar",
        types: {
          doctorPatient: "Medico-Paciente",
          doctorDoctor: "Medico-Medico",
          group: "Conversa de grupo",
        },
        typeDescriptions: {
          doctorPatient:
            "Comunicacao segura com pacientes para consultas medicas",
          doctorDoctor:
            "Colaboracao profissional com outros prestadores de saude",
          group: "Discussoes com varios participantes para coordenacao da equipa",
        },
        conversationTitle: "Titulo da conversa (opcional)",
        conversationTitlePlaceholder: "Introduza um titulo para esta conversa...",
        autoGenerateHint:
          "Deixe vazio para gerar automaticamente com base nos participantes",
        searchUsers: "Pesquisar utilizadores",
        searchPlaceholder: "Pesquisar por nome...",
        selectedParticipants: "Participantes selecionados ({count})",
        searchResults: "Resultados da pesquisa",
        unknownUserInitial: "U",
        unknownUser: "Utilizador desconhecido",
        noUsersFound: "Nenhum utilizador encontrado",
        startTyping: "Comece a escrever para pesquisar utilizadores",
        back: "Voltar",
        cancel: "Cancelar",
        nextAddParticipants: "Seguinte: adicionar participantes",
        createConversation: "Criar conversa",
        chatWith: "Conversa com {name}",
        groupChatMembers: "Conversa de grupo ({count} membros)",
      },
      inbox: {
        search: "Pesquisar",
        searchRecipients: "Pesquisar destinatarios",
        clearSearch: "Limpar pesquisa",
        openFola: "Abrir conversa Fola",
        newMessage: "Nova mensagem",
        title: "Mensagens",
        composeTitle: "Nova mensagem",
        loadingRecipientsTitle: "A carregar destinatarios",
        loadingRecipientsBody:
          "Aguarde enquanto carregamos as pessoas a quem pode enviar mensagem.",
        opening: "A abrir...",
        new: "Nova",
        noRecipientsMatch: "Nenhum destinatario corresponde a sua pesquisa.",
        noRecipientsTitle: "Ainda sem destinatarios",
        noRecipientsBody:
          "Os destinatarios aparecerao aqui assim que tiver uma consulta ou conversa existente.",
        noConversationsMatch: "Nenhuma conversa corresponde a sua pesquisa.",
        loadingMessagesTitle: "A carregar mensagens",
        loadingMessagesBody:
          "Aguarde enquanto procuramos as suas conversas mais recentes.",
        emptyTitle: "Nenhuma mensagem para mostrar",
        emptyBody: "A sua caixa de entrada esta vazia neste momento. Volte mais tarde.",
        noMessagesPreview: "Ainda nao ha mensagens.",
      },
      conversation: {
        now: "Agora",
        deletedForMe: "Eliminou esta mensagem",
        deletedBySender: "O remetente eliminou a mensagem",
        deleteDialog: {
          close: "Fechar caixa de eliminacao",
          title: "Eliminar mensagem?",
          body:
            "Elimine esta mensagem apenas para si ou remova-a para ambos os participantes. Esta acao nao pode ser desfeita.",
          deleting: "A eliminar...",
          forMe: "Eliminar para mim",
          forBoth: "Eliminar para ambos",
        },
        toast: {
          dismiss: "OK",
          undo: "Desfazer",
          deletedForMe: "Mensagem eliminada para mim",
          deletedForBoth: "Mensagem eliminada para ambos",
          deleteError: "Nao foi possivel eliminar a mensagem agora.",
        },
        composer: {
          all: "Tudo",
          attach: "Anexar foto",
          send: "Enviar mensagem",
          thinking: "A Fola esta a pensar",
          selectedAttachmentAlt: "Anexo selecionado",
        },
        topBar: {
          back: "Voltar as mensagens",
          openFola: "Abrir conversa Fola",
          compose: "Escrever mensagem",
        },
      },
    },
    appointments: {
      nearby: {
        pageTitle: "Consultas",
      },
      book: {
        title: "Escolha uma data e hora",
        doctorMissing:
          "Medico nao encontrado. Volte atras e selecione novamente o medico.",
        backToDoctors: "Voltar aos medicos",
        sections: {
          service: "Selecionar um servico",
          date: "Data",
          time: "Hora",
          payment: "Selecione o seu metodo de pagamento",
        },
        selectDate: "Selecionar data",
        minutesShort: "{count} min",
        loading: {
          services: "A carregar servicos do medico...",
          dates: "A carregar datas disponiveis...",
          times: "A carregar horas disponiveis...",
          payments: "A carregar metodos de pagamento do medico...",
        },
        empty: {
          services: "Este medico ainda nao adicionou servicos.",
          dates: "Este medico ainda nao abriu dias de consulta.",
          unavailableDay: "Este medico nao esta disponivel no dia selecionado.",
          noTimes: "Nao restam horas de consulta disponiveis para este dia.",
          payments: "Este medico ainda nao definiu metodos de pagamento.",
        },
        errors: {
          loadServices: "Nao foi possivel carregar os servicos do medico.",
          loadDates: "Nao foi possivel carregar as datas disponiveis.",
          loadTimes: "Nao foi possivel carregar as horas disponiveis.",
          loadPayments:
            "Nao foi possivel carregar os metodos de pagamento.",
        },
        confirm: "Confirmar",
        fallbackServices: {
          evisit: "Consulta virtual",
          consultation: "Consulta",
        },
      },
      details: {
        title: "Detalhes da consulta",
        loading: "A carregar consulta...",
        notFound:
          "Consulta nao encontrada. Volte atras e abra-a novamente.",
        backToAppointments: "Voltar as consultas",
        visitType: {
          evisit: "Consulta virtual",
        },
        meetLabel: "Video AfriMed™",
        videoRoomLabel: "Sala segura de consulta AfriMed™",
        join: "Entrar",
        message: "Mensagem",
        call: "Chamada",
        ehr: {
          granted: "Acesso concedido",
          grant: "Conceder acesso",
          granting: "A conceder...",
        },
        sections: {
          time: "Selecione a hora da consulta",
          payment: "Metodo de pagamento",
        },
        cancelVisit: "Cancelar consulta",
        editVisit: "Editar consulta",
        cancelDialog: {
          title: "Cancelar consulta?",
          description: "Tem a certeza de que quer cancelar esta consulta?",
          confirm: "Sim, cancelar",
        },
        deleteDialog: {
          title: "Tem a certeza de que quer eliminar esta consulta medica?",
          description:
            "Depois de eliminar o registo da consulta medica, nao sera possivel recupera-lo.",
          confirm: "Eliminar",
        },
        toast: {
          rescheduleRequested:
            "Novo pedido de horario enviado. Aguardando aprovacao.",
          confirmed: "Consulta confirmada",
          updated: "Consulta atualizada",
          deleted: "A sua consulta foi eliminada",
          ehrGranted: "Acesso ao EHR concedido",
        },
        errors: {
          load: "Nao foi possivel carregar a consulta.",
          ehrMissing: "Faltam detalhes da consulta para o acesso ao EHR.",
          verifyAccount: "Nao foi possivel verificar a sua conta.",
          ehrGrant:
            "Nao foi possivel conceder acesso ao EHR neste momento.",
          cancel: "Nao foi possivel cancelar a consulta.",
        },
      },
      doctorIndex: {
        defaultFacilityName: "Instalacao principal nao definida",
        patientFallback: "Paciente",
        errorLoad: "Nao foi possivel carregar as consultas.",
        loading: "A carregar consultas...",
        emptyTitle: "Nenhuma consulta para mostrar",
        emptyBody: "A sua caixa de entrada esta vazia neste momento. Volte mais tarde.",
        selectDay: "Selecionar dia {day}",
        viewMode: {
          label: "Modo de visualizacao",
          day: "Dia",
          week: "Semana",
          month: "Mes",
          list: "Lista",
        },
        list: {
          freeSchedule: "Agenda livre",
          allDay: "Todo o dia",
        },
        snackbar: {
          rescheduled:
            "A consulta foi movida para {date}. Pendente de aceitacao do paciente.",
          review: "Rever",
          cancelled: "Consulta cancelada",
        },
      },
      directory: {
        common: {
          filter: "Filtro",
          loading: "A carregar...",
          centerMap: "Centrar mapa",
        },
        hospitals: {
          search: "Pesquisar hospitais",
          nearby: "Perto",
          empty: "Nenhum hospital encontrado.",
          favoriteAria: "Hospital favorito",
        },
        pharmacies: {
          title: "Farmacias",
          subtitle: "Farmacias perto de si",
          search: "Pesquisar farmacias",
          empty: "Nenhuma farmacia encontrada.",
          favoriteAria: "Farmacia favorita",
          filter: {
            data: "Dados",
            payment: "Metodos de pagamento",
            apply: "Aplicar",
            options: {
              "best-rating": "Melhor classificacao",
              "near-you": "Perto de si",
              cards: "Cartoes de credito e debito",
              "bank-transfer": "Transferencias bancarias",
              ewallet: "Carteiras digitais",
              "instant-eft": "EFT instantaneo",
            },
          },
        },
        ambulances: {
          title: "Ambulancia",
          subtitle: "Ambulancias perto de si",
          favoriteAria: "Ambulancia favorita",
          filter: {
            data: "Dados",
            payment: "Metodos de pagamento",
            apply: "Aplicar",
            options: {
              "best-rating": "Melhor classificacao",
              "near-you": "Perto de si",
              cards: "Cartoes de credito e debito",
              "bank-transfer": "Transferencias bancarias",
              ewallet: "Carteiras digitais",
              "instant-eft": "EFT instantaneo",
            },
          },
        },
      },
    },
    onboarding: {
      category: {
        continue: "Continuar",
        options: {
          doctor: {
            title: "Medico",
            desc: "Junte-se como medico licenciado e ofereca cuidados especializados na AfriMed™.",
          },
          patient: {
            title: "Paciente",
            desc: "Registe-se para aceder a clinicos de confianca, aos seus registos eletronicos e a prescricoes eletronicas.",
          },
          employer: {
            title: "Empregador",
            desc: "Dê aos seus colaboradores acesso a cuidados de saude de qualidade. Uma equipa saudavel impulsiona uma organizacao saudavel.",
          },
          moh: {
            title: "Ministerio da Saude",
            desc: "Avance a Cobertura Universal de Saude ao integrar cidadaos na AfriMed™.",
          },
        },
      },
      email: {
        title: "Email",
        subtitle:
          "Introduza corretamente o seu email para receber atualizacoes e notificacoes.",
        placeholder: "Email",
        continue: "Continuar",
      },
      emailEdit: {
        title: "O seu endereco de email",
        subtitle:
          "Usaremos este email para atualizacoes e notificacoes, apenas quando necessario. Se precisar de o alterar mais tarde, pode faze-lo nas Definicoes.",
        saveContinue: "Guardar e continuar",
        label: "Email",
        placeholder: "voce@exemplo.com",
        verified: "Verificado",
      },
      name: {
        title: "Os seus nomes completos",
        subtitle:
          "Certifique-se de que isto corresponde aos nomes no seu documento oficial de identificacao.",
        saving: "A guardar...",
        continue: "Continuar",
        firstLabel: "Primeiro nome",
        firstPlaceholder: "Primeiro nome no documento",
        lastLabel: "Apelido no documento",
        lastPlaceholder: "Apelido no documento",
        clearFirst: "Limpar primeiro nome",
        clearLast: "Limpar apelido",
        sessionNotReady:
          "A sua sessao ainda nao esta pronta. Tente novamente.",
        saveError: "Nao foi possivel guardar. Tente novamente.",
        saveRequest: "Guardar nome",
      },
      phone: {
        title: "O seu numero de telefone",
        saving: "A guardar...",
        continue: "Continuar",
        invalidPhone: "Introduza um numero de telefone valido.",
        invalidPhoneLength:
          "Introduza um numero de telefone valido (7-12 digitos).",
        mustAccept:
          "Aceite os Termos e a Politica de Privacidade para continuar.",
        termsLead:
          "Ao assinalar esta caixa, confirmo que li e concordo com os",
        termsLink: "Termos de Servico",
        termsJoiner: "e",
        privacyLink: "Politica de Privacidade",
        termsEnd: ".",
      },
      otp: {
        title: "Verificacao do telefone (em breve)",
        subtitle:
          "Guardamos o seu numero para verificacao por WhatsApp na proxima versao. Pode continuar por agora.",
        continue: "Continuar",
        phoneNumber: "Numero de telefone",
        notProvided: "Nao fornecido",
        note:
          "Nota: a verificacao por SMS esta desativada em staging enquanto passamos para onboarding com WhatsApp primeiro.",
      },
      passcodeConfirm: {
        title: "Codigo de acesso",
        subtitle: "Proteja a sua conta com um codigo de seguranca",
        saving: "A guardar...",
        continue: "Continuar",
        confirm: "Confirmar codigo",
        mismatch: "Os codigos nao coincidem. Tente novamente.",
        sessionExpired: "Sessao expirada. Inicie sessao novamente.",
        saveError: "Falha ao guardar o codigo",
      },
      passcodeCreate: {
        title: "Codigo de acesso",
        subtitle: "Proteja a sua conta com um codigo de seguranca",
        continue: "Continuar",
        create: "Criar codigo",
      },
      dob: {
        title: "Data de nascimento",
        subtitle:
          "Certifique-se de que isto corresponde ao nome no seu documento oficial de identificacao",
        saving: "A guardar...",
        continue: "Continuar",
        label: "Data de nascimento",
        placeholder: "DD-MM-AAAA",
        done: "Concluido",
        saveError: "Nao foi possivel guardar. Tente novamente.",
        timeout:
          "Tempo de rede esgotado ao guardar. Tente novamente (ou mude de rede).",
      },
      idPassport: {
        title: "Documento nacional • Passaporte",
        subtitle:
          "Introduza o seu numero de documento/passaporte ou a linha MRZ (30 caracteres).",
        continue: "Continuar",
        verifying: "A verificar...",
        label: "Documento / Passaporte",
        placeholder: "A12345678  ·  ou linha MRZ",
        done: "Concluido",
        invalidHint:
          "Use um numero de passaporte ou cole uma linha MRZ de 30 caracteres.",
        processingTitle: "Processamento do documento",
        processingPending: "A analisar o seu documento...",
        processingIdle: "Capture uma foto ou carregue uma digitalizacao nitida",
        working: "A processar...",
        retake: "Repetir",
        camera: "Camera",
        uploadFile: "Carregar ficheiro",
        aiProcessing: "Processamento IA",
        sessionNotReady: "Sessao ainda nao pronta. Inicie sessao novamente.",
        fileTooLarge:
          "Ficheiro demasiado grande. Carregue uma imagem com menos de 5MB.",
        uploading: "A carregar documento...",
        receivedExtracting: "Documento recebido. A extrair detalhes...",
        uploadFailed: "Falha no carregamento. Tente novamente.",
        retention: "Privacidade: o armazenamento encriptado expira em {date}.",
        status: {
          pending: "A analisar documento...",
          done: "Identidade recebida",
          failed: "Falha no processamento",
          received: "Documento recebido",
          idle: "A processar...",
        },
        alt: {
          passed: "Aprovado",
          failed: "Falhou",
          received: "Recebido",
        },
        summary: {
          surname: "Apelido",
          idNumber: "N.º do documento",
          dob: "Data de nascimento",
          expiry: "Data de validade",
          givenNames: "Nomes proprios",
        },
      },
      languages: {
        title: "Adicionar idiomas",
        searchPlaceholder: "Pesquisar ou adicionar",
        clearSearch: "Limpar pesquisa",
        addLanguage: "Adicionar idioma",
        helper: "Selecione todos os idiomas que fala.",
        noMatches: "Nenhum idioma corresponde a sua pesquisa.",
        continue: "Continuar",
        saving: "A guardar...",
        sessionExpired: "Sessao expirada",
        saveError: "Nao foi possivel guardar os idiomas",
      },
    },
    fola: {
      widget: {
        title: "Fola - Assistente AfriMed",
        greeting:
          "Ola, sou a Fola. Posso ajudar com OTP, magic links e definicoes.",
        placeholder: "Pergunte a Fola...",
        send: "Enviar",
        error: "Desculpe, ocorreu um problema. Tente novamente.",
      },
    },
  },
  fr: {
    common: {
      back: "Retour",
      cancel: "Annuler",
      change: "Changer",
      close: "Fermer",
      continue: "Continuer",
      discard: "Ignorer",
      changesSaved: "Modifications enregistrees",
      keepEditing: "Continuer a modifier",
      no: "Non",
      save: "Enregistrer",
      saving: "Enregistrement...",
      yes: "Oui",
      loggingOut: "Deconnexion...",
      logout: "Se deconnecter",
      loading: "Chargement...",
      manage: "Gérer",
      open: "Ouvrir",
      comingSoon: "Bientot disponible",
      legal: {
        terms: "Conditions generales",
        privacy: "Politique de confidentialite",
        dataDeletion: "Suppression des donnees",
        copyright: "© {year} AfriMed™ Telehealth",
      },
    },
    auth: {
      login: {
        sheetMethodLabel: "Choisir la methode de connexion",
        methods: {
          email: "Email",
          phone: "Telephone",
        },
        sheet: {
          email: "Email",
          emailPlaceholder: "vous@exemple.com",
          sendMagicLink: "Recevoir un lien de connexion securise par email",
          sending: "Envoi...",
          phoneLabel: "Indicatif pays, numero de telephone",
          continue: "Continuer",
          phoneSaved:
            "Enregistre comme verification en attente. Connectez-vous maintenant avec email pour continuer.",
          phoneHint:
            "La verification par telephone est temporairement indisponible.",
          invalidPhone:
            "Saisissez un numero SADC/Diaspora valide.",
          invalidPhoneLength:
            "Veuillez saisir un numero de telephone valide (7-12 chiffres).",
          cooldown: "Vous pouvez demander un nouveau lien dans {seconds}s.",
          waitBeforeRetry:
            "Veuillez attendre {seconds}s avant de demander un autre lien.",
          rateLimit:
            "Trop de demandes. Veuillez attendre 1 minute avant de reessayer.",
          loginOnlyMode:
            "Nous n'avons pas pu vous connecter avec ce lien. Demandez un nouveau lien de connexion securise et ouvrez l'email le plus recent.",
          emailUnavailable:
            "La connexion email est temporairement indisponible. Veuillez reessayer bientot ou utiliser Google/Facebook.",
          networkIssue:
            "Probleme reseau lors de l'envoi du lien. Veuillez reessayer.",
          linkSent:
            "Nous vous avons envoye un lien de connexion. Ouvrez-le sur ce meme navigateur/appareil.",
          close: "Fermer",
          manageCookies: "Gérer les cookies",
          complianceLine:
            "Infrastructure de sante numerique conforme HIPAA et GDPR.",
        },
        landing: {
          title: "Bienvenue sur AfriMed™",
          line1: "Faisons le voyage vers une meilleure",
          line2: "santé-ensemble !",
          registerEmail: "S'inscrire avec email",
          registerFacebook: "S'inscrire avec Facebook",
          registerGoogle: "S'inscrire avec Google",
          login: "Se connecter",
          trouble: "Difficulté à vous connecter ?",
          trial: "Commencer un essai gratuit de 14 jours",
          journey: "Votre parcours vers les soins",
        },
      },
      resetPassword: {
        invalidLink:
          "Ce lien est invalide ou a expire. Veuillez en demander un nouveau.",
        missingLink: "Lien de recuperation manquant ou invalide.",
        updateError:
          "Nous n'avons pas pu mettre a jour votre mot de passe. Veuillez reessayer.",
        title: "Definir un nouveau mot de passe",
        intro: "Creez un nouveau mot de passe pour votre compte.",
        successTitle: "Mot de passe reinitialise",
        successIntro:
          "Votre mot de passe a ete mis a jour. Vous pouvez maintenant vous connecter avec votre email et votre mot de passe.",
        newPassword: "Nouveau mot de passe",
        newPasswordHelper: "Au moins 8 caracteres",
        confirmPassword: "Confirmer le mot de passe",
        saving: "Enregistrement...",
        save: "Enregistrer le nouveau mot de passe",
        requestNewLink: "Demander un nouveau lien",
        backToLogin: "Retour a la connexion",
      },
      demo: {
        title: "Acces demo",
        intro: "Utilisez un compte pre-rempli pour explorer AfriMed™.",
        form: {
          emailRequired: "L'adresse email est requise",
          passwordRequired: "Le mot de passe est requis",
          signInError: "Connexion impossible.",
          networkError:
            "Erreur reseau. Verifiez votre connexion et reessayez.",
          errorTitle: "Echec de l'authentification",
          copyError: "Copier le message d'erreur",
          dismiss: "Fermer",
          emailLabel: "Adresse email",
          emailPlaceholder: "Saisissez votre adresse email",
          passwordLabel: "Mot de passe",
          passwordPlaceholder: "Saisissez votre mot de passe",
          rememberMe: "Se souvenir de moi",
          forgotPassword: "Mot de passe oublie ?",
          signingIn: "Connexion...",
          signIn: "Se connecter",
          demoTitle: "Identifiants demo disponibles",
          demoIntro: "Utilisez ces comptes demo pour tester la plateforme",
          doctorAccount: "Compte medecin",
          patientAccount: "Compte patient",
          patientJane: "Compte patient (Jane)",
        },
      },
      signUp: {
        title: "Bienvenue sur AfriMed™",
        subtitle: "Creez votre compte pour continuer.",
        rolePatient: "Patient",
        roleDoctor: "Medecin",
        continueWithGoogle: "Continuer avec Google",
        continueWithEmail: "ou continuer avec email",
        email: "Email",
        emailPlaceholder: "vous@domaine.com",
        password: "Mot de passe",
        passwordPlaceholder: "Mot de passe fort",
        createAccount: "Creer un compte",
        existingAccount: "Vous avez deja un compte ?",
        forgotPassword: "Mot de passe oublie ?",
      },
      forgotPassword: {
        title: "Reinitialiser votre mot de passe",
        intro: "Saisissez votre email et nous vous enverrons un lien securise pour creer un nouveau mot de passe.",
        email: "Email",
        emailPlaceholder: "vous@exemple.com",
        sendLink: "Envoyer le lien de reinitialisation",
        sending: "Envoi...",
        sendError:
          "Nous n'avons pas pu envoyer le lien de reinitialisation du mot de passe. Veuillez reessayer.",
        backToLogin: "Retour a la connexion",
        usePhoneInstead: "Utiliser le telephone",
        checkEmail: "Consultez votre email pour le lien securise de reinitialisation du mot de passe.",
      },
      idleLogout: {
        title: "Etes-vous toujours la ?",
        bodyLead: "Pour votre securite, nous vous deconnecterons dans",
        bodyEnd: "s'il n'y a aucune activite.",
        logOut: "Se deconnecter",
        staySignedIn: "Rester connecte",
      },
    },
    doctor: {
      editIntro: {
        title: "Modifier l'intro",
      },
    },
    home: {
      patient: {
        welcome: "Bienvenue, {firstName} !",
        actions: {
          openProfile: "Ouvrir le profil",
          notifications: "Notifications",
          viewAll: "Voir tout",
        },
        appointments: {
          title: "Vos rendez-vous",
          tabs: {
            upcoming: "A venir",
            past: "Passes",
            pending: "En attente d'approbation",
          },
          empty: {
            title: "Aucun rendez-vous pour le moment",
            body: "Prenez rendez-vous avec un medecin pour commencer vos soins.",
          },
          bookAction: "Prendre rendez-vous",
          error:
            "Nous chargeons vos rendez-vous. Veuillez reessayer dans un instant.",
        },
        serviceCategories: {
          title: "Categories de service",
          doctors: "Medecins",
          hospitals: "Hopitaux",
          pharmacies: "Pharmacies",
          ambulances: "Ambulances",
        },
        popularServices: {
          title: "Services populaires",
          action: "Tous les services",
        },
        nearby: {
          title: "Sante a proximite",
          action: "Trouver des soins pres de moi",
          selectedFacility: "Etablissement selectionne",
          seeDoctors: "Voir les medecins de cet etablissement",
          loading: "Chargement des etablissements a proximite...",
          findDoctors: "Trouver des medecins",
          searchPlaceholder: "Rechercher des etablissements",
          clearSearch: "Effacer la recherche",
          showingNear: "Affichage des etablissements pres de",
          clearSelectedFacility: "Effacer l'etablissement selectionne",
          defaultFacilityName: "Etablissement de sante",
        },
        verifyIdentity: {
          title: "Verifiez votre identite",
          body: "Les profils verifies inspirent davantage confiance.",
          pending: "Verification en attente",
          action: "Verifier maintenant",
        },
      },
      doctor: {
        fallbackName: "Medecin",
        patientFallback: "Patient",
        consultancyFallback: "Consultation",
        welcome: "Bienvenue Dr {surname}",
        specialtyFallback: "Medecin",
        actions: {
          openProfile: "Ouvrir le profil",
          dashboard: "Tableau de bord",
          notifications: "Notifications",
          viewAll: "Voir tout",
        },
        appointments: {
          title: "Vos rendez-vous",
          loading: "Chargement des rendez-vous...",
          loadingError:
            "Nous chargeons vos rendez-vous. Veuillez actualiser dans un instant.",
          error: "Impossible de charger les rendez-vous.",
          emptyTitle: "Vous n'avez aucun rendez-vous planifie.",
          emptyBody:
            "Les rendez-vous approuves apparaitront ici une fois confirmes par les patients.",
          tabs: {
            today: "Aujourd'hui",
            todayCount: "Aujourd'hui {count}",
            upcoming: "A venir",
            upcomingCount: "A venir {count}",
            pending: "En attente d'approbation",
            pendingCount: "En attente d'approbation {count}",
          },
        },
        elevate: {
          title: "Valorisez votre consultation",
        },
        gallery: {
          title: "Mettez votre profil en valeur",
          body: "Ajoutez des images de votre consultation",
          notNow: "Pas maintenant",
        },
        regional: {
          title: "Sante regionale",
          headline: "Restez informe sur les",
          defaultSummary: "tendances et conditions de sante",
          facilitySummary: "{count} etablissements et tendances cartographies",
        },
      },
    },
    settings: {
      home: {
        title: "Reglages",
        userFallback: "Utilisateur",
        loginSecurity: "Connexion et securite",
        language: "Langue",
        availability: "Disponibilite",
        notifications: "Notifications",
        preferences: "Preferences",
        legal: "Mentions legales",
        faq: "FAQ",
        logoutDialog: {
          title: "Voulez-vous vraiment vous deconnecter ?",
          body: "Vous devrez vous reconnecter pour continuer.",
        },
      },
      welcome: {
        fallbackName: "ici",
        title: "Bienvenue {name} dans vos Reglages",
        doctorBody:
          "Les reglages sont votre centre de controle ou vous definissez votre photo de profil, vos horaires de rendez-vous et gerez votre compte, vos paiements, vos notifications et bien plus encore.",
        patientBody:
          "Les reglages sont votre centre de controle ou vous definissez votre photo de profil et gerez la securite, les paiements, les notifications et bien plus encore.",
      },
      preferences: {
        title: "Preferences",
        sections: {
          app: "Application",
          account: "Compte",
        },
        appearance: {
          title: "Apparence",
          subtitle: "Utiliser le theme systeme, clair ou sombre",
        },
        language: {
          title: "Langue",
        },
        news: {
          title: "Actualites et mises a jour",
          subtitle: "Preferences email et push",
        },
        notifications: {
          title: "Notifications",
          subtitle: "Actualites, mises a jour et reglementations locales",
        },
        notificationInbox: {
          title: "Boite de notifications",
          subtitle: "Urgentes, non lues et mises a jour de rendez-vous",
        },
        accessibility: {
          title: "Accessibilite et Fola",
          subtitle: "Options d'assistance et soutien IA",
        },
        plans: {
          title: "Plans et abonnements",
          subtitle: "Votre plan AfriMedTM et ses options",
        },
        transactions: {
          title: "Transactions et factures",
          subtitle: "Voir l'historique et telecharger les recus",
        },
        downloads: {
          title: "Telechargements",
          subtitle: "Exporter les donnees, rapports et resumes",
        },
        closeAccount: {
          title: "Fermer, suspendre ou supprimer le compte",
          subtitle: "Nous vous guiderons d'abord vers des options plus sures",
        },
      },
      language: {
        title: "Langue",
        changedTo: "Langue changee en {language}",
      },
      profile: {
        title: "Profil",
        common: {
          editName: "Modifier le nom",
          editDob: "Modifier la date de naissance",
          editPhone: "Modifier le téléphone",
          editEmail: "Modifier l'email",
          editAddress: "Modifier l'adresse",
          idPassport: "Carte d'identité • Passeport",
          languages: "Langues",
        },
        doctor: {
          editIntro: "Modifier l'intro",
          registrationDetails: "Détails d'inscription",
          uploadRegistration: "Téléverser l'inscription",
          specialty: "Spécialité",
          subspecialty: "Sous-spécialité",
          consultancies: "Lieux de consultation",
          eVisit: "Consultations virtuelles",
          availability: "Disponibilités",
          servicesPricing: "Services et tarifs",
          yourFocus: "Domaines d'intérêt",
          editFormation: "Modifier la formation",
          about: "À propos de vous",
        },
      },
      edit: {
        common: {
          saveFailed:
            "Impossible d'enregistrer les modifications. Veuillez reessayer.",
          sessionNotReady:
            "Votre session n'est pas encore prete. Veuillez reessayer.",
        },
        name: {
          title: "Modifier le nom",
          subtitle:
            "Assurez-vous que cela correspond au nom figurant sur votre piece d'identite officielle.",
          firstLabel: "Prenom sur la piece d'identite",
          firstPlaceholder: "Prenom(s) sur la piece d'identite",
          lastLabel: "Nom de famille sur la piece d'identite",
          lastPlaceholder: "Nom(s) de famille sur la piece d'identite",
          clearFirst: "Effacer le prenom",
          clearLast: "Effacer le nom de famille",
          updated: "Nom mis a jour",
        },
        phone: {
          title: "Modifier votre numero de telephone",
          subtitle:
            "Ajoutez votre numero de telephone afin que nous puissions vous contacter si necessaire",
          invalidPhone: "Veuillez d'abord saisir un numero de telephone valide.",
          mustAccept: "Veuillez d'abord accepter les conditions.",
          invalidPhoneLength:
            "Veuillez saisir un numero de telephone valide (7-12 chiffres).",
          timeout:
            "L'enregistrement prend trop de temps. Appuyez a nouveau sur Enregistrer.",
          saveFailed:
            "Nous n'avons pas pu enregistrer le numero de telephone. Veuillez reessayer.",
          updated: "Numero de telephone enregistre",
          verified: "Ce numero de telephone est deja verifie.",
          termsLead:
            "En cochant cette case, je confirme avoir lu et accepter les",
          termsLink: "Conditions d'utilisation",
          termsJoiner: "et la",
          privacyLink: "Politique de confidentialite",
          termsEnd: ".",
          verifyLater: "",
        },
        dob: {
          title: "Modifier la date de naissance",
          subtitle:
            "Assurez-vous que cela correspond a votre date de naissance sur votre piece d'identite officielle.",
          label: "Date de naissance",
          placeholder: "JJ MMM, AAAA",
          updated: "Date de naissance mise a jour",
        },
        about: {
          title: "A propos de vous",
          subtitle: "Presentez-vous a vos patients",
          label: "A propos de vous",
          placeholder:
            "Parlez aux patients de votre parcours, de votre experience et de votre approche.",
          counter: "{count}/{max} caracteres",
          minimum: "{min} caracteres minimum requis",
          updated: "Section a propos mise a jour",
          folaTitle:
            "Puis-je vous aider a rediger une biographie professionnelle aujourd'hui ?",
          folaLoading: "Analyse de vos qualifications...",
          folaApply: "Appliquer le brouillon de Fola",
        },
        organDonor: {
          title: "Donneur d'organes",
          subtitle:
            "Choisissez si vous etes inscrit comme donneur d'organes. Vous pouvez modifier cette preference a tout moment et en discuter avec votre medecin.",
          discardTitle: "Ignorer les modifications ?",
          discardBody:
            "Vous avez des modifications non enregistrees concernant votre preference de don d'organes. Voulez-vous vraiment fermer sans enregistrer ?",
        },
        email: {
          title: "Modifier votre email",
          subtitleLink:
            "Nous vous enverrons un lien de verification pour confirmer cet email.",
          subtitleCode:
            "Nous vous enverrons un code a 6 chiffres pour confirmer cet email.",
          label: "Email",
          placeholder: "vous@exemple.com",
          verified: "Cet email est deja verifie.",
          enterEmail: "Saisissez une adresse email.",
          invalidEmail: "Saisissez une adresse email valide.",
          sendFailed: "Nous n'avons pas pu envoyer l'email. Veuillez reessayer.",
          linkSent: "Nous avons envoye un lien de verification a {email}",
          checkInbox:
            "Consultez votre email et ouvrez le lien de verification envoye a",
          sendVerificationLink: "Envoyer le lien de verification",
          sending: "Envoi...",
          checking: "Verification...",
          verifiedAction: "J'ai verifie",
          updated: "Email verifie",
          notVerifiedYet:
            "Pas encore verifie. Ouvrez le lien dans votre email puis reessayez.",
          notAuthenticated: "Non authentifie. Veuillez vous reconnecter.",
          sendCodeFailed:
            "Nous n'avons pas pu envoyer le code. Veuillez reessayer.",
          forbidden:
            "Interdit (politique serveur). Nous devons corriger la regle cote backend.",
          enterCode: "Saisissez le code a 6 chiffres.",
          codeExpired: "Ce code a expire. Renvoyez-en un nouveau.",
          incorrectCode: "Code incorrect. Veuillez reessayer.",
          verifyFailed: "La verification a echoue. Veuillez reessayer.",
          stillSending: "Envoi en cours...",
          waitBeforeResend: "Veuillez attendre {seconds}s avant de renvoyer.",
          sendDisabled: "L'envoi est actuellement desactive.",
          resendIn: "Renvoyer dans {seconds}s",
          sendCode: "Envoyer le code",
          enterSentCode: "Saisissez le code a 6 chiffres envoye a",
          codeLabel: "Code de verification",
          codePlaceholder: "123456",
          verifying: "Verification...",
          verify: "Verifier",
        },
        address: {
          title: "Modifier l'adresse",
          subtitle: "Assurez-vous de saisir correctement votre adresse.",
          locationUnavailable: "La localisation n'est pas disponible dans ce navigateur.",
          lookupFailed:
            "Localisation trouvee, mais la recherche d'adresse a echoue. Vous pouvez modifier manuellement.",
          permissionDenied:
            "Autorisation de localisation refusee. Activez l'acces a la localisation pour le remplissage rapide.",
          locationTimeout: "La demande de localisation a expire. Veuillez reessayer.",
          locationFailed: "Impossible d'obtenir votre localisation.",
          signInRequired: "Veuillez vous connecter pour enregistrer votre adresse.",
          saveFailed:
            "Nous n'avons pas pu enregistrer votre adresse. Veuillez reessayer.",
          locating: "Localisation...",
          useCurrentLocation: "Utiliser ma position actuelle",
          line1Label: "Adresse",
          line1Placeholder: "Numero, Rue",
          line2Label: "Adresse (ligne 2)",
          line2Placeholder: "Ville, Quartier",
          postalLabel: "Code postal",
          postalPlaceholder: "Code postal",
          countryLabel: "Pays",
          quickFillTitle: "Remplir l'adresse automatiquement ?",
          quickFillBodyPatient:
            "Nous pouvons utiliser votre position actuelle pour remplir rapidement votre adresse de domicile afin que vous n'ayez pas a la saisir manuellement.",
          quickFillBodyDoctor:
            "Nous pouvons utiliser votre position actuelle pour remplir rapidement votre adresse et afficher les etablissements proches.",
          quickFillAction: "Oui, remplissage rapide",
          locationNameLabel: "Nom du lieu",
          locationNamePlaceholder: "Commencez a saisir le nom de l'etablissement...",
          buildingTypeLabel: "Type de batiment",
          buildingTypePlaceholder: "Hopital",
          doctorLine1Placeholder: "Seogoditshane Way, 5th floor, 507",
          cityLabel: "Ville",
          cityPlaceholder: "Gaborone",
          buildingTypeDescription:
            "Choisissez le type de batiment qui decrit le mieux votre localisation.",
          addBuildingTypeLabel: "Ajouter un type de batiment",
          addBuildingTypePlaceholder: "ex. laboratoire de diagnostic",
          permissionsBlocked:
            "L'adresse de consultation ne peut pas etre mise a jour pour le moment en raison des permissions. Les donnees n'ont pas ete enregistrees dans la base.",
        },
        idPassport: {
          submitted: "ID / Passeport envoye pour verification",
          signInRequired: "Vous devez etre connecte.",
          statusReadFailed: "Impossible de lire le statut de verification.",
          awaitingReview: "Document recu. En attente de revision.",
        },
        registrationUpload: {
          title: "Document d'inscription",
          subtitle:
            "Telechargez une copie nette de votre inscription au conseil",
          addTitle: "Ajouter votre document d'inscription",
          addAction: "Ajouter",
          changeFile: "Changer le fichier",
          addMore: "Ajouter plus",
          existingNotice:
            "Un document d'inscription existe deja depuis le {date}. Telechargez-en un nouveau pour le remplacer.",
          status: {
            done: "Inscription reconnue",
            failed: "La verification a echoue",
          },
          saveOcrFailed:
            "Impossible d'enregistrer les resultats OCR.",
          analysisFailed:
            "L'analyse du document a echoue. Veuillez essayer un autre fichier.",
          statusReadFailed:
            "Impossible de lire le statut de verification.",
          summary: {
            registrationNumber: "N d'inscription",
            practitionerName: "Nom complet (praticien)",
            specialty: "Specialite / Categorie",
            practitionerFallback: "Praticien",
          },
          retention: "Conserve jusqu'au {date}.",
          consent:
            "En telechargeant, vous autorisez AfriMed a stocker ce document avec un chiffrement de bout en bout pour verification. Il sera conserve jusqu'a 90 jours.",
          alt: {
            verified: "Verifie",
            documentPreview: "Apercu du document d'inscription",
          },
        },
        registrationDetails: {
          title: "Details d'inscription",
          subtitle: "Gardez vos informations d'inscription a jour.",
          signInRequired: "Vous devez etre connecte.",
          saveFailed:
            "Impossible d'enregistrer les details d'inscription.",
          savedPending:
            "Modifications enregistrees (verification en attente)",
          expiryPast:
            "La date d'expiration ne peut pas etre dans le passe. Choisissez aujourd'hui ou une date future.",
          yearsRange: "Saisissez une valeur entre 1 et 60.",
          suggestions: {
            other: "Autre",
          },
          fields: {
            number: {
              label: "Numero d'inscription",
              placeholder: "ex. BMD 12345",
            },
            issuer: {
              label: "Autorite de delivrance",
              placeholder: "Selectionnez ou saisissez l'autorite",
            },
            issueDate: {
              label: "Date de delivrance",
            },
            expiryDate: {
              label: "Date d'expiration",
            },
            datePlaceholder: "DD MMM, YYYY",
            yearsExperience: {
              label: "Annees d'experience",
              placeholder: "ex. 12",
            },
          },
        },
      },
    },
    messages: {
      loadingConversation: "Chargement de la conversation...",
      noMessagesYet: "Aucun message pour le moment.",
      writeMessage: "Ecrire un message...",
      composeModal: {
        title: "Nouvelle conversation",
        addParticipants: "Ajouter des participants",
        close: "Fermer",
        types: {
          doctorPatient: "Medecin-Patient",
          doctorDoctor: "Medecin-Medecin",
          group: "Conversation de groupe",
        },
        typeDescriptions: {
          doctorPatient:
            "Communication securisee avec les patients pour les consultations medicales",
          doctorDoctor:
            "Collaboration professionnelle avec d'autres soignants",
          group:
            "Discussions a plusieurs participants pour la coordination d'equipe",
        },
        conversationTitle: "Titre de la conversation (facultatif)",
        conversationTitlePlaceholder:
          "Saisissez un titre pour cette conversation...",
        autoGenerateHint:
          "Laissez vide pour le generer automatiquement selon les participants",
        searchUsers: "Rechercher des utilisateurs",
        searchPlaceholder: "Rechercher par nom...",
        selectedParticipants: "Participants selectionnes ({count})",
        searchResults: "Resultats de recherche",
        unknownUserInitial: "U",
        unknownUser: "Utilisateur inconnu",
        noUsersFound: "Aucun utilisateur trouve",
        startTyping:
          "Commencez a saisir pour rechercher des utilisateurs",
        back: "Retour",
        cancel: "Annuler",
        nextAddParticipants: "Suivant : ajouter des participants",
        createConversation: "Creer la conversation",
        chatWith: "Conversation avec {name}",
        groupChatMembers: "Conversation de groupe ({count} membres)",
      },
      inbox: {
        search: "Rechercher",
        searchRecipients: "Rechercher des destinataires",
        clearSearch: "Effacer la recherche",
        openFola: "Ouvrir la conversation Fola",
        newMessage: "Nouveau message",
        title: "Messages",
        composeTitle: "Nouveau message",
        loadingRecipientsTitle: "Chargement des destinataires",
        loadingRecipientsBody:
          "Veuillez patienter pendant le chargement des personnes que vous pouvez contacter.",
        opening: "Ouverture...",
        new: "Nouveau",
        noRecipientsMatch:
          "Aucun destinataire ne correspond a votre recherche.",
        noRecipientsTitle: "Aucun destinataire pour le moment",
        noRecipientsBody:
          "Les destinataires apparaitront ici des que vous aurez un rendez-vous ou une conversation existante.",
        noConversationsMatch:
          "Aucune conversation ne correspond a votre recherche.",
        loadingMessagesTitle: "Chargement des messages",
        loadingMessagesBody:
          "Veuillez patienter pendant la recuperation de vos dernieres conversations.",
        emptyTitle: "Aucun message a afficher",
        emptyBody: "Votre boite de reception est vide pour le moment. Revenez plus tard.",
        noMessagesPreview: "Aucun message pour le moment.",
      },
      conversation: {
        now: "Maintenant",
        deletedForMe: "Vous avez supprime ce message",
        deletedBySender: "L'expediteur a supprime le message",
        deleteDialog: {
          close: "Fermer la boite de suppression",
          title: "Supprimer le message ?",
          body:
            "Supprimez ce message pour vous uniquement ou retirez-le pour les deux participants. Cette action est irreversible.",
          deleting: "Suppression...",
          forMe: "Supprimer pour moi",
          forBoth: "Supprimer pour les deux",
        },
        toast: {
          dismiss: "OK",
          undo: "Annuler",
          deletedForMe: "Message supprime pour moi",
          deletedForBoth: "Message supprime pour les deux",
          deleteError: "Impossible de supprimer le message pour le moment.",
        },
        composer: {
          all: "Tous",
          attach: "Joindre une photo",
          send: "Envoyer le message",
          thinking: "Fola reflechit",
          selectedAttachmentAlt: "Piece jointe selectionnee",
        },
        topBar: {
          back: "Retour aux messages",
          openFola: "Ouvrir la conversation Fola",
          compose: "Rediger un message",
        },
      },
    },
    appointments: {
      nearby: {
        pageTitle: "Rendez-vous",
      },
      book: {
        title: "Choisissez une date et une heure",
        doctorMissing:
          "Medecin introuvable. Revenez en arriere et selectionnez de nouveau un medecin.",
        backToDoctors: "Retour aux medecins",
        sections: {
          service: "Selectionner un service",
          date: "Date",
          time: "Heure",
          payment: "Selectionnez votre mode de paiement",
        },
        selectDate: "Selectionner une date",
        minutesShort: "{count} min",
        loading: {
          services: "Chargement des services du medecin...",
          dates: "Chargement des dates disponibles...",
          times: "Chargement des heures disponibles...",
          payments: "Chargement des moyens de paiement du medecin...",
        },
        empty: {
          services: "Ce medecin n'a pas encore ajoute de services.",
          dates: "Ce medecin n'a pas encore ouvert de jours de rendez-vous.",
          unavailableDay:
            "Ce medecin n'est pas disponible le jour selectionne.",
          noTimes:
            "Aucun horaire de rendez-vous disponible ne reste pour ce jour.",
          payments:
            "Ce medecin n'a pas encore defini de moyens de paiement.",
        },
        errors: {
          loadServices:
            "Impossible de charger les services du medecin.",
          loadDates: "Impossible de charger les dates disponibles.",
          loadTimes: "Impossible de charger les heures disponibles.",
          loadPayments:
            "Impossible de charger les moyens de paiement.",
        },
        confirm: "Confirmer",
        fallbackServices: {
          evisit: "Consultation virtuelle",
          consultation: "Consultation",
        },
      },
      details: {
        title: "Details du rendez-vous",
        loading: "Chargement du rendez-vous...",
        notFound:
          "Rendez-vous introuvable. Revenez en arriere et ouvrez-le de nouveau.",
        backToAppointments: "Retour aux rendez-vous",
        visitType: {
          evisit: "Consultation virtuelle",
        },
        meetLabel: "Video AfriMed™",
        videoRoomLabel: "Salle de consultation AfriMed™ securisee",
        join: "Rejoindre",
        message: "Message",
        call: "Appel",
        ehr: {
          granted: "Acces accorde",
          grant: "Accorder l'acces",
          granting: "Attribution...",
        },
        sections: {
          time: "Selectionnez l'heure de votre rendez-vous",
          payment: "Mode de paiement",
        },
        cancelVisit: "Annuler la visite",
        editVisit: "Modifier la visite",
        cancelDialog: {
          title: "Annuler le rendez-vous ?",
          description:
            "Etes-vous sur de vouloir annuler ce rendez-vous ?",
          confirm: "Oui, annuler",
        },
        deleteDialog: {
          title:
            "Etes-vous sur de vouloir supprimer ce rendez-vous medical ?",
          description:
            "Apres avoir supprime l'enregistrement de ce rendez-vous medical, vous ne pourrez pas le recuperer.",
          confirm: "Supprimer",
        },
        toast: {
          rescheduleRequested:
            "Nouvelle demande d'horaire envoyee. En attente d'approbation.",
          confirmed: "Rendez-vous confirme",
          updated: "Rendez-vous mis a jour",
          deleted: "Votre rendez-vous a ete supprime",
          ehrGranted: "Acces EHR accorde",
        },
        errors: {
          load: "Impossible de charger le rendez-vous.",
          ehrMissing:
            "Les details du rendez-vous manquent pour l'acces EHR.",
          verifyAccount: "Impossible de verifier votre compte.",
          ehrGrant:
            "Impossible d'accorder l'acces EHR pour le moment.",
          cancel: "Impossible d'annuler le rendez-vous.",
        },
      },
      doctorIndex: {
        defaultFacilityName: "Etablissement principal non defini",
        patientFallback: "Patient",
        errorLoad: "Impossible de charger les rendez-vous.",
        loading: "Chargement des rendez-vous...",
        emptyTitle: "Aucun rendez-vous a afficher",
        emptyBody: "Votre boite de reception est vide pour le moment. Revenez plus tard.",
        selectDay: "Selectionner le jour {day}",
        viewMode: {
          label: "Mode d'affichage",
          day: "Jour",
          week: "Semaine",
          month: "Mois",
          list: "Liste",
        },
        list: {
          freeSchedule: "Planning libre",
          allDay: "Toute la journee",
        },
        snackbar: {
          rescheduled:
            "Le rendez-vous a ete deplace au {date}. En attente d'acceptation du patient.",
          review: "Examiner",
          cancelled: "Rendez-vous annule",
        },
      },
      directory: {
        common: {
          filter: "Filtrer",
          loading: "Chargement...",
          centerMap: "Centrer la carte",
        },
        hospitals: {
          search: "Rechercher des hopitaux",
          nearby: "A proximite",
          empty: "Aucun hopital trouve.",
          favoriteAria: "Hopital favori",
        },
        pharmacies: {
          title: "Pharmacies",
          subtitle: "Pharmacies pres de vous",
          search: "Rechercher des pharmacies",
          empty: "Aucune pharmacie trouvee.",
          favoriteAria: "Pharmacie favorite",
          filter: {
            data: "Donnees",
            payment: "Moyens de paiement",
            apply: "Appliquer",
            options: {
              "best-rating": "Meilleure note",
              "near-you": "Pres de vous",
              cards: "Cartes de credit et de debit",
              "bank-transfer": "Virements bancaires",
              ewallet: "Portefeuilles numeriques",
              "instant-eft": "EFT instantane",
            },
          },
        },
        ambulances: {
          title: "Ambulance",
          subtitle: "Ambulances pres de vous",
          favoriteAria: "Ambulance favorite",
          filter: {
            data: "Donnees",
            payment: "Moyens de paiement",
            apply: "Appliquer",
            options: {
              "best-rating": "Meilleure note",
              "near-you": "Pres de vous",
              cards: "Cartes de credit et de debit",
              "bank-transfer": "Virements bancaires",
              ewallet: "Portefeuilles numeriques",
              "instant-eft": "EFT instantane",
            },
          },
        },
      },
    },
    onboarding: {
      category: {
        continue: "Continuer",
        options: {
          doctor: {
            title: "Medecin",
            desc: "Rejoignez AfriMed™ en tant que medecin agree et fournissez des soins experts.",
          },
          patient: {
            title: "Patient",
            desc: "Inscrivez-vous pour acceder a des cliniciens de confiance, a vos dossiers electroniques et a vos prescriptions electroniques.",
          },
          research: {
            title: "Recherche • santé publique",
            desc: "Rejoignez AfriMed™ en tant que chercheur, professionnel de santé publique, agent de santé communautaire, membre du personnel de programme ou d'une équipe de terrain afin de soutenir des programmes gouvernés de recherche et de santé des populations.",
          },
          employer: {
            title: "Employeur",
            desc: "Offrez a vos employes un acces a des soins de qualite. Une main-d'oeuvre en bonne sante favorise une organisation en bonne sante.",
          },
          moh: {
            title: "Ministere de la Sante",
            desc: "Faites progresser la couverture sante universelle en integrant les citoyens a AfriMed™.",
          },
        },
      },
      email: {
        title: "Email",
        subtitle:
          "Saisissez correctement votre email pour recevoir des mises a jour et des notifications.",
        placeholder: "Email",
        continue: "Continuer",
      },
      emailEdit: {
        title: "Votre adresse email",
        subtitle:
          "Nous utiliserons cet email pour les mises a jour et notifications, uniquement si necessaire. Si vous devez le modifier plus tard, vous pourrez le faire dans les Parametres.",
        saveContinue: "Enregistrer et continuer",
        label: "Email",
        placeholder: "vous@exemple.com",
        verified: "Verifie",
      },
      name: {
        title: "Vos noms complets",
        subtitle:
          "Assurez-vous que cela correspond aux noms figurant sur votre piece d'identite officielle.",
        saving: "Enregistrement...",
        continue: "Continuer",
        firstLabel: "Prenom",
        firstPlaceholder: "Prenom(s) sur la piece d'identite",
        lastLabel: "Nom de famille sur la piece d'identite",
        lastPlaceholder: "Nom(s) de famille sur la piece d'identite",
        clearFirst: "Effacer le prenom",
        clearLast: "Effacer le nom de famille",
        sessionNotReady:
          "Votre session n'est pas encore prete. Veuillez reessayer.",
        saveError: "Impossible d'enregistrer. Veuillez reessayer.",
        saveRequest: "Enregistrer le nom",
      },
      phone: {
        title: "Votre numero de telephone",
        saving: "Enregistrement...",
        continue: "Continuer",
        invalidPhone: "Saisissez un numero de telephone valide.",
        invalidPhoneLength:
          "Veuillez saisir un numero de telephone valide (7-12 chiffres).",
        mustAccept:
          "Veuillez accepter les Conditions et la Politique de confidentialite pour continuer.",
        termsLead:
          "En cochant cette case, je confirme avoir lu et accepter les",
        termsLink: "Conditions d'utilisation",
        termsJoiner: "et la",
        privacyLink: "Politique de confidentialite",
        termsEnd: ".",
      },
      otp: {
        title: "Verification du telephone (bientot disponible)",
        subtitle:
          "Nous avons enregistre votre numero pour la verification WhatsApp dans la prochaine version. Vous pouvez continuer pour l'instant.",
        continue: "Continuer",
        phoneNumber: "Numero de telephone",
        notProvided: "Non fourni",
        note:
          "Note : la verification SMS est desactivee en staging pendant notre transition vers un onboarding priorisant WhatsApp.",
      },
      passcodeConfirm: {
        title: "Code d'acces",
        subtitle: "Protegez votre compte avec un code de securite",
        saving: "Enregistrement...",
        continue: "Continuer",
        confirm: "Confirmer le code",
        mismatch: "Les codes ne correspondent pas. Veuillez reessayer.",
        sessionExpired: "Session expiree. Veuillez vous reconnecter.",
        saveError: "Echec de l'enregistrement du code",
      },
      passcodeCreate: {
        title: "Code d'acces",
        subtitle: "Protegez votre compte avec un code de securite",
        continue: "Continuer",
        create: "Creer le code",
      },
      dob: {
        title: "Date de naissance",
        subtitle:
          "Assurez-vous que cela correspond au nom figurant sur votre piece d'identite officielle",
        saving: "Enregistrement...",
        continue: "Continuer",
        label: "Date de naissance",
        placeholder: "JJ-MM-AAAA",
        done: "Valide",
        saveError: "Impossible d'enregistrer. Veuillez reessayer.",
        timeout:
          "Delai reseau depasse pendant l'enregistrement. Veuillez reessayer (ou changer de reseau).",
      },
      idPassport: {
        title: "Piece d'identite nationale • Passeport",
        subtitle:
          "Saisissez votre numero d'identite/passeport ou la ligne MRZ (30 caracteres).",
        continue: "Continuer",
        verifying: "Verification...",
        label: "Identite / Passeport",
        placeholder: "A12345678  ·  ou ligne MRZ",
        done: "Valide",
        invalidHint:
          "Utilisez un numero de passeport ou collez une ligne MRZ de 30 caracteres.",
        processingTitle: "Traitement de l'identite",
        processingPending: "Analyse de votre document...",
        processingIdle: "Prenez une photo ou telechargez un scan net",
        working: "Traitement...",
        retake: "Reprendre",
        camera: "Camera",
        uploadFile: "Telecharger un fichier",
        aiProcessing: "Traitement IA",
        sessionNotReady: "Session non prete. Veuillez vous reconnecter.",
        fileTooLarge:
          "Fichier trop volumineux. Veuillez telecharger une image de moins de 5 Mo.",
        uploading: "Telechargement du document...",
        receivedExtracting: "Document recu. Extraction des details...",
        uploadFailed: "Echec du telechargement. Veuillez reessayer.",
        retention: "Confidentialite : le stockage chiffre expire le {date}.",
        status: {
          pending: "Analyse du document...",
          done: "Identite recue",
          failed: "Echec du traitement",
          received: "Document recu",
          idle: "Traitement...",
        },
        alt: {
          passed: "Valide",
          failed: "Echec",
          received: "Recu",
        },
        summary: {
          surname: "Nom",
          idNumber: "N° d'identite",
          dob: "Date de naissance",
          expiry: "Date d'expiration",
          givenNames: "Prenoms",
        },
      },
      languages: {
        title: "Ajouter des langues",
        searchPlaceholder: "Rechercher ou ajouter",
        clearSearch: "Effacer la recherche",
        addLanguage: "Ajouter une langue",
        helper: "Selectionnez toutes les langues que vous parlez.",
        noMatches: "Aucune langue ne correspond a votre recherche.",
        continue: "Continuer",
        saving: "Enregistrement...",
        sessionExpired: "Session expiree",
        saveError: "Impossible d'enregistrer les langues",
      },
    },
    fola: {
      widget: {
        title: "Fola - Assistant AfriMed",
        greeting:
          "Bonjour, je suis Fola. Je peux aider avec les OTP, les magic links et les reglages.",
        placeholder: "Demandez a Fola...",
        send: "Envoyer",
        error: "Desole, un probleme est survenu. Reessayez.",
      },
    },
  },
  de: {
    common: {
      back: "Zuruck",
      cancel: "Abbrechen",
      change: "Andern",
      close: "Schliessen",
      continue: "Weiter",
      discard: "Verwerfen",
      changesSaved: "Anderungen gespeichert",
      keepEditing: "Weiter bearbeiten",
      no: "Nein",
      save: "Speichern",
      saving: "Speichert...",
      yes: "Ja",
      loggingOut: "Wird abgemeldet...",
      logout: "Abmelden",
      loading: "Wird geladen...",
      manage: "Verwalten",
      open: "Offnen",
      comingSoon: "Kommt bald",
      legal: {
        terms: "AGB",
        privacy: "Datenschutz",
        dataDeletion: "Datenloschung",
        copyright: "© {year} AfriMed™ Telehealth",
      },
    },
    auth: {
      login: {
        sheetMethodLabel: "Anmeldemethode wahlen",
        methods: {
          email: "E-Mail",
          phone: "Telefon",
        },
        sheet: {
          email: "E-Mail",
          emailPlaceholder: "du@beispiel.com",
          sendMagicLink: "Magic Link senden",
          sending: "Wird gesendet...",
          phoneLabel: "Landesvorwahl, Telefonnummer",
          continue: "Weiter",
          phoneSaved:
            "Als ausstehende Verifizierung gespeichert. Melde dich jetzt mit E-Mail an, um fortzufahren.",
          phoneHint:
            "Die Telefonverifizierung ist vorubergehend nicht verfugbar.",
          invalidPhone:
            "Gib eine gultige SADC/Diaspora-Nummer ein.",
          invalidPhoneLength:
            "Bitte gib eine gultige Telefonnummer ein (7-12 Ziffern).",
          cooldown:
            "Du kannst in {seconds}s einen neuen Link anfordern.",
          waitBeforeRetry:
            "Bitte warte {seconds}s, bevor du einen weiteren Link anforderst.",
          rateLimit:
            "Zu viele Anfragen. Bitte warte 1 Minute und versuche es erneut.",
          loginOnlyMode:
            "Wir konnten dich mit diesem Link nicht anmelden. Fordere einen neuen Magic Link an und offne die neueste E-Mail.",
          emailUnavailable:
            "Die E-Mail-Anmeldung ist vorubergehend nicht verfugbar. Bitte versuche es in Kurze erneut oder nutze Google/Facebook.",
          networkIssue:
            "Netzwerkproblem beim Senden des Links. Bitte versuche es erneut.",
          linkSent:
            "Wir haben dir einen Anmeldelink gesendet. Offne ihn auf diesem Browser/Gerat.",
          close: "Schliessen",
          manageCookies: "Cookies verwalten",
          complianceLine:
            "HIPAA- und GDPR-konforme digitale Gesundheitsinfrastruktur.",
        },
        landing: {
          title: "Willkommen bei AfriMed™",
          line1: "Lass uns gemeinsam den Weg zu besserer",
          line2: "Gesundheit gehen!",
          registerEmail: "Mit E-Mail registrieren",
          registerFacebook: "Mit Facebook registrieren",
          registerGoogle: "Mit Google registrieren",
          login: "Anmelden",
          trouble: "Probleme bei der Anmeldung?",
          trial: "14-tagige Gratisphase starten",
          journey: "Dein Weg zur Versorgung",
        },
      },
      resetPassword: {
        invalidLink:
          "Dieser Link ist ungueltig oder abgelaufen. Bitte fordere einen neuen an.",
        missingLink: "Wiederherstellungslink fehlt oder ist ungueltig.",
        updateError:
          "Dein Passwort konnte nicht aktualisiert werden. Bitte versuche es erneut.",
        title: "Neues Passwort festlegen",
        intro: "Erstelle ein neues Passwort fuer dein Konto.",
        successTitle: "Passwort zurueckgesetzt",
        successIntro:
          "Dein Passwort wurde aktualisiert. Du kannst dich jetzt mit E-Mail und Passwort anmelden.",
        newPassword: "Neues Passwort",
        newPasswordHelper: "Mindestens 8 Zeichen",
        confirmPassword: "Passwort bestaetigen",
        saving: "Wird gespeichert...",
        save: "Neues Passwort speichern",
        requestNewLink: "Neuen Reset-Link anfordern",
        backToLogin: "Zuruck zur Anmeldung",
      },
      demo: {
        title: "Demo-Zugang",
        intro: "Nutze ein vorausgefuelltes Konto, um AfriMed™ zu erkunden.",
        form: {
          emailRequired: "E-Mail-Adresse ist erforderlich",
          passwordRequired: "Passwort ist erforderlich",
          signInError: "Anmeldung nicht moeglich.",
          networkError:
            "Netzwerkfehler. Bitte pruefe deine Verbindung und versuche es erneut.",
          errorTitle: "Authentifizierung fehlgeschlagen",
          copyError: "Fehlermeldung kopieren",
          dismiss: "Schliessen",
          emailLabel: "E-Mail-Adresse",
          emailPlaceholder: "Gib deine E-Mail-Adresse ein",
          passwordLabel: "Passwort",
          passwordPlaceholder: "Gib dein Passwort ein",
          rememberMe: "Angemeldet bleiben",
          forgotPassword: "Passwort vergessen?",
          signingIn: "Anmeldung laeuft...",
          signIn: "Anmelden",
          demoTitle: "Demo-Zugangsdaten verfuegbar",
          demoIntro: "Nutze diese Demo-Konten, um die Plattform zu testen",
          doctorAccount: "Arztkonto",
          patientAccount: "Patientenkonto",
          patientJane: "Patientenkonto (Jane)",
        },
      },
      signUp: {
        title: "Willkommen bei AfriMed™",
        subtitle: "Erstelle dein Konto, um fortzufahren.",
        rolePatient: "Patient",
        roleDoctor: "Arzt",
        continueWithGoogle: "Mit Google fortfahren",
        continueWithEmail: "oder mit E-Mail fortfahren",
        email: "E-Mail",
        emailPlaceholder: "du@domain.com",
        password: "Passwort",
        passwordPlaceholder: "Starkes Passwort",
        createAccount: "Konto erstellen",
        existingAccount: "Hast du bereits ein Konto?",
        forgotPassword: "Passwort vergessen?",
      },
      forgotPassword: {
        title: "Passwort zuruecksetzen",
        intro: "Gib deine E-Mail-Adresse ein und wir senden dir einen sicheren Link, um ein neues Passwort zu erstellen.",
        email: "E-Mail",
        emailPlaceholder: "du@beispiel.com",
        sendLink: "Reset-Link senden",
        sending: "Wird gesendet...",
        sendError:
          "Der Link zum Zuruecksetzen des Passworts konnte nicht gesendet werden. Bitte versuche es erneut.",
        backToLogin: "Zuruck zur Anmeldung",
        usePhoneInstead: "Telefon verwenden",
        checkEmail: "Pruefe deine E-Mails auf den sicheren Link zum Zuruecksetzen des Passworts.",
      },
      idleLogout: {
        title: "Bist du noch da?",
        bodyLead: "Zu deiner Sicherheit melden wir dich in",
        bodyEnd: "ab, wenn keine Aktivitat erkannt wird.",
        logOut: "Abmelden",
        staySignedIn: "Angemeldet bleiben",
      },
    },
    home: {
      patient: {
        welcome: "Willkommen, {firstName}!",
        actions: {
          openProfile: "Profil offnen",
          notifications: "Benachrichtigungen",
          viewAll: "Alle ansehen",
        },
        appointments: {
          title: "Deine Termine",
          tabs: {
            upcoming: "Bevorstehend",
            past: "Vergangen",
            pending: "Warten auf Freigabe",
          },
          empty: {
            title: "Noch keine Termine",
            body: "Buche einen Arzttermin, um deine Versorgung zu beginnen.",
          },
          bookAction: "Termin buchen",
          error:
            "Deine Termine werden geladen. Bitte versuche es gleich noch einmal.",
        },
        serviceCategories: {
          title: "Leistungskategorien",
          doctors: "Arzte",
          hospitals: "Krankenhauser",
          pharmacies: "Apotheken",
          ambulances: "Ambulanzen",
        },
        popularServices: {
          title: "Beliebte Leistungen",
          action: "Alle Leistungen",
        },
        nearby: {
          title: "Gesundheitsversorgung in deiner Nahe",
          action: "Versorgung in meiner Nahe finden",
          selectedFacility: "Ausgewahlte Einrichtung",
          seeDoctors: "Arzte in dieser Einrichtung ansehen",
          loading: "Nahegelegene Einrichtungen werden geladen...",
          findDoctors: "Arzte finden",
          searchPlaceholder: "Einrichtungen suchen",
          clearSearch: "Suche loschen",
          showingNear: "Einrichtungen in der Nahe von",
          clearSelectedFacility: "Ausgewahlte Einrichtung entfernen",
          defaultFacilityName: "Gesundheitseinrichtung",
        },
        verifyIdentity: {
          title: "Bestatige deine Identitat",
          body: "Verifizierte Profile schaffen mehr Vertrauen.",
          pending: "Prufung ausstehend",
          action: "Jetzt verifizieren",
        },
      },
      doctor: {
        fallbackName: "Arzt",
        patientFallback: "Patient",
        consultancyFallback: "Konsultation",
        welcome: "Willkommen Dr {surname}",
        specialtyFallback: "Arzt",
        actions: {
          openProfile: "Profil offnen",
          dashboard: "Dashboard",
          notifications: "Benachrichtigungen",
          viewAll: "Alle anzeigen",
        },
        appointments: {
          title: "Deine Termine",
          loading: "Termine werden geladen...",
          loadingError:
            "Deine Termine werden geladen. Bitte aktualisiere gleich noch einmal.",
          error: "Termine konnten nicht geladen werden.",
          emptyTitle: "Du hast keine geplanten Termine.",
          emptyBody:
            "Bestatigte Termine erscheinen hier, sobald Patientinnen oder Patienten sie bestatigen.",
          tabs: {
            today: "Heute",
            todayCount: "Heute {count}",
            upcoming: "Bevorstehend",
            upcomingCount: "Bevorstehend {count}",
            pending: "Warten auf Freigabe",
            pendingCount: "Warten auf Freigabe {count}",
          },
        },
        elevate: {
          title: "Starke deine Konsultation",
        },
        gallery: {
          title: "Lass dein Profil hervorstechen",
          body: "Fuge Bilder zu deiner Konsultation hinzu",
          notNow: "Jetzt nicht",
        },
        regional: {
          title: "Regionale Gesundheit",
          headline: "Bleib informiert uber die",
          defaultSummary: "Gesundheitstrends und Zustande",
          facilitySummary: "{count} kartierte Einrichtungen und Trends",
        },
      },
    },
    settings: {
      home: {
        title: "Einstellungen",
        userFallback: "Nutzer",
        loginSecurity: "Anmeldung und Sicherheit",
        language: "Sprache",
        availability: "Verfugbarkeit",
        notifications: "Benachrichtigungen",
        preferences: "Einstellungen",
        legal: "Rechtliches",
        faq: "FAQ",
        logoutDialog: {
          title: "Mochtest du dich wirklich abmelden?",
          body: "Du musst dich erneut anmelden, um fortzufahren.",
        },
      },
      welcome: {
        fallbackName: "da",
        title: "Willkommen {name} in deinen Einstellungen",
        doctorBody:
          "Die Einstellungen sind deine Schaltzentrale, in der du dein Profilbild, deine Terminzeiten sowie Konto, Zahlungen, Benachrichtigungen und vieles mehr verwaltest.",
        patientBody:
          "Die Einstellungen sind deine Schaltzentrale, in der du dein Profilbild sowie Sicherheit, Zahlungen, Benachrichtigungen und mehr verwaltest.",
      },
      preferences: {
        title: "Einstellungen",
        sections: {
          app: "App",
          account: "Konto",
        },
        appearance: {
          title: "Darstellung",
          subtitle: "Systemdesign, hell oder dunkel verwenden",
        },
        language: {
          title: "Sprache",
        },
        news: {
          title: "Neuigkeiten und Updates",
          subtitle: "E-Mail- und Push-Einstellungen",
        },
        notifications: {
          title: "Benachrichtigungen",
          subtitle: "Neuigkeiten, Updates und lokale Vorgaben",
        },
        notificationInbox: {
          title: "Benachrichtigungsfach",
          subtitle: "Dringende, ungelesene und Termin-Updates",
        },
        accessibility: {
          title: "Barrierefreiheit und Fola",
          subtitle: "Assistive Optionen und KI-Unterstutzung",
        },
        plans: {
          title: "Plane und Abos",
          subtitle: "Dein AfriMedTM Tarif und Erweiterungen",
        },
        transactions: {
          title: "Transaktionen und Rechnungen",
          subtitle: "Verlauf ansehen und Belege herunterladen",
        },
        downloads: {
          title: "Downloads",
          subtitle: "Daten, Berichte und Zusammenfassungen exportieren",
        },
        closeAccount: {
          title: "Konto schliessen, pausieren oder loschen",
          subtitle: "Wir zeigen zuerst sicherere Optionen",
        },
      },
      language: {
        title: "Sprache",
        changedTo: "Sprache geandert zu {language}",
      },
      edit: {
        common: {
          saveFailed:
            "Die Anderungen konnten nicht gespeichert werden. Bitte versuche es erneut.",
          sessionNotReady:
            "Deine Sitzung ist noch nicht bereit. Bitte versuche es erneut.",
        },
        name: {
          title: "Name bearbeiten",
          subtitle:
            "Bitte stelle sicher, dass dies mit dem Namen auf deinem amtlichen Ausweis ubereinstimmt.",
          firstLabel: "Vorname auf dem Ausweis",
          firstPlaceholder: "Vorname(n) auf dem Ausweis",
          lastLabel: "Nachname auf dem Ausweis",
          lastPlaceholder: "Nachname(n) auf dem Ausweis",
          clearFirst: "Vorname loschen",
          clearLast: "Nachname loschen",
          updated: "Name aktualisiert",
        },
        phone: {
          title: "Deine Telefonnummer bearbeiten",
          subtitle:
            "Fuge deine Telefonnummer hinzu, damit wir dich bei Bedarf kontaktieren konnen",
          invalidPhone: "Bitte gib zuerst eine gultige Telefonnummer ein.",
          mustAccept: "Bitte akzeptiere zuerst die Bedingungen.",
          invalidPhoneLength:
            "Bitte gib eine gultige Telefonnummer ein (7-12 Ziffern).",
          timeout:
            "Das Speichern dauert zu lange. Tippe erneut auf Speichern.",
          saveFailed:
            "Die Telefonnummer konnte nicht gespeichert werden. Bitte versuche es erneut.",
          updated: "Telefonnummer gespeichert",
          verified: "Diese Telefonnummer ist bereits verifiziert.",
          termsLead:
            "Mit dem Aktivieren dieses Kontrollkastchens bestatige ich, dass ich die",
          termsLink: "Nutzungsbedingungen",
          termsJoiner: "und die",
          privacyLink: "Datenschutzerklarung",
          termsEnd: ".",
          verifyLater: "",
        },
        dob: {
          title: "Geburtsdatum bearbeiten",
          subtitle:
            "Bitte stelle sicher, dass dies mit deinem Geburtsdatum auf deinem amtlichen Ausweis ubereinstimmt.",
          label: "Geburtsdatum",
          placeholder: "TT MMM, JJJJ",
          updated: "Geburtsdatum aktualisiert",
        },
        about: {
          title: "Uber dich",
          subtitle: "Stell dich deinen Patientinnen und Patienten vor",
          label: "Uber dich",
          placeholder:
            "Erzahle Patientinnen und Patienten etwas uber deinen Hintergrund, deine Erfahrung und deinen Ansatz.",
          counter: "{count}/{max} Zeichen",
          minimum: "Mindestens {min} Zeichen erforderlich",
          updated: "Bereich uber dich aktualisiert",
          folaTitle:
            "Kann ich dir heute helfen, eine professionelle Biografie zu schreiben?",
          folaLoading: "Deine Qualifikationen werden analysiert...",
          folaApply: "Folas Entwurf ubernehmen",
        },
        organDonor: {
          title: "Organspender",
          subtitle:
            "Wahle aus, ob du als Organspender registriert bist. Du kannst diese Einstellung jederzeit andern und mit deinem Arzt besprechen.",
          discardTitle: "Anderungen verwerfen?",
          discardBody:
            "Du hast ungespeicherte Anderungen an deiner Organspende-Einstellung. Mochtest du wirklich ohne Speichern schliessen?",
        },
        email: {
          title: "Deine E-Mail bearbeiten",
          subtitleLink:
            "Wir senden dir einen Bestatigungslink, um diese E-Mail zu bestaetigen.",
          subtitleCode:
            "Wir senden dir einen 6-stelligen Code, um diese E-Mail zu bestaetigen.",
          label: "E-Mail",
          placeholder: "du@beispiel.com",
          verified: "Diese E-Mail ist bereits verifiziert.",
          enterEmail: "Gib eine E-Mail-Adresse ein.",
          invalidEmail: "Gib eine gultige E-Mail-Adresse ein.",
          sendFailed:
            "Die E-Mail konnte nicht gesendet werden. Bitte versuche es erneut.",
          linkSent: "Wir haben einen Bestatigungslink an {email} gesendet",
          checkInbox:
            "Prufe deine E-Mails und offne den Bestatigungslink, den wir an folgende Adresse gesendet haben:",
          sendVerificationLink: "Bestatigungslink senden",
          sending: "Wird gesendet...",
          checking: "Wird gepruft...",
          verifiedAction: "Ich habe bestaetigt",
          updated: "E-Mail verifiziert",
          notVerifiedYet:
            "Noch nicht verifiziert. Offne bitte den Link in deiner E-Mail und versuche es erneut.",
          notAuthenticated: "Nicht authentifiziert. Bitte melde dich erneut an.",
          sendCodeFailed:
            "Der Code konnte nicht gesendet werden. Bitte versuche es erneut.",
          forbidden:
            "Verboten (Serverrichtlinie). Wir mussen die Backend-Regel korrigieren.",
          enterCode: "Gib den 6-stelligen Code ein.",
          codeExpired: "Dieser Code ist abgelaufen. Bitte sende einen neuen.",
          incorrectCode: "Falscher Code. Bitte versuche es erneut.",
          verifyFailed: "Verifizierung fehlgeschlagen. Bitte versuche es erneut.",
          stillSending: "Wird noch gesendet...",
          waitBeforeResend: "Bitte warte {seconds}s, bevor du erneut sendest.",
          sendDisabled: "Senden ist derzeit deaktiviert.",
          resendIn: "Erneut senden in {seconds}s",
          sendCode: "Code senden",
          enterSentCode: "Gib den 6-stelligen Code ein, der gesendet wurde an",
          codeLabel: "Bestatigungscode",
          codePlaceholder: "123456",
          verifying: "Wird verifiziert...",
          verify: "Verifizieren",
        },
        address: {
          title: "Adresse bearbeiten",
          subtitle: "Bitte stelle sicher, dass du deine Adresse korrekt eingibst.",
          locationUnavailable: "Standort ist in diesem Browser nicht verfugbar.",
          lookupFailed:
            "Standort gefunden, aber die Adresssuche ist fehlgeschlagen. Du kannst manuell weiterbearbeiten.",
          permissionDenied:
            "Standortberechtigung verweigert. Aktiviere den Standortzugriff fur das Schnell-Ausfullen.",
          locationTimeout: "Standortabfrage hat zu lange gedauert. Bitte versuche es erneut.",
          locationFailed: "Dein Standort konnte nicht ermittelt werden.",
          signInRequired: "Bitte melde dich an, um deine Adresse zu speichern.",
          saveFailed:
            "Deine Adresse konnte nicht gespeichert werden. Bitte versuche es erneut.",
          locating: "Standort wird ermittelt...",
          useCurrentLocation: "Meinen aktuellen Standort verwenden",
          line1Label: "Adresse",
          line1Placeholder: "Nummer, Strasse",
          line2Label: "Adresse (Zeile 2)",
          line2Placeholder: "Stadt, Stadtteil",
          postalLabel: "Postleitzahl",
          postalPlaceholder: "Postleitzahl",
          countryLabel: "Land",
          quickFillTitle: "Adresse automatisch ausfullen?",
          quickFillBodyPatient:
            "Wir konnen deinen aktuellen Standort verwenden, um deine Wohnadresse schnell auszufullen, damit du sie nicht manuell eingeben musst.",
          quickFillBodyDoctor:
            "Wir konnen deinen aktuellen Standort verwenden, um deine Adresse schnell auszufullen und Einrichtungen in deiner Nahe anzuzeigen.",
          quickFillAction: "Ja, schnell ausfullen",
          locationNameLabel: "Name des Standorts",
          locationNamePlaceholder: "Beginne mit der Eingabe des Einrichtungsnamens...",
          buildingTypeLabel: "Gebaudetyp",
          buildingTypePlaceholder: "Krankenhaus",
          doctorLine1Placeholder: "Seogoditshane Way, 5th floor, 507",
          cityLabel: "Stadt",
          cityPlaceholder: "Gaborone",
          buildingTypeDescription:
            "Wahle den Gebaudetyp, der deinen Standort am besten beschreibt.",
          addBuildingTypeLabel: "Gebaudetyp hinzufugen",
          addBuildingTypePlaceholder: "z. B. Diagnostiklabor",
          permissionsBlocked:
            "Die Praxisadresse kann derzeit wegen fehlender Berechtigungen nicht aktualisiert werden. Die Daten wurden nicht in der Datenbank gespeichert.",
        },
        idPassport: {
          submitted: "ID / Reisepass zur Verifizierung eingereicht",
          signInRequired: "Du musst angemeldet sein.",
          statusReadFailed: "Der Verifizierungsstatus konnte nicht gelesen werden.",
          awaitingReview: "Dokument empfangen. Wartet auf Prufung.",
        },
        registrationUpload: {
          title: "Registrierungsdokument",
          subtitle:
            "Lade eine klare Kopie deiner Registrierung beim Rat hoch",
          addTitle: "Dein Registrierungsdokument hinzufugen",
          addAction: "Hinzufugen",
          changeFile: "Datei andern",
          addMore: "Mehr hinzufugen",
          existingNotice:
            "Es ist bereits ein Registrierungsdokument vom {date} hinterlegt. Lade ein neues hoch, um es zu ersetzen.",
          status: {
            done: "Registrierung erkannt",
            failed: "Verifizierung fehlgeschlagen",
          },
          saveOcrFailed: "Die OCR-Ergebnisse konnten nicht gespeichert werden.",
          analysisFailed:
            "Die Dokumentanalyse ist fehlgeschlagen. Bitte versuche eine andere Datei.",
          statusReadFailed:
            "Der Verifizierungsstatus konnte nicht gelesen werden.",
          summary: {
            registrationNumber: "Registrierungsnr.",
            practitionerName: "Vollstandiger Name (Arztin/Arzt)",
            specialty: "Fachgebiet / Kategorie",
            practitionerFallback: "Arztin/Arzt",
          },
          retention: "Gespeichert bis {date}.",
          consent:
            "Mit dem Hochladen stimmst du zu, dass AfriMed dieses Dokument fur die Verifizierung Ende-zu-Ende-verschlusselt speichert. Es wird bis zu 90 Tage aufbewahrt.",
          alt: {
            verified: "Verifiziert",
            documentPreview: "Vorschau des Registrierungsdokuments",
          },
        },
        registrationDetails: {
          title: "Registrierungsdetails",
          subtitle: "Halte deine Registrierungsangaben aktuell.",
          signInRequired: "Du musst angemeldet sein.",
          saveFailed:
            "Die Registrierungsdetails konnten nicht gespeichert werden.",
          savedPending:
            "Anderungen gespeichert (Verifizierung ausstehend)",
          expiryPast:
            "Das Ablaufdatum darf nicht in der Vergangenheit liegen. Bitte wahl heute oder ein zukunftiges Datum.",
          yearsRange: "Gib einen Wert von 1 bis 60 ein.",
          suggestions: {
            other: "Andere",
          },
          fields: {
            number: {
              label: "Registrierungsnummer",
              placeholder: "z. B. BMD 12345",
            },
            issuer: {
              label: "Ausstellende Stelle",
              placeholder: "Wahle oder gib die ausstellende Stelle ein",
            },
            issueDate: {
              label: "Ausstellungsdatum",
            },
            expiryDate: {
              label: "Ablaufdatum",
            },
            datePlaceholder: "DD MMM, YYYY",
            yearsExperience: {
              label: "Jahre Berufserfahrung",
              placeholder: "z. B. 12",
            },
          },
        },
      },
    },
    messages: {
      loadingConversation: "Konversation wird geladen...",
      noMessagesYet: "Noch keine Nachrichten.",
      writeMessage: "Nachricht schreiben...",
      composeModal: {
        title: "Neue Konversation",
        addParticipants: "Teilnehmende hinzufugen",
        close: "Schliessen",
        types: {
          doctorPatient: "Arzt-Patient",
          doctorDoctor: "Arzt-Arzt",
          group: "Gruppenchat",
        },
        typeDescriptions: {
          doctorPatient:
            "Sichere Kommunikation mit Patientinnen und Patienten fur medizinische Konsultationen",
          doctorDoctor:
            "Professionelle Zusammenarbeit mit anderen Gesundheitsfachpersonen",
          group:
            "Mehrparteien-Gesprach fur Teamkoordination",
        },
        conversationTitle: "Konversationstitel (optional)",
        conversationTitlePlaceholder:
          "Gib einen Titel fur diese Konversation ein...",
        autoGenerateHint:
          "Leer lassen, um den Titel automatisch aus den Teilnehmenden zu erzeugen",
        searchUsers: "Benutzer suchen",
        searchPlaceholder: "Nach Namen suchen...",
        selectedParticipants: "Ausgewahlte Teilnehmende ({count})",
        searchResults: "Suchergebnisse",
        unknownUserInitial: "U",
        unknownUser: "Unbekannter Benutzer",
        noUsersFound: "Keine Benutzer gefunden",
        startTyping: "Beginne zu tippen, um nach Benutzern zu suchen",
        back: "Zuruck",
        cancel: "Abbrechen",
        nextAddParticipants: "Weiter: Teilnehmende hinzufugen",
        createConversation: "Konversation erstellen",
        chatWith: "Chat mit {name}",
        groupChatMembers: "Gruppenchat ({count} Mitglieder)",
      },
      inbox: {
        search: "Suchen",
        searchRecipients: "Empfanger suchen",
        clearSearch: "Suche loschen",
        openFola: "Fola-Konversation offnen",
        newMessage: "Neue Nachricht",
        title: "Nachrichten",
        composeTitle: "Neue Nachricht",
        loadingRecipientsTitle: "Empfanger werden geladen",
        loadingRecipientsBody:
          "Bitte warte, wahrend wir die Personen laden, denen du schreiben kannst.",
        opening: "Offnet...",
        new: "Neu",
        noRecipientsMatch:
          "Keine Empfanger entsprechen deiner Suche.",
        noRecipientsTitle: "Noch keine Empfanger",
        noRecipientsBody:
          "Empfanger erscheinen hier, sobald du einen Termin oder eine bestehende Konversation hast.",
        noConversationsMatch:
          "Keine Konversationen entsprechen deiner Suche.",
        loadingMessagesTitle: "Nachrichten werden geladen",
        loadingMessagesBody:
          "Bitte warte, wahrend wir deine neuesten Konversationen abrufen.",
        emptyTitle: "Keine Nachrichten zum Anzeigen",
        emptyBody: "Dein Posteingang ist derzeit leer. Schau spater noch einmal vorbei.",
        noMessagesPreview: "Noch keine Nachrichten.",
      },
      conversation: {
        now: "Jetzt",
        deletedForMe: "Du hast diese Nachricht geloscht",
        deletedBySender: "Der Absender hat die Nachricht geloscht",
        deleteDialog: {
          close: "Dialog zum Loschen schliessen",
          title: "Nachricht loschen?",
          body:
            "Losche diese Nachricht nur fur dich oder entferne sie fur beide Teilnehmenden. Diese Aktion kann nicht ruckgangig gemacht werden.",
          deleting: "Wird geloscht...",
          forMe: "Fur mich loschen",
          forBoth: "Fur beide loschen",
        },
        toast: {
          dismiss: "OK",
          undo: "Ruckgangig",
          deletedForMe: "Nachricht fur mich geloscht",
          deletedForBoth: "Nachricht fur beide geloscht",
          deleteError: "Die Nachricht konnte gerade nicht geloscht werden.",
        },
        composer: {
          all: "Alle",
          attach: "Foto anhangen",
          send: "Nachricht senden",
          thinking: "Fola denkt nach",
          selectedAttachmentAlt: "Ausgewahlter Anhang",
        },
        topBar: {
          back: "Zuruck zu den Nachrichten",
          openFola: "Fola-Konversation offnen",
          compose: "Nachricht verfassen",
        },
      },
    },
    appointments: {
      nearby: {
        pageTitle: "Termine",
      },
      book: {
        title: "Wahle ein Datum und eine Uhrzeit",
        doctorMissing:
          "Arzt nicht gefunden. Bitte gehe zuruck und wahle den Arzt erneut aus.",
        backToDoctors: "Zuruck zu den Arzten",
        sections: {
          service: "Einen Service auswahlen",
          date: "Datum",
          time: "Uhrzeit",
          payment: "Wahle deine Zahlungsmethode",
        },
        selectDate: "Datum auswahlen",
        minutesShort: "{count} Min.",
        loading: {
          services: "Arzt-Services werden geladen...",
          dates: "Verfugbare Daten werden geladen...",
          times: "Verfugbare Uhrzeiten werden geladen...",
          payments: "Zahlungsmethoden des Arztes werden geladen...",
        },
        empty: {
          services: "Dieser Arzt hat noch keine Services hinzugefugt.",
          dates: "Dieser Arzt hat noch keine Termintage freigegeben.",
          unavailableDay:
            "Dieser Arzt ist am ausgewahlten Tag nicht verfugbar.",
          noTimes:
            "Fur diesen Tag sind keine freien Termine mehr verfugbar.",
          payments:
            "Dieser Arzt hat noch keine Zahlungsmethoden eingerichtet.",
        },
        errors: {
          loadServices:
            "Die Services des Arztes konnten nicht geladen werden.",
          loadDates:
            "Die buchbaren Daten konnten nicht geladen werden.",
          loadTimes:
            "Die verfugbaren Uhrzeiten konnten nicht geladen werden.",
          loadPayments:
            "Die Zahlungsmethoden konnten nicht geladen werden.",
        },
        confirm: "Bestatigen",
        fallbackServices: {
          evisit: "Virtuelle Konsultation",
          consultation: "Konsultation",
        },
      },
      details: {
        title: "Termindetails",
        loading: "Termin wird geladen...",
        notFound:
          "Termin nicht gefunden. Bitte gehe zuruck und offne ihn erneut.",
        backToAppointments: "Zuruck zu den Terminen",
        visitType: {
          evisit: "Virtuell",
        },
        meetLabel: "AfriMed™-Video",
        videoRoomLabel: "Sicherer AfriMed™-Sprechraum",
        join: "Beitreten",
        message: "Nachricht",
        call: "Anruf",
        ehr: {
          granted: "Zugriff gewahrt",
          grant: "Zugriff gewahren",
          granting: "Wird gewahrt...",
        },
        sections: {
          time: "Wahle deine Terminzeit",
          payment: "Zahlungsmethode",
        },
        cancelVisit: "Termin absagen",
        editVisit: "Termin bearbeiten",
        cancelDialog: {
          title: "Termin absagen?",
          description:
            "Bist du sicher, dass du diesen Termin absagen mochtest?",
          confirm: "Ja, absagen",
        },
        deleteDialog: {
          title:
            "Mochtest du diesen medizinischen Termin wirklich loschen?",
          description:
            "Nachdem du den medizinischen Termin geloscht hast, kannst du ihn nicht wiederherstellen.",
          confirm: "Loschen",
        },
        toast: {
          rescheduleRequested:
            "Neue Zeit angefragt. Wartet auf Genehmigung.",
          confirmed: "Termin bestatigt",
          updated: "Termin aktualisiert",
          deleted: "Dein Termin wurde geloscht",
          ehrGranted: "EHR-Zugriff gewahrt",
        },
        errors: {
          load: "Der Termin konnte nicht geladen werden.",
          ehrMissing:
            "Termindetails fur den EHR-Zugriff fehlen.",
          verifyAccount: "Dein Konto konnte nicht verifiziert werden.",
          ehrGrant:
            "Der EHR-Zugriff konnte derzeit nicht gewahrt werden.",
          cancel: "Der Termin konnte nicht abgesagt werden.",
        },
      },
      doctorIndex: {
        defaultFacilityName: "Primare Einrichtung nicht festgelegt",
        patientFallback: "Patient",
        errorLoad: "Termine konnten nicht geladen werden.",
        loading: "Termine werden geladen...",
        emptyTitle: "Keine Termine zum Anzeigen",
        emptyBody: "Dein Posteingang ist derzeit leer. Schau spater noch einmal vorbei.",
        selectDay: "Tag {day} auswahlen",
        viewMode: {
          label: "Ansichtsmodus",
          day: "Tag",
          week: "Woche",
          month: "Monat",
          list: "Liste",
        },
        list: {
          freeSchedule: "Freier Zeitplan",
          allDay: "Ganztagig",
        },
        snackbar: {
          rescheduled:
            "Der Termin wurde auf {date} verschoben. Wartet auf die Zustimmung der Patientin oder des Patienten.",
          review: "Prufen",
          cancelled: "Termin abgesagt",
        },
      },
      directory: {
        common: {
          filter: "Filter",
          loading: "Wird geladen...",
          centerMap: "Karte zentrieren",
        },
        hospitals: {
          search: "Krankenhauser suchen",
          nearby: "In der Nahe",
          empty: "Keine Krankenhauser gefunden.",
          favoriteAria: "Bevorzugtes Krankenhaus",
        },
        pharmacies: {
          title: "Apotheken",
          subtitle: "Apotheken in deiner Nahe",
          search: "Apotheken suchen",
          empty: "Keine Apotheken gefunden.",
          favoriteAria: "Bevorzugte Apotheke",
          filter: {
            data: "Daten",
            payment: "Zahlungsmethoden",
            apply: "Anwenden",
            options: {
              "best-rating": "Beste Bewertung",
              "near-you": "In deiner Nahe",
              cards: "Kredit- und Debitkarten",
              "bank-transfer": "Bankuberweisungen",
              ewallet: "E-Wallets",
              "instant-eft": "Sofort-EFT",
            },
          },
        },
        ambulances: {
          title: "Ambulanz",
          subtitle: "Ambulanzen in deiner Nahe",
          favoriteAria: "Bevorzugte Ambulanz",
          filter: {
            data: "Daten",
            payment: "Zahlungsmethoden",
            apply: "Anwenden",
            options: {
              "best-rating": "Beste Bewertung",
              "near-you": "In deiner Nahe",
              cards: "Kredit- und Debitkarten",
              "bank-transfer": "Bankuberweisungen",
              ewallet: "E-Wallets",
              "instant-eft": "Sofort-EFT",
            },
          },
        },
      },
    },
    onboarding: {
      category: {
        continue: "Weiter",
        options: {
          doctor: {
            title: "Arzt",
            desc: "Tritt AfriMed™ als zugelassener Arzt bei und biete fachkundige Versorgung an.",
          },
          patient: {
            title: "Patient",
            desc: "Registriere dich, um auf vertrauenswurdige Kliniker, deine E-Akten und E-Rezepte zuzugreifen.",
          },
          employer: {
            title: "Arbeitgeber",
            desc: "Gib deinen Mitarbeitenden Zugang zu hochwertiger Gesundheitsversorgung. Eine gesunde Belegschaft starkt eine gesunde Organisation.",
          },
          moh: {
            title: "Gesundheitsministerium",
            desc: "Fordere die universelle Gesundheitsversorgung, indem Burgerinnen und Burger in AfriMed™ aufgenommen werden.",
          },
        },
      },
      email: {
        title: "E-Mail",
        subtitle:
          "Gib deine E-Mail korrekt ein, damit du Updates und Benachrichtigungen erhaltst.",
        placeholder: "E-Mail",
        continue: "Weiter",
      },
      emailEdit: {
        title: "Deine E-Mail-Adresse",
        subtitle:
          "Wir verwenden diese E-Mail nur bei Bedarf fur Updates und Benachrichtigungen. Wenn du sie spater andern musst, kannst du das in den Einstellungen tun.",
        saveContinue: "Speichern und weiter",
        label: "E-Mail",
        placeholder: "du@beispiel.com",
        verified: "Verifiziert",
      },
      name: {
        title: "Deine vollstandigen Namen",
        subtitle:
          "Achte darauf, dass dies mit den Namen auf deinem amtlichen Ausweisdokument ubereinstimmt.",
        saving: "Wird gespeichert...",
        continue: "Weiter",
        firstLabel: "Vorname",
        firstPlaceholder: "Vorname(n) laut Ausweis",
        lastLabel: "Familienname laut Ausweis",
        lastPlaceholder: "Familienname(n) laut Ausweis",
        clearFirst: "Vornamen loschen",
        clearLast: "Familiennamen loschen",
        sessionNotReady:
          "Deine Sitzung ist noch nicht bereit. Bitte versuche es erneut.",
        saveError: "Konnte nicht gespeichert werden. Bitte versuche es erneut.",
        saveRequest: "Namen speichern",
      },
      phone: {
        title: "Deine Telefonnummer",
        saving: "Wird gespeichert...",
        continue: "Weiter",
        invalidPhone: "Gib eine gultige Telefonnummer ein.",
        invalidPhoneLength:
          "Bitte gib eine gultige Telefonnummer ein (7-12 Ziffern).",
        mustAccept:
          "Bitte akzeptiere die Nutzungsbedingungen und Datenschutzrichtlinie, um fortzufahren.",
        termsLead:
          "Mit dem Ankreuzen dieses Feldes bestatige ich, dass ich die",
        termsLink: "Nutzungsbedingungen",
        termsJoiner: "und die",
        privacyLink: "Datenschutzrichtlinie",
        termsEnd: ".",
      },
      otp: {
        title: "Telefonverifizierung (kommt bald)",
        subtitle:
          "Wir haben deine Nummer fur die WhatsApp-Verifizierung in der nachsten Version gespeichert. Du kannst jetzt fortfahren.",
        continue: "Weiter",
        phoneNumber: "Telefonnummer",
        notProvided: "Nicht angegeben",
        note:
          "Hinweis: Die SMS-Verifizierung ist in Staging deaktiviert, wahrend wir auf ein WhatsApp-first-Onboarding umstellen.",
      },
      passcodeConfirm: {
        title: "Passcode",
        subtitle: "Schutze dein Konto mit einem Sicherheitscode",
        saving: "Wird gespeichert...",
        continue: "Weiter",
        confirm: "Passcode bestatigen",
        mismatch: "Die Passcodes stimmen nicht uberein. Bitte versuche es erneut.",
        sessionExpired: "Sitzung abgelaufen. Bitte melde dich erneut an.",
        saveError: "Passcode konnte nicht gespeichert werden",
      },
      passcodeCreate: {
        title: "Passcode",
        subtitle: "Schutze dein Konto mit einem Sicherheitscode",
        continue: "Weiter",
        create: "Passcode erstellen",
      },
      dob: {
        title: "Geburtsdatum",
        subtitle:
          "Achte darauf, dass dies mit dem Namen auf deinem amtlichen Ausweis ubereinstimmt",
        saving: "Wird gespeichert...",
        continue: "Weiter",
        label: "Geburtsdatum",
        placeholder: "TT-MM-JJJJ",
        done: "Fertig",
        saveError: "Konnte nicht gespeichert werden. Bitte versuche es erneut.",
        timeout:
          "Netzwerk-Zeituberschreitung beim Speichern. Bitte versuche es erneut (oder wechsle das Netzwerk).",
      },
      idPassport: {
        title: "Nationaler Ausweis • Reisepass",
        subtitle:
          "Gib deine Ausweis-/Reisepassnummer oder die MRZ-Zeile (30 Zeichen) ein.",
        continue: "Weiter",
        verifying: "Wird verifiziert...",
        label: "Ausweis / Reisepass",
        placeholder: "A12345678  ·  oder MRZ-Zeile",
        done: "Fertig",
        invalidHint:
          "Verwende eine Reisepassnummer oder fige eine 30-stellige MRZ-Zeile ein.",
        processingTitle: "Ausweisverarbeitung",
        processingPending: "Dein Dokument wird analysiert...",
        processingIdle: "Mache ein Foto oder lade einen klaren Scan hoch",
        working: "In Arbeit...",
        retake: "Erneut aufnehmen",
        camera: "Kamera",
        uploadFile: "Datei hochladen",
        aiProcessing: "KI-Verarbeitung",
        sessionNotReady: "Sitzung noch nicht bereit. Bitte melde dich erneut an.",
        fileTooLarge:
          "Datei zu gross. Bitte lade ein Bild unter 5 MB hoch.",
        uploading: "Dokument wird hochgeladen...",
        receivedExtracting: "Dokument erhalten. Details werden extrahiert...",
        uploadFailed: "Hochladen fehlgeschlagen. Bitte versuche es erneut.",
        retention:
          "Datenschutz: Die verschlusselte Speicherung lauft am {date} ab.",
        status: {
          pending: "Dokument wird analysiert...",
          done: "Identitat erhalten",
          failed: "Verarbeitung fehlgeschlagen",
          received: "Dokument erhalten",
          idle: "Verarbeitung...",
        },
        alt: {
          passed: "Bestanden",
          failed: "Fehlgeschlagen",
          received: "Erhalten",
        },
        summary: {
          surname: "Nachname",
          idNumber: "Ausweis-Nr.",
          dob: "Geburtsdatum",
          expiry: "Ablaufdatum",
          givenNames: "Vornamen",
        },
      },
      languages: {
        title: "Sprachen hinzufugen",
        searchPlaceholder: "Suchen oder hinzufugen",
        clearSearch: "Suche loschen",
        addLanguage: "Sprache hinzufugen",
        helper: "Wahle alle Sprachen aus, die du sprichst.",
        noMatches: "Keine Sprachen entsprechen deiner Suche.",
        continue: "Weiter",
        saving: "Wird gespeichert...",
        sessionExpired: "Sitzung abgelaufen",
        saveError: "Sprachen konnten nicht gespeichert werden",
      },
    },
    fola: {
      widget: {
        title: "Fola - AfriMed Assistentin",
        greeting:
          "Hallo, ich bin Fola. Ich kann bei OTPs, Magic Links und Einstellungen helfen.",
        placeholder: "Frag Fola...",
        send: "Senden",
        error: "Entschuldigung, es gab ein Problem. Bitte versuche es erneut.",
      },
    },
  },
  sn: {
    common: {
      comingSoon: "Zvichauya munguva pfupi",
      tryAgain: "Edza zvakare",
      no: "Kwete",
      yes: "Hongu",
      cancel: "Kanzura",
      search: "Tsvaga",
      loggingOut: "Kubuda kuri kuitika...",
      logout: "Buda",
      legal: {
        terms: "Mitemo nemamiriro",
        privacy: "Mutemo wekuvanzika",
        dataDeletion: "Kubviswa kwedata",
      },
      actions: {
        save: "Chengeta",
        continue: "Enderera",
        done: "Zvaitwa",
        clear: "Bvisa",
        clearSearch: "Bvisa kutsvaga",
      },
      cookies: {
        title: "Zvinodiwa zveCookie zveAfriMed™",
        intro:
          "Sarudza mashandisirwo anoitwa ma-cookie asingamanikidzwi. Zvimwe zvikamu zvakadzimwa pakutanga. Rongedza ma-cookie ako pano pazasi.",
        support:
          "Zvakagadzirirwa kutsigira mitemo yeGDPR nemisimboti yeAfrican Union yekudzivirira data kuitira kujeka, chinangwa chakajeka, uye kutonga kwemushandisi.",
        close: "Vhara zvinodiwa zvecookie",
        alwaysActive: "Zvinogara zvichishanda",
        rejectOptional: "Ramba zvisingamanikidzwi",
        saveChoices: "Chengeta zvasarudzwa",
        acceptAll: "Gamuchira zvese",
        categories: {
          strictly: {
            label: "Ma-cookie anokosha chete",
            body:
              "Anodiwa pakushanda kukuru kwakaita sekuchengetedzwa, kuenderera kwesession, uye accessibility. Aya ma-cookie anogara achishanda.",
          },
          statistics: {
            label: "Ma-cookie ehuwandu",
            body:
              "Anoyera mashandisirwo akabatanidzwa kuitira kuti tivandudze mhando yebasa nekunzwisisa kweutano hweveruzhinji. Hatitengesi data remunhu.",
          },
          performance: {
            label: "Ma-cookie ekushanda",
            body:
              "Anotibatsira kuona kumhanya, kugadzikana, uye kusimba kwebasa pamidziyo nemanetiweki akasiyana.",
          },
          functionality: {
            label: "Ma-cookie ezvaunofarira",
            body:
              "Anorangarira zvaunofarira zvakaita semutauro nenzvimbo kuitira kuti kudzoka kwako kuve nyore.",
          },
          targeting: {
            label: "Ma-cookie ekushambadza",
            body:
              "Ano shandiswa kuunza kana kuderedza kukosha kwemashoko ekushambadza. Hatitengesi data remunhu.",
          },
          social: {
            label: "Ma-cookie esocial media",
            body:
              "Anoita kuti social login uye zvemukati zvemumasocial zviitike. Vamwe vanopa vanogona kushandisa mitemo yavo.",
          },
          beacons: {
            label: "Web beacons",
            body:
              "Matagi madiki anoshandiswa kunzwisisa kuendeswa nekupindurwa kwemashoko kana zvichishanda.",
          },
        },
      },
    },
    home: {
      doctor: {
        fallbackName: "Chiremba",
        patientFallback: "Murwere",
        consultancyFallback: "Kubvunza",
        welcome: "Mauya Dr {surname}",
        specialtyFallback: "Chiremba",
        actions: {
          openProfile: "Vhura profile",
          dashboard: "Dashboard",
          notifications: "Zviziviso",
          viewAll: "Ona zvese",
        },
        appointments: {
          title: "Kuonana kwako",
          loading: "Kurodha kuonana...",
          loadingError: "Tiri kurodha kuonana kwako. Zorodzazve munguva pfupi.",
          error: "Hatina kukwanisa kurodha kuonana.",
          emptyTitle: "Hausati uine kuonana kwakarongwa.",
          emptyBody: "Kuonana kwabvumidzwa kucharatidzwa pano kana varwere vabvuma.",
          when: {
            today: "Nhasi",
          },
          tabs: {
            today: "Nhasi",
            todayCount: "Nhasi {count}",
            upcoming: "Zviri kuuya",
            upcomingCount: "Zviri kuuya {count}",
            pending: "Zvakamirira mvumo",
            pendingCount: "Zvakamirira mvumo {count}",
          },
        },
        elevate: {
          title: "Simudzira kuoneka kwebasa rako",
        },
        gallery: {
          title: "Ita profile yako ioneke",
          body: "Wedzera mifananidzo ine chekuita nebasa rako",
          notNow: "Kwete izvozvi",
        },
        regional: {
          title: "Utano hwenharaunda",
          headline: "Ramba uchiziva nezveutano hwedunhu",
          defaultSummary: "maitiro ehutano nezvirwere",
          facilitySummary: "{count} nzvimbo dzakanyorwa nemaitiro ehutano",
        },
      },
    },
    auth: {
      login: {
        sheet: {
          manageCookies: "Rongedza ma-cookie",
        },
        landing: {
          title: "Mauya kuAfriMed™",
          line1: "Ngatitange rwendo rweutano",
          line2: "ruri nani pamwe chete!",
          registerEmail: "Nyoresa neemail",
          registerFacebook: "Nyoresa neFacebook",
          registerGoogle: "Nyoresa neGoogle",
          login: "Pinda",
          trouble: "Uri kunetseka kupinda?",
          journey: "Rwendo rwako rwekuwana rubatsiro runotangira pano!",
        },
      },
    },
    appointments: {
      details: {
        title: "Zvekuonana",
        status: {
          completed: "ZVAPERA",
          pending: "ZVAKAMIRIRA",
          cancelled: "ZVADZIMWA",
          missed: "ZVASHAYIKWA",
        },
        message: "Meseji",
        call: "Fonera",
      },
      edit: {
        paymentMethodFallback: "Makadhi edhibhiti kana ekiredhiti",
      },
      doctorIndex: {
        defaultFacilityName: "Nzvimbo huru haisati yaiswa",
        errorLoad: "Hatina kukwanisa kurodha kuonana.",
        loading: "Kurodha kuonana...",
        emptyTitle: "Hapana kuonana kwekuratidza",
        emptyBody: "Hapana chiripo parizvino. Dzokazve gare gare.",
        patientFallback: "Murwere",
        selectDay: "Sarudza zuva {day}",
        weekNav: {
          previous: "Vhiki rapfuura",
          next: "Vhiki rinotevera",
        },
        monthNav: {
          previous: "Mwedzi wapfuura",
          next: "Mwedzi unotevera",
        },
        viewMode: {
          label: "Maonero",
          day: "Zuva",
          week: "Vhiki",
          month: "Mwedzi",
          list: "Rondedzero",
        },
        list: {
          freeSchedule: "Purogiramu yakasununguka",
          allDay: "Zuva rose",
        },
        snackbar: {
          rescheduled: "Kuonana kwachinjirwa ku {date}. Kuri kumirira kubvumidzwa kwemurwere.",
          review: "Ongorora",
          cancelled: "Kuonana kwadzimwa",
        },
      },
      summary: {
        title: "Kuonana kwapera",
      },
    },
    messages: {
      inbox: {
        title: "Meseji",
        emptyTitle: "Hapana meseji dzekuratidza",
        emptyBody: "Inbox yako haina chinhu parizvino. Dzokazve gare gare.",
      },
      loadingConversation: "Kurodha hurukuro...",
      noMessagesYet: "Hakusati pave nemeseji.",
      writeMessage: "Nyora meseji...",
      conversation: {
        deleteDialog: {
          title: "Bvisa meseji?",
          forMe: "Bvisa kwandiri",
          forBoth: "Bvisa kune vese",
        },
        composer: {
          send: "Tumira meseji",
          thinking: "Fola ari kunyora...",
        },
      },
    },
    referrals: {
      entry: {
        postConsultActions: "Zviito mushure mekuonana",
        postConsultActionsSubtitle:
          "Bata pfupiso uye rambisa mberi rwendo rwekutarisira murwere.",
      },
      doctor: {
        title: "Tumira murwere",
      },
      consultationNote: {
        save: "Chengeta chinyorwa",
      },
    },
    doctors: {
      appointmentDetails: {
        title: "Zvekuonana",
        loading: "Kurodha zvinotsanangura kuonana...",
        notFound: "Kuonana hakuwaniki. Dzokera wozarura zvakare.",
        backToAppointments: "Dzokera kukuonana",
        patientFallback: "Murwere",
        doctorFallback: "Chiremba",
        yearsOld: "Ane makore {count}",
        facilityFallback: "Chipatara chepachivande",
        firstAppointment: "Kuonana kwekutanga",
        diagnosisTitleFallback: "Kuongorora nezvinyorwa",
        meetPending: "Kamuri yakachengeteka yeAfriMed™ yekuonana",
        eVisit: "E-Kuonana",
        notesEmpty: "Hapana zvinyorwa zviripo.",
        photosEmpty: "Hapana mifananidzo yemurwere yagovaniswa.",
        notesPlaceholder: "Wedzera zvinyorwa...",
        notesAutosave: "Zvinyorwa zvinochengetwa zvoga paunobuda mundima iyi.",
        status: {
          pending: "Zvakamirira",
          scheduled: "Zvakarongwa",
          inProgress: "Zviri kufamba",
          completed: "Zvapera",
          missed: "Zvashaikwa",
          cancelled: "Zvadzimwa",
          confirmed: "Zvabvumidzwa",
        },
        startsIn: {
          default: "Zvinotanga muawa 1",
          minutes: "Zvinotanga mumaminitsi {count}",
          hours: "Zvinotanga mumaawa {count}",
        },
        sections: {
          diagnosis: "Kuongorora",
          prescription: "Resiphi",
          testsAndLabs: "Miedzo nemalabhu",
          testsAndDocuments: "Miedzo nemagwaro",
          notes: "Zvinyorwa",
          photos: "Mifananidzo yemurwere",
          ehr: "EHR",
          support: "Rubatsiro",
        },
        fields: {
          bloodType: "Rudzi rweropa",
          allergies: "Ma-allergy",
          chronicConditions: "Zvirwere zvisingaperi",
          organDonor: "Mupi wenhengo",
        },
        requestEhr: {
          title: "Kumbira EHR",
          body: "Ipa kutarisira kuri nani nekuwana Electronic Health Record yemurwere wako",
        },
        ehr: {
          accessGranted: "Kupinda kwabvumidzwa",
          accessRequested: "Kupinda kwakumbirwa",
        },
        fulfillment: {
          title: "Kuzadzikiswa kweresiphi",
          deliveryMode: "Kuendeswa",
          pickupMode: "Kutora",
          selectedPharmacy: "Pharmacy yasarudzwa",
          readyForPickup: "Yagadzirira kutorwa",
          readyForPickupDescription:
            "{pharmacy} yaratidza resiphi iyi yagadzirira kutorwa.",
          fulfillmentModeComplete: "{mode} yapera kudivi repharmacy.",
          paid: "Yabhadharwa",
          paidDescription: "{pharmacy} yasimbisa kubhadharwa kweresiphi iyi.",
          waitForPickup: "Mirira pharmacy imake odha yagadzirira kutorwa.",
          paymentReady: "Kubhadhara kwagadzirira",
          paymentReadyDescription:
            "{pharmacy} yaisa mutengo uye murwere ava kukwanisa kubhadhara muAfriMed.",
          waitingForPayment: "{mode} yakamirira kubhadhara kwemurwere.",
          pharmacyPreparing: "Pharmacy iri kugadzirira",
          pharmacyPreparingDescription:
            "{pharmacy} yabvuma resiphi uye iri kuigadzirira.",
          folaActive: "{mode} iri kushanda muFola.",
          needsNewPharmacy: "Inoda imwe pharmacy",
          needsNewPharmacyDescription:
            "{pharmacy} haina kukwanisa kuzadzisa resiphi iyi.",
          chooseAnotherPharmacy: "Murwere anofanira kusarudza imwe pharmacy yakanyoreswa.",
          pharmacySelected: "Pharmacy yasarudzwa",
          pharmacySelectedDescription:
            "{pharmacy} ndiyo branch iri kushanda pa{mode} yeresiphi iyi.",
          openFolaConversation: "Vhura Fola handoff kuti utevere hurukuro yepharmacy.",
          syncingFola: "Fola handoff ichiri kuwiriranisa muscreen iyi.",
          folaStarted: "Fola handoff yatanga",
          folaStartedDescription:
            "Rubatsiro rweresiphi rwatoshanda uye thread yekuzadzikisa yagadzirira.",
          followPharmacyUpdates: "Vhura Fola handoff kuti utevere zvitsva zvepharmacy.",
          issued: "Yabudiswa",
          issuedDescription: "Resiphi yabudiswa. Fola handoff ichiri kuwiriranisa muscreen iyi.",
        },
        actions: {
          profile: "Purofayiri",
          editDiagnosis: "Gadzirisa kuongorora",
          add: "Wedzera",
          view: "Ona",
          request: "Kumbira",
          showAll: "Ratidza zvese",
          message: "Meseji",
          call: "Fonera",
          join: "Pinda",
          joinClosed: "Nguva yapera",
          updating: "Kuvandudza...",
          details: "Zvimwe",
          changeAppointment: "Chinja kuonana",
          startConsultation: "Tanga kuonana",
          markInProgress: "Ratidza kuti zvafamba",
          completeConsultation: "Pedzisa kuonana",
          openFolaHandoff: "Vhura Fola handoff",
        },
        support: {
          unavailablePastAppointments: "Hazviwanikwi pakuonana kwakapfuura",
        },
        cancelDialog: {
          title: "Dzima kuonana?",
          description: "Rangarira kutanga wabata murwere usati waenderera.",
          confirm: "Hongu, dzima",
        },
        deleteDialog: {
          title: "Uri kuda kubvisa rekodhi rekuonana iri here?",
          description: "Kana wabvisa rekodhi iri, hauzokwanisi kuridzorera.",
          confirm: "Bvisa",
        },
        changeSheet: {
          title: "Chinja kana gadzirisa kuonana",
          requestNewTime: "Kumbira imwe nguva",
          cancelAppointment: "Dzima kuonana",
        },
        completeConsultationDialog: {
          body: "Pedzisa kuonana uku chete kana wapera uye zvinyorwa zvachengetwa.",
          confirmShort: "Pedzisa",
        },
        toast: {
          callOnlyDuringAppointment: "Unogona kufonera chete panguva yekuonana uku.",
          rescheduleRequested: "Chikumbiro chenguva itsva chatumirwa. Chakamirira mvumo.",
        },
        errors: {
          auth: "Kupinda kunodiwa.",
          update: "Hatina kukwanisa kugadzirisa kuonana.",
          requestEhr: "Hatina kukwanisa kukumbira EHR parizvino.",
          completeConsultation: "Hatina kukwanisa kupedzisa kuonana.",
        },
        attachments: {
          remove: "Bvisa chakabatanidzwa",
          removed: "Chakabatanidzwa chabviswa.",
        },
      },
    },
    regionalHealth: {
      title: "Utano hwenharaunda",
      loading: "Kurodha mashoko ehutano hwenharaunda...",
      newAlert: "Yambiro itsva",
      diseaseFallback: "Coronavirus",
      diseases: {
        coronavirus: "Coronavirus",
        influenza: "Flu",
        malaria: "Malaria",
        rsv: "RSV",
        cholera: "Cholera",
        measles: "Measles",
        dengue: "Dengue",
      },
      actions: {
        resetView: "Dzorerazve maonero",
      },
      source: {
        live: "Mashoko ehutano epanguva chaiyo",
        demo: "Demo refeed yehutano hwenharaunda",
      },
      metrics: {
        patients: "Varwere {count}",
        patientsTitle: "Varwere {count}",
        update: "Gadziriso",
      },
      errors: {
        mapTokenMissing: "Map token haipo",
      },
      status: {
        good: "Zvakanaka",
        acceptable: "Zvinoshanda",
        caution: "Chenjerera",
        critical: "Zvakakomba",
      },
      updated: {
        today: "Nhasi",
        yesterday: "Nezuro",
      },
      countries: {
        angola: "Angola",
        botswana: "Botswana",
        comoros: "Komoro",
        drCongo: "DR Congo",
        eswatini: "Eswatini",
        lesotho: "Lesotho",
        madagascar: "Madagascar",
        malawi: "Malawi",
        mauritius: "Mauritius",
        mozambique: "Mozambique",
        namibia: "Namibia",
        seychelles: "Seychelles",
        southAfrica: "Chamhembe Afrika",
        tanzania: "Tanzania",
        zambia: "Zambia",
        zimbabwe: "Zimbabwe",
      },
    },
    doctorDashboard: {
      metrics: {
        patients: "Varwere",
        overallRating: "Chiyero chese",
        appointments: "Kuonana",
        prescriptions: "Maresiphi",
        past30Days: "Mazuva 30 apfuura",
        thisMonth: "Mwedzi uno",
      },
      range: {
        label: "Nguva",
        today: "Nhasi",
        week: "Vhiki",
        month: "Mwedzi",
        year: "Gore",
      },
      visitors: {
        title: "Vashanyi vekiriniki",
        menu: "Nguva yevashanyi vekiriniki",
        loadingChart: "Kurodha chati...",
        empty: "Hakusati kwava nemaitiro ekuonana.",
        range: {
          threeMonths: "Mwedzi 3 yapfuura",
          sixMonths: "Mwedzi 6 yapfuura",
          year: "Gore rapfuura",
        },
      },
      calendar: {
        title: "Vashanyi vekuonana",
        selectMonth: "Sarudza mwedzi",
        previousMonth: "Mwedzi wapfuura",
        nextMonth: "Mwedzi unotevera",
        noAppointments: "Hapana kuonana",
        legend: {
          appointment: "Kuonana",
          eVisit: "E-Kuonana",
          pending: "Zvakamirira",
        },
      },
      patientsAppointments: {
        title: "Kuonana kwevarwere",
        subtitle: "Pfupiso yerwendo rwemurwere nerubatsiro rwapiwa pakiriniki.",
        loading: "Kurodha kuonana...",
        empty: "Hapana kuonana munhamba iyi yenguva.",
        noDiagnosis: "Hapana kuongorora kwakanyorwa.",
        notProvided: "Hazvina kupihwa",
        openDetails: "Vhura zvitsananguro zvekuonana",
        columns: {
          patientName: "Zita remurwere",
          primaryCondition: "Dambudziko guru",
          riskLevel: "Ngozi",
          insurance: "Inishuwarenzi",
          lastVisit: "Kushanya kwekupedzisira",
        },
      },
      prescriptions: {
        title: "Maresiphi achangoburwa",
        subtitle: "Maresiphi awakagadzira kubva mukurapwa kwekuonana.",
        searchPlaceholder: "Tsvaga neID yemurwere",
        searchAria: "Tsvaga maresiphi achangoburwa neID yemurwere",
        loading: "Kurodha maresiphi...",
        empty: "Hakusati kwava nemaresiphi.",
        noMatches: "Hapana zvawawana.",
        columns: {
          patient: "Murwere",
          issued: "Yabudiswa",
          expires: "Inopera",
          rxNumber: "Nhamba yeRx",
          status: "Mamiro",
        },
        status: {
          draft: "Rasara richinyorwa",
          issued: "Yabudiswa",
          dispensed: "Yapiwa",
          cancelled: "Yadzimwa",
          expired: "Yapera",
        },
      },
      prescriptionsPage: {
        title: "Nhoroondo yemaresiphi",
        heading: "Nhoroondo yemaresiphi",
        subtitle: "Maresiphi akabudiswa ane chekuita nekuchengetwa kwekuonana.",
        issuedPast30Days: "{count} abudiswa mumazuva 30 apfuura.",
        columns: {
          refill: "Kuzadzazve",
        },
        errors: {
          load: "Hatina kukwanisa kurodha maresiphi.",
        },
      },
      common: {
        title: "Resiphi",
        notFound: "Resiphi haisi kuwanika.",
        item: "resiphi",
        medication: "Mushonga",
        patient: "Murwere",
        facility: "Nzvimbo",
        dob: "Zuva rekuzvarwa",
        id: "ID",
        ePrescription: "E-Resiphi",
        qrCode: "QR kodhi",
        verificationQr: "QR yekusimbisa",
        prescriber: "Muprescriber",
        registration: "Kunyoreswa",
        registrationShort: "Reg",
        prescriptionNumber: "Nhamba yeresiphi",
        issued: "Yabudiswa",
        signInToView: "Ndapota pinda kuti uone resiphi iyi.",
        accessDenied: "Hauna mvumo yekuona resiphi iyi.",
        loadFailed: "Hatina kukwanisa kurodha resiphi.",
        poweredByIssuedVia:
          "Inofambiswa ne {issuedVia}. Muprescriber ndiye anosara ane mutoro wezvisarudzo zvekurapa.",
      },
      wizard: {
        header: {
          addPrescription: "Wedzera resiphi",
          subtitle: "Unogona kuiwedzera nemaoko kana kushandisa kamera kuiisa.",
        },
        medication: "Mushonga",
        addStrength: "Wedzera simba remushonga",
        addMedication: "Wedzera mushonga",
        uploadImage: "Isa mufananidzo",
        searchOrAdd: "Tsvaga kana wedzera",
        possibleMatches: "Zvinogona kuenderana",
        loadingMatches: "Kurodha... imbomirai!",
        noMatchesAdd: "Hapana zvakafanana. Tinya + kuti uwedzere “{query}”.",
        chooseMedicationType: "Sarudza mhando yemushonga",
        chooseUnit: "Sarudza unit",
        select: "Sarudza",
        frequency: {
          title: "Kakawanda",
          daily: "Zuva nezuva",
          cyclical: "Nehurongwa hunodzokorora",
          specificDays: "Pazuva rakatarwa revhiki",
          asNeeded: "Pazvinodiwa",
        },
        days: {
          title: "Mazuva evhiki",
          label: "Mazuva",
          mon: "Muvh",
          tue: "Chip",
          wed: "Chit",
          thu: "China",
          fri: "Chish",
          sat: "Mug",
          sun: "Svo",
        },
        medType: {
          capsule: "Kapusuru",
          tablet: "Piritsi",
          injectionSolution: "Mushonga wejekiseni",
          oralSolution: "Mushonga wemukanwa",
          topical: "Wekuzora",
          device: "Mudivhisi",
          drops: "Madonhwe",
          inhaler: "Inhaler",
        },
        dose: "Dozi",
        every: "Mushure me",
        day: "Zuva",
        time: "Nguva",
        timeAndDoses: "Nguva nemadozi",
        cyclicalShort: "Cycle",
        doses: "Madozi",
        duration: "Nguva yekutora",
        startDate: "Zuva rekutanga",
        endDate: "Zuva rekupedzisira",
        cycle: "Cycle",
        useFor: "Shandisa kwemazuva",
        pauseFor: "Mira kwemazuva",
        hoursValue: "{count} maawa",
        schedule: "Shedhuru",
        dosage: "Dozi",
        starts: "Inotanga",
        ends: "Inopera",
        optionalNotes: "Manotsi esarudzo emurwere",
        signAndPrescribe: "Saina wobudisa resiphi",
        issuing: "Kubudisa resiphi...",
        viewPrescription: "Vhura resiphi",
        addImagesToGallery: "Wedzera mifananidzo kugallery",
        uploadFromGallery: "Isa kubva kugallery",
        takePhoto: "Tora mufananidzo",
        timeInterval: "Nguva pakati",
        qrCode: "QR kodhi",
        issueFirstForQr: "Tanga wabudisa resiphi kuti ubatidze QR inotarisiswa.",
        scheduleUnavailable: "Shedhuru haisi kuwanika",
        prescriber: "Muprescriber",
        poweredBy:
          "Inofambiswa ne AfriMed™. Muprescriber ndiye anosara ane mutoro wezvisarudzo zvekurapa.",
        errors: {
          appointmentNotFound: "Hatina kuwana appointment yeresiphi iyi.",
          recordLinkageMissing: "Kubatanidzwa kwechiremba kana murwere kweresiphi iyi kushaya.",
          authLinkageMissing: "Kubatanidzwa kweauth kwechiremba kana murwere kweresiphi iyi kushaya.",
          idMissing: "Resiphi yabudiswa asi ID haina kudzoka.",
          issueFailed: "Hatina kukwanisa kubudisa resiphi.",
        },
      },
      checkout: {
        title: "Kubuda kwemushonga kufamasi",
        openFolaShort: "Fola",
        openFola: "Vhura Fola handoff",
        feedbackSubtitle: "Bata danho iri rekubhadhara kuti AfriMed ivhurezve nzvimbo chaiyo yemuedzi.",
        sponsor: {
          title: "Muripo wemutsigiri",
          headline: "Shandisa sponsor link yakachengeteka",
          body: "Gadzira sponsor link yakachengetwa kuti hama kana mutsigiri abhadhare kubva kune imwe nyika, AfriMed yobva yadzosa muripo uyu murekodhi yefamasi.",
          prepare: "Gadzirira muripo wemutsigiri",
          prefill: "Kuzadzikiswa kweresiphi",
        },
        card: {
          title: "Zvinyorwa zvemubhadharo",
          headline: "Kubuda nekadhi",
          body: "Bhadhara bazi refamasi ratorwa zvino kuitira kuti kupihwa kwemushonga kufambe pasina kutevera nemaoko.",
          loading: "Kurodha fomu rekadhi rakachengeteka…",
          remember: "Rangarira ruzivo rwekadhi nguva inotevera",
          processing: "Kugadzirisa…",
          payNow: "Bhadhara famasi zvino",
          refresh: "Rodhazve zvemubhadharo",
        },
        summary: {
          prescription: "Resiphi",
          pharmacy: "Famasi inopa",
          awaitingBranch: "Bazi harisati rasarudzwa",
          deliveryHelper: "Quote yekuendesa yagadzirirwa nefamasi.",
          pickupHelper: "Quote yekutora yagadzirirwa nefamasi.",
          subtotal: "Mari yemushonga",
          delivery: "Kuendesa",
          total: "Yese",
          totalHelper: "Mari yepuratifomu yeAfriMed iri kumashure uye haisi kuwedzerwa pamusoro pemari yemurwere iyi.",
          state: "Mamiro ekuzadzisa",
          mode: "Nzira",
          modeHelper: "Shandisa Fola handoff kana famasi ichida kujekeswa isati yaburitsa.",
        },
        state: {
          paid: "Yabhadharwa",
          paidHelper: "Dzokera kutsananguro dzeresiphi kuti uone kuburitswa nekutora.",
          refundPending: "Refund yakamirira",
          refundPendingHelper: "Muripo uyu wefamasi uri kudzorerwa.",
          refunded: "Yadzoserwa",
          refundedHelper: "Sarudza imwe famasi kana resiphi iyi ichiri kuda kuzadzikiswa.",
          paymentReady: "Mubhadharo wagadzirira",
          paymentReadyHelper: "Famasi yagadzira quote. Pedzisa kubhadhara kuti usimbise odha.",
          awaitingQuote: "Quote yakamirira",
          awaitingQuoteHelper: "Dzokera kutsananguro dzeresiphi kana famasi yagadzira mutengo.",
        },
        status: {
          preparing: "Kugadzirira kubhadhara kufamasi…",
          restoringSponsor: "Kudzorera muripo wemutsigiri nekuyananisa ledger yefamasi…",
          awaitingQuoteBody: "Famasi haisati yagadzira quote inobhadharika yeresiphi iyi. Vhura tsananguro dzeresiphi zvakare kana famasi yasimbisa subtotal nekuzadzikisa.",
          alreadyPaid: "Resiphi iyi yakatobhadharwa. Unogona kudzokera kutsananguro dzeresiphi kuti uone mamiriro emuripo nerefund.",
          alreadyReversing: "Muripo uyu wefamasi watotanga kudzorerwa. Dzokera kutsananguro dzeresiphi kuti uone mamiriro erefund.",
          alreadyRefunded: "Muripo uyu wefamasi watodzorerwa.",
          preparingCard: "Kugadzirira kubhadhara nekadhi kwakachengeteka…",
        },
        errors: {
          signInAgain: "Ndapota pinda zvakare kuti uenderere mberi.",
          accessDenied: "Hauna mvumo yekubhadhara resiphi iyi.",
          load: "Hatina kukwanisa kurodha mubhadharo weresiphi iyi parizvino.",
          notConfigured: "Nzira yekubhadhara yeStripe haisati yagadzirirwa panzvimbo iyi.",
          stripeLoad: "Nzira yekubhadhara yeStripe yatadza kurodha pari zvino.",
          sessionExpired: "Session yapera. Ndapota pinda zvakare.",
          quoteNotReady: "Resiphi iyi haisati yava nequote yefamasi yakagadzirira kubhadharwa.",
          formLoading: "Fomu rekadhi rakachengeteka richiri kurodha. Rodhazve zvemubhadharo.",
          secureCheckout: "Kubhadhara kwakachengeteka hakuna kugadzirika zvakanaka. Rodhazve zvemubhadharo uedze zvakare.",
          prepareIntent: "Stripe haina kukwanisa kugadzirira payment intent iyi.",
          paymentFailed: "Mubhadharo haukwanisi kupedzwa.",
          processing: "Mubhadharo wako uchiri kugadziriswa. Ndapota mirira zvishoma uedze zvakare.",
          referenceMissing: "Mubhadharo wapera asi reference yemubhadharo yakashaikwa.",
          sponsorRestore: "Muripo wemutsigiri wapera, asi AfriMed haina kukwanisa kudzoreredza mubhadharo wefamasi parizvino.",
          intentMissing: "Stripe haina kuwana payment intent yefamasi iyi mubrowser rino. Rodhazve zvemubhadharo uedze zvakare.",
          payoutReconnect: "Kugadziriswa kwepayout yefamasi kunofanira kubatanidzwa zvakare usati waenderera nekubhadhara nekadhi.",
          generic: "Mubhadharo unogona kunge wapfuura, asi AfriMed haina kukwanisa kupedzisa kubhadhara kufamasi zvakanaka.",
          intentMismatch: "Stripe haina kuwana payment intent yefamasi iyi mufomu rekadhi riri kushanda. Rodhazve zvemubhadharo uedze zvakare.",
          intentMismatchWithAccount: "Stripe haina kuwana payment intent yefamasi iyi mufomu rekadhi riri kushanda. AfriMed yakaiumba muplatform account {account}. Rodhazve zvemubhadharo uedze zvakare.",
        },
      },
      fulfillment: {
        modePickup: "Kutora",
        modeDelivery: "Kuendesa",
        modePickupLower: "kutora",
        modeDeliveryLower: "kuendesa",
        selectedPharmacy: "Famasi yakasarudzwa",
        yourSelectedPharmacy: "Famasi yako yakasarudzwa",
        theSelectedPharmacy: "Famasi yakasarudzwa",
        requestedPharmacy: "Famasi yakakumbirwa",
        afrimedPharmacy: "Famasi yeAfriMed",
        totalCost: "Mari yose",
        nearbyPharmacies: "Mafamasi ari pedyo",
        signedUpPharmacies: "Mafamasi akanyoresa",
        loadingNearby: "Kurodha mafamasi matatu ari pedyo akanyoresa…",
        chooseNearby: "Sarudza imwe yemafamasi matatu ari pedyo kuti uenderere mberi.",
        chooseRanked: "Sarudza famasi yakanyoresa kuti uenderere mberi. AfriMed icharonga nedaro kana nzvimbo yawanikwa.",
        noneAvailable: "Parizvino hapana mabhuranchi efamasi akanyoresa anowanikwa.",
        distanceMeters: "{count} m kure",
        distanceKm: "{count} km kure",
        locationPending: "Nzvimbo haisati yazara",
        pickupPending: "Kutora kuchakamirira",
        medicineSubtotal: "Mari yemushonga",
        total: "Yese",
        quoteIncludesDelivery: "Quote iyi inosanganisira kuendesa.",
        quotePreparedForPickup: "Quote iyi yakagadzirirwa kutora.",
        quotedOn: "Yakakotwa {date}.",
        banner: {
          ready: "{pharmacy} yati resiphi iyi yagadzirira kutorwa.",
          paid: "Mubhadharo wasimbiswa. {pharmacy} iri kugadzirira kuburitsa kuti itorwe.",
          awaitingPayment: "{pharmacy} yaisa mutengo weresiphi iyi.",
          preparing: "{pharmacy} iri kugadzirira resiphi iyi.",
          reviewing: "{pharmacy} iri kuongorora resiphi iyi.",
          rejected: "{pharmacy} yatadza kuzadzisa resiphi iyi.",
          chooseBranch: "Sarudza bazi refamasi rakanyoresa kuti uenderere mberi.",
          handling: "{pharmacy} iri kubata resiphi iyi.",
          requestPending: "{pharmacy} iri kugadzirira quote.",
          chooseBranchForMode: "Sarudza bazi refamasi rakanyoresa kuti resiphi iyi itumirwe kutorwa kana kuendeswa.",
        },
        paymentReadyBody: "Mubhadharo wagadzirira. Pedzisa kubhadhara kuti usimbise odha iyi uye ubvumire bazi kuburitsa rekutora.",
        paymentConfirmedBody: "Mubhadharo wasimbiswa. {pharmacy} yaziviswa uye ichaburitsa odha iyi kana yagadzirira kutorwa.",
        readyBody: "{pharmacy} yati resiphi iyi yagadzirira kutorwa.",
        preparingBody: "{pharmacy} yagamuchira resiphi iyi uye iri kuigadzirira.",
        reviewingBody: "{pharmacy} yaziviswa uye iri kuongorora resiphi iyi.",
        rejectedBody: "{pharmacy} yatadza kuzadzisa resiphi iyi. Ndapota sarudza imwe famasi.",
        requestedQuoteBody: "{pharmacy} yakumbirwa kugadzirira quote ye{mode}.",
        loadingBranches: "Kurodha mabhuranchi efamasi aripo…",
        selectBranchDistance: "Sarudza bazi rinofanira kugadzirira resiphi iyi. Mabhuranchi ane geodata acharongwa nedaro chairo kutanga.",
        selectBranchCountry: "Sarudza bazi rinofanira kugadzirira resiphi iyi. AfriMed iri kushandisa kurongeka kwenyika imwe chete kusvikira nzvimbo yawanikwa.",
      },
      patientFallback: "Murwere",
      patientAge: "Ane makore {count}",
      risk: {
        normal: "Zvakajairika",
        caution: "Chenjerera",
        critical: "Zvakakomba",
      },
      errors: {
        sessionUnavailable: "Session haisi kuwanika.",
        partialData: "Zvimwe zvedashboard hazvina kukwanisa kurodha.",
        load: "Dashboard yatadza kurodha.",
      },
    },
    settings: {
      home: {
        title: "Zvirongwa",
        userFallback: "Mushandisi",
        loginSecurity: "Kupinda nekuchengeteka",
        language: "Mutauro",
        availability: "Kuwanikwa",
        notifications: "Zviziviso",
        preferences: "Zvaunofarira",
        legal: "Zvemutemo",
        faq: "Mibvunzo inowanzo bvunzwa",
        logoutDialog: {
          title: "Une chokwadi chekuti unoda kubuda here?",
          body: "Uchada kupinda zvakare kuti uenderere mberi.",
        },
      },
      language: {
        title: "Mutauro",
        availableNow: "Zviripo izvozvi",
        availableNowCopy:
          "Sarudza mutauro weAfriMed uri kushandiswa pafoni kana pakombiyuta iyi.",
        comingSoonTitle: "Zvichauya munguva pfupi",
        comingSoonCopy:
          "Mitauro yeSouthern Africa iri kugadzirirwa zvine hungwaru kuti ishande zvakanaka muhutano.",
        changedTo: "Mutauro wachinjwa kuva {language}",
      },
    },
    verify: {
      phoneOtp: {
        title: "Isa kodhi yekusimbisa",
        copy: "Takutumira kodhi ine manhamba 6 ku",
        resend: "Tumirazve kodhi",
        invalidCode: "Kodhi haisi kushanda.",
      },
    },
  },
  zu: {
    common: {
      comingSoon: "Kuyeza maduze",
      tryAgain: "Zama futhi",
      no: "Cha",
      yes: "Yebo",
      cancel: "Khansela",
      search: "Sesha",
      loggingOut: "Iyaphuma...",
      logout: "Phuma",
      legal: {
        terms: "Imigomo nemibandela",
        privacy: "Inqubomgomo yobumfihlo",
        dataDeletion: "Ukususwa kwedatha",
      },
      actions: {
        save: "Londoloza",
        continue: "Qhubeka",
        done: "Kwenziwe",
        clear: "Sula",
        clearSearch: "Sula usesho",
      },
      cookies: {
        title: "Izinketho zama-cookie ze-AfriMed™",
        intro:
          "Khetha indlela ama-cookie angaphoqelekile azosetshenziswa ngayo. Lezi zigaba zivaliwe ekuqaleni. Hlela ama-cookie akho ngezansi.",
        support:
          "Kwakhelwe ukusekela amazinga e-GDPR nemigomo ye-African Union yokuvikela idatha ukuze kube nokucaca, inhloso ecacile, nokulawula komsebenzisi.",
        close: "Vala izinketho zama-cookie",
        alwaysActive: "Kuhlala kusebenza",
        rejectOptional: "Yenqaba okungaphoqelekile",
        saveChoices: "Londoloza okukhethile",
        acceptAll: "Vuma konke",
        categories: {
          strictly: {
            label: "Ama-cookie abalulekile kuphela",
            body:
              "Ayadingeka ekusebenzeni okuyisisekelo njengokuvikeleka, ukuqhubeka kweseshini, kanye nokufinyeleleka. Lawa ma-cookie ahlala esebenza.",
          },
          statistics: {
            label: "Ama-cookie ezibalo",
            body:
              "Alinganisa ukusetshenziswa okuhlanganisiwe ukuze sithuthukise ikhwalithi yesevisi nokuqonda kwezempilo yomphakathi. Asidayisi idatha yomuntu.",
          },
          performance: {
            label: "Ama-cookie okusebenza",
            body:
              "Asisiza ukulandelela isivinini, ukuzinza, nokwethembeka kwesevisi kumadivayisi namanethiwekhi ahlukene.",
          },
          functionality: {
            label: "Ama-cookie wokusebenza komuntu",
            body:
              "Akhumbula okuthandayo njengolimi nesifunda ukuze ukubuyela kwakho kube lula kakhulu.",
          },
          targeting: {
            label: "Ama-cookie okukhankasa",
            body:
              "Asetshenziswa ukuletha noma ukunciphisa ukubaluleka kwemikhankaso. Asidayisi idatha yomuntu.",
          },
          social: {
            label: "Ama-cookie ezinkundla zokuxhumana",
            body:
              "Enza i-social login nokuqukethwe kwezinkundla zokuxhumana kusebenze. Abahlinzeki bangaphandle bangase basebenzise imigomo yabo.",
          },
          beacons: {
            label: "Ama-web beacon",
            body:
              "Amathegi amancane asetshenziswa ukuqonda ukulethwa nokuzibandakanya kwemiyalezo lapho kudingeka khona.",
          },
        },
      },
    },
    home: {
      doctor: {
        fallbackName: "Udokotela",
        patientFallback: "Isiguli",
        consultancyFallback: "Ukubonisana",
        welcome: "Siyakwamukela Dkt {surname}",
        specialtyFallback: "Udokotela",
        actions: {
          openProfile: "Vula iphrofayela",
          dashboard: "I-dashboard",
          notifications: "Izaziso",
          viewAll: "Bona konke",
        },
        appointments: {
          title: "Ama-aphoyintimenti akho",
          loading: "Kulayishwa ama-aphoyintimenti...",
          loadingError: "Silayisha ama-aphoyintimenti akho. Sicela ubuye uzame maduze.",
          error: "Asikwazanga ukulayisha ama-aphoyintimenti.",
          emptyTitle: "Awunawo ama-aphoyintimenti ahleliwe.",
          emptyBody: "Ama-aphoyintimenti avunyiwe azovela lapha uma iziguli sezivumile.",
          when: {
            today: "Namuhla",
          },
          tabs: {
            today: "Namuhla",
            todayCount: "Namuhla {count}",
            upcoming: "Okuzayo",
            upcomingCount: "Okuzayo {count}",
            pending: "Kulindwe ukuvunywa",
            pendingCount: "Kulindwe ukuvunywa {count}",
          },
        },
        elevate: {
          title: "Phakamisa ukubonakala komsebenzi wakho",
        },
        gallery: {
          title: "Yenza iphrofayela yakho ivelele",
          body: "Engeza izithombe ezichaza umsebenzi wakho",
          notNow: "Hhayi manje",
        },
        regional: {
          title: "Ezempilo zesifunda",
          headline: "Hlala unolwazi ngezempilo zesifunda",
          defaultSummary: "izitayela nezimo zezempilo",
          facilitySummary: "Izikhungo ezingu-{count} nezitayela zempilo",
        },
      },
    },
    auth: {
      login: {
        sheet: {
          manageCookies: "Phatha ama-cookie",
        },
        landing: {
          title: "Siyakwamukela ku-AfriMed™",
          line1: "Asiqale uhambo oluya",
          line2: "empilweni engcono ndawonye!",
          registerEmail: "Bhalisa nge-imeyili",
          registerFacebook: "Bhalisa nge-Facebook",
          registerGoogle: "Bhalisa nge-Google",
          login: "Ngena",
          trouble: "Unenkinga yokungena?",
          journey: "Uhambo lwakho lokuthola ukunakekelwa luqala lapha!",
        },
      },
    },
    appointments: {
      details: {
        title: "Imininingwane ye-aphoyintimenti",
        status: {
          completed: "KUQEDIWE",
          pending: "KULINDILE",
          cancelled: "KUKHANSELIWE",
          missed: "KUPHOSIWE",
        },
        message: "Umlayezo",
        call: "Shayela",
      },
      edit: {
        paymentMethodFallback: "Amakhadi edebhithi noma ekhredithi",
      },
      doctorIndex: {
        defaultFacilityName: "Indawo enkulu ayikabekwa",
        errorLoad: "Asikwazanga ukulayisha ama-aphoyintimenti.",
        loading: "Kulayishwa ama-aphoyintimenti...",
        emptyTitle: "Awekho ama-aphoyintimenti aboniswayo",
        emptyBody: "Akukho lutho okwamanje. Buya futhi kamuva.",
        patientFallback: "Isiguli",
        selectDay: "Khetha usuku {day}",
        weekNav: {
          previous: "Iviki eledlule",
          next: "Iviki elilandelayo",
        },
        monthNav: {
          previous: "Inyanga edlule",
          next: "Inyanga elandelayo",
        },
        viewMode: {
          label: "Uhlobo lokubuka",
          day: "Usuku",
          week: "Iviki",
          month: "Inyanga",
          list: "Uhlu",
        },
        list: {
          freeSchedule: "Ishejuli ekhululekile",
          allDay: "Usuku lonke",
        },
        snackbar: {
          rescheduled: "I-aphoyintimenti ishintshelwe ku-{date}. Ilindele ukuvunywa kwesiguli.",
          review: "Buyekeza",
          cancelled: "I-aphoyintimenti ikhanseliwe",
        },
      },
      summary: {
        title: "Ukubonana kuqediwe",
      },
    },
    messages: {
      inbox: {
        title: "Imilayezo",
        emptyTitle: "Ayikho imilayezo ezoboniswa",
        emptyBody: "Ibhokisi lakho lokungenayo alinalutho okwamanje. Buya futhi kamuva.",
      },
      loadingConversation: "Kulayishwa ingxoxo...",
      noMessagesYet: "Akukabi nemilayezo.",
      writeMessage: "Bhala umlayezo...",
      conversation: {
        deleteDialog: {
          title: "Susa umlayezo?",
          forMe: "Susa kimi",
          forBoth: "Susa kubo bonke",
        },
        composer: {
          send: "Thumela umlayezo",
          thinking: "Fola uyabhala...",
        },
      },
    },
    referrals: {
      entry: {
        postConsultActions: "Okumele kwenziwe ngemva kokubonana",
        postConsultActionsSubtitle:
          "Bamba isifinyezo bese uqhubekisela phambili ukunakekelwa kwesiguli.",
      },
      doctor: {
        title: "Dlulisela isiguli",
      },
      consultationNote: {
        save: "Londoloza inothi",
      },
    },
    doctors: {
      appointmentDetails: {
        title: "Imininingwane ye-aphoyintimenti",
        loading: "Kulayishwa imininingwane ye-aphoyintimenti...",
        notFound: "I-aphoyintimenti ayitholakali. Sicela ubuyele emuva uyivule futhi.",
        backToAppointments: "Buyela kuma-aphoyintimenti",
        patientFallback: "Isiguli",
        doctorFallback: "Udokotela",
        yearsOld: "Iminyaka engu-{count}",
        facilityFallback: "Isibhedlela esizimele",
        firstAppointment: "I-aphoyintimenti yokuqala",
        diagnosisTitleFallback: "Ukuhlonza namanothi",
        meetPending: "Igumbi elivikelekile lokubonana le-AfriMed™",
        eVisit: "Ukuvakasha ku-inthanethi",
        notesEmpty: "Awekho amanothi akhona.",
        photosEmpty: "Azikho izithombe zesiguli ezabiwe okwamanje.",
        notesPlaceholder: "Engeza amanothi...",
        notesAutosave: "Amanothi azigcina wona lapho ushiya le ngosi.",
        status: {
          pending: "Kulindile",
          scheduled: "Kuhlelwe",
          inProgress: "Kuyaqhubeka",
          completed: "Kuqediwe",
          missed: "Kuphosiwe",
          cancelled: "Kukhanseliwe",
          confirmed: "Kuqinisekisiwe",
        },
        startsIn: {
          default: "Kuqala ngehora elingu-1",
          minutes: "Kuqala emizuzwini engu-{count}",
          hours: "Kuqala emahoreni angu-{count}",
        },
        sections: {
          diagnosis: "Ukuhlonza",
          prescription: "Iresiphi",
          testsAndLabs: "Izivivinyo nemiphumela yelabhu",
          testsAndDocuments: "Izivivinyo nemibhalo",
          notes: "Amanothi",
          photos: "Izithombe zesiguli",
          ehr: "EHR",
          support: "Ukusekelwa",
        },
        fields: {
          bloodType: "Uhlobo lwegazi",
          allergies: "Ukungezwani komzimba",
          chronicConditions: "Izifo ezingapheli",
          organDonor: "Umnikeli wezitho",
        },
        requestEhr: {
          title: "Cela i-EHR",
          body: "Nikeza ukunakekelwa okungcono ngokuthola i-Electronic Health Record yesiguli sakho",
        },
        ehr: {
          accessGranted: "Ukufinyelela kunikiwe",
          accessRequested: "Ukufinyelela kuceliwe",
        },
        fulfillment: {
          title: "Ukugcwaliswa kweresiphi",
          deliveryMode: "Ukulethwa",
          pickupMode: "Ukulanda",
          selectedPharmacy: "Ikhemisi ekhethiwe",
          readyForPickup: "Sekulungele ukulandwa",
          readyForPickupDescription:
            "{pharmacy} imake le resiphi njengelungele ukulandwa.",
          fulfillmentModeComplete: "Ukuhanjiswa kwe-{mode} sekuphelile ohlangothini lwekhemisi.",
          paid: "Kukhokhiwe",
          paidDescription: "{pharmacy} iqinisekise inkokhelo yale resiphi.",
          waitForPickup: "Linda ikhemisi limake i-oda njengelilungele ukulandwa.",
          paymentReady: "Inkokhelo isilungile",
          paymentReadyDescription:
            "{pharmacy} ibeke intengo futhi isiguli singakhokha manje ku-AfriMed.",
          waitingForPayment: "Ukuhanjiswa kwe-{mode} kulinde inkokhelo yesiguli.",
          pharmacyPreparing: "Ikhemisi iyalungisa",
          pharmacyPreparingDescription:
            "{pharmacy} ivumile iresiphi futhi iyayilungisa.",
          folaActive: "Ukuhanjiswa kwe-{mode} kuyasebenza ku-Fola.",
          needsNewPharmacy: "Kudingeka enye ikhemisi",
          needsNewPharmacyDescription:
            "{pharmacy} ayikwazanga ukugcwalisa le resiphi.",
          chooseAnotherPharmacy: "Isiguli kufanele sikhethe enye ikhemisi ebhalisiwe.",
          pharmacySelected: "Ikhemisi ikhethiwe",
          pharmacySelectedDescription:
            "{pharmacy} yiyo igatsha elisebenzayo lokuhanjiswa kwe-{mode} lale resiphi.",
          openFolaConversation: "Vula i-Fola handoff ukuze ulandele ingxoxo yekhemisi.",
          syncingFola: "I-Fola handoff isaqhathanisa kulesi sikrini.",
          folaStarted: "I-Fola handoff isiqalile",
          folaStartedDescription:
            "Ukusekelwa kweresiphi sekuyasebenza futhi ingxoxo yokugcwaliswa isilungile.",
          followPharmacyUpdates: "Vula i-Fola handoff ukuze ulandele izibuyekezo zekhemisi.",
          issued: "Ikhishiwe",
          issuedDescription:
            "Iresiphi ikhishiwe. I-Fola handoff isaqhathanisa kulesi sikrini.",
        },
        actions: {
          profile: "Iphrofayela",
          editDiagnosis: "Hlela ukuhlonza",
          add: "Engeza",
          view: "Buka",
          request: "Cela",
          showAll: "Bonisa konke",
          message: "Umlayezo",
          call: "Shayela",
          join: "Joyina",
          joinClosed: "Iwindi livaliwe",
          updating: "Kubuyekezwa...",
          details: "Imininingwane",
          changeAppointment: "Shintsha i-aphoyintimenti",
          startConsultation: "Qala ukubonana",
          markInProgress: "Maka njengokuqhubekayo",
          completeConsultation: "Qeda ukubonana",
          openFolaHandoff: "Vula i-Fola handoff",
        },
        support: {
          unavailablePastAppointments: "Akutholakali kuma-aphoyintimenti adlulile",
        },
        cancelDialog: {
          title: "Khansela i-aphoyintimenti?",
          description: "Khumbula ukuqala uxhumane nesiguli ngaphambi kokuqhubeka.",
          confirm: "Yebo, khansela",
        },
        deleteDialog: {
          title: "Uqinisekile ukuthi ufuna ukususa le rekhodi ye-aphoyintimenti?",
          description: "Uma usususile le rekhodi, ngeke ukwazi ukuyibuyisela.",
          confirm: "Susa",
        },
        changeSheet: {
          title: "Shintsha noma ubuyekeze i-aphoyintimenti",
          requestNewTime: "Cela isikhathi esisha",
          cancelAppointment: "Khansela i-aphoyintimenti",
        },
        completeConsultationDialog: {
          body: "Qedela lokhu kubonana kuphela uma usuqedile futhi amanothi egciniwe.",
          confirmShort: "Qeda",
        },
        toast: {
          callOnlyDuringAppointment: "Ungashayela kuphela ngesikhathi sale aphoyintimenti.",
          rescheduleRequested: "Isicelo sesikhathi esisha sithunyelwe. Silindele ukuvunywa.",
        },
        errors: {
          auth: "Ukungena kuyadingeka.",
          update: "Asikwazanga ukubuyekeza i-aphoyintimenti.",
          requestEhr: "Asikwazanga ukucela i-EHR njengamanje.",
          completeConsultation: "Asikwazanga ukuqeda ukubonana.",
        },
        attachments: {
          remove: "Susa okunamathiselwe",
          removed: "Okunamathiselwe kususiwe.",
        },
      },
    },
    regionalHealth: {
      title: "Ezempilo zesifunda",
      loading: "Kulayishwa ulwazi lwezempilo zesifunda...",
      newAlert: "Isaziso esisha",
      diseaseFallback: "Coronavirus",
      diseases: {
        coronavirus: "Coronavirus",
        influenza: "Umkhuhlane",
        malaria: "Umalaleveva",
        rsv: "RSV",
        cholera: "Ikholera",
        measles: "Isimungumungwane",
        dengue: "Idenge",
      },
      actions: {
        resetView: "Setha kabusha ukubuka",
      },
      source: {
        live: "Okuphakelayo bukhoma kwezempilo zesifunda",
        demo: "Idemo yokuphakelayo kwezempilo zesifunda",
      },
      metrics: {
        patients: "Iziguli ezingu-{count}",
        patientsTitle: "Iziguli ezingu-{count}",
        update: "Isibuyekezo",
      },
      errors: {
        mapTokenMissing: "Ayikho i-map token",
      },
      status: {
        good: "Kuhle",
        acceptable: "Kwamukelekile",
        caution: "Qaphela",
        critical: "Kubucayi",
      },
      updated: {
        today: "Namuhla",
        yesterday: "Izolo",
      },
      countries: {
        angola: "i-Angola",
        botswana: "iBotswana",
        comoros: "iComoros",
        drCongo: "i-DR Congo",
        eswatini: "iSwatini",
        lesotho: "iLesotho",
        madagascar: "iMadagascar",
        malawi: "iMalawi",
        mauritius: "iMauritius",
        mozambique: "iMozambique",
        namibia: "iNamibia",
        seychelles: "iSeychelles",
        southAfrica: "iNingizimu Afrika",
        tanzania: "iTanzania",
        zambia: "iZambia",
        zimbabwe: "iZimbabwe",
      },
    },
    doctorDashboard: {
      metrics: {
        patients: "Iziguli",
        overallRating: "Isilinganiso sonke",
        appointments: "Ama-aphoyintimenti",
        prescriptions: "Amarisiphi",
        past30Days: "Ezinsukwini ezingu-30 ezedlule",
        thisMonth: "Kule nyanga",
      },
      range: {
        label: "Ibanga lesikhathi",
        today: "Namuhla",
        week: "Iviki",
        month: "Inyanga",
        year: "Unyaka",
      },
      visitors: {
        title: "Abavakashi bekiliniki",
        menu: "Ibanga lesikhathi sabavakashi bekiliniki",
        loadingChart: "Kulayishwa ishadi...",
        empty: "Akukabi nedatha yethrendi yama-aphoyintimenti.",
        range: {
          threeMonths: "Ezinyangeni ezi-3 ezedlule",
          sixMonths: "Ezinyangeni ezi-6 ezedlule",
          year: "Onyakeni odlule",
        },
      },
      calendar: {
        title: "Abavakashi bokubonana",
        selectMonth: "Khetha inyanga",
        previousMonth: "Inyanga edlule",
        nextMonth: "Inyanga elandelayo",
        noAppointments: "Awekho ama-aphoyintimenti",
        legend: {
          appointment: "I-aphoyintimenti",
          eVisit: "Ukuvakasha ku-inthanethi",
          pending: "Kulindile",
        },
      },
      patientsAppointments: {
        title: "Ama-aphoyintimenti eziguli",
        subtitle: "Ukubuka konke kohambo lwesiguli nosizo olunikezwe emtholampilo.",
        loading: "Kulayishwa ama-aphoyintimenti...",
        empty: "Awekho ama-aphoyintimenti kuleli banga lesikhathi.",
        noDiagnosis: "Akukho kuhlonza okubhaliwe.",
        notProvided: "Akunikezwanga",
        openDetails: "Vula imininingwane ye-aphoyintimenti",
        columns: {
          patientName: "Igama lesiguli",
          primaryCondition: "Isimo esiyinhloko",
          riskLevel: "Izinga lobungozi",
          insurance: "Umshwalense",
          lastVisit: "Ukuvakashela kokugcina",
        },
      },
      prescriptions: {
        title: "Amarisiphi akamuva",
        subtitle: "Amarisiphi akamuva owawakhe ahlobene nokunakekelwa kwama-aphoyintimenti.",
        searchPlaceholder: "Sesha nge-ID yesiguli",
        searchAria: "Sesha amarisiphi akamuva nge-ID yesiguli",
        loading: "Kulayishwa amarisiphi...",
        empty: "Awakabi khona amarisiphi.",
        noMatches: "Akukho okufanayo okutholakele.",
        columns: {
          patient: "Isiguli",
          issued: "Ikhishiwe",
          expires: "Iphelelwa",
          rxNumber: "Inombolo yeRx",
          status: "Isimo",
        },
        status: {
          draft: "Okusalungiswa",
          issued: "Ikhishiwe",
          dispensed: "Kunikwe",
          cancelled: "Kukhanseliwe",
          expired: "Iphelelwe",
        },
      },
      prescriptionsPage: {
        title: "Umlando wamarisiphi",
        heading: "Umlando wamarisiphi",
        subtitle: "Amarisiphi akhishiwe ahlobene nokunakekelwa okusekelwe kuma-aphoyintimenti.",
        issuedPast30Days: "{count} akhishiwe ezinsukwini ezingu-30 ezedlule.",
        columns: {
          refill: "Ukuphindiselwa",
        },
        errors: {
          load: "Asikwazanga ukulayisha amarisiphi.",
        },
      },
      common: {
        title: "Iresiphi",
        notFound: "Iresiphi ayitholakalanga.",
        item: "iresiphi",
        medication: "Umuthi",
        patient: "Isiguli",
        facility: "Isikhungo",
        dob: "Usuku lokuzalwa",
        id: "ID",
        ePrescription: "Iresiphi ye-elekthronikhi",
        qrCode: "Ikhodi ye-QR",
        verificationQr: "I-QR yokuqinisekisa",
        prescriber: "Umnikezeli weresiphi",
        registration: "Ukubhaliswa",
        registrationShort: "Reg",
        prescriptionNumber: "Inombolo yeresiphi",
        issued: "Ikhishiwe",
        signInToView: "Sicela ungene ukuze ubuke le resiphi.",
        accessDenied: "Awunalo ilungelo lokufinyelela kule nkokhelo yeresiphi.",
        loadFailed: "Asikwazanga ukulayisha le resiphi.",
        poweredByIssuedVia:
          "Inikwe amandla yi {issuedVia}. Umnikezeli weresiphi usalokhu enesibopho sezimiso zokwelashwa.",
      },
      wizard: {
        header: {
          addPrescription: "Engeza iresiphi",
          subtitle: "Ungayengeza ngesandla noma usebenzise ikhamera ukuyifaka.",
        },
        medication: "Umuthi",
        addStrength: "Engeza amandla omuthi",
        addMedication: "Engeza umuthi",
        uploadImage: "Layisha isithombe",
        searchOrAdd: "Sesha noma engeza",
        possibleMatches: "Okungenzeka kufane",
        loadingMatches: "Kuyalayishwa... sicela ume kancane!",
        noMatchesAdd: "Akukho okufanayo. Thepha + ukuze ungeze “{query}”.",
        chooseMedicationType: "Khetha uhlobo lomuthi",
        chooseUnit: "Khetha iyunithi",
        select: "Khetha",
        frequency: {
          title: "Ukuvama",
          daily: "Nsuku zonke",
          cyclical: "Ngomjikelezo",
          specificDays: "Ngosuku oluthile lweviki",
          asNeeded: "Uma kudingeka",
        },
        days: {
          title: "Izinsuku zeviki",
          label: "Izinsuku",
          mon: "Mso",
          tue: "Bil",
          wed: "Tha",
          thu: "Sin",
          fri: "Hla",
          sat: "Mgq",
          sun: "Son",
        },
        medType: {
          capsule: "Ikhepsuli",
          tablet: "Iphilisi",
          injectionSolution: "Umjovo",
          oralSolution: "Umuthi womlomo",
          topical: "Okwesikhumba",
          device: "Idivayisi",
          drops: "Amaconsi",
          inhaler: "I-inhaler",
        },
        dose: "Idosi",
        every: "Njalo ngemva",
        day: "Usuku",
        time: "Isikhathi",
        timeAndDoses: "Isikhathi namadosi",
        cyclicalShort: "Umjikelezo",
        doses: "Amadosi",
        duration: "Ubude besikhathi",
        startDate: "Usuku lokuqala",
        endDate: "Usuku lokugcina",
        cycle: "Umjikelezo",
        useFor: "Sebenzisa izinsuku",
        pauseFor: "Misa izinsuku",
        hoursValue: "amahora angu-{count}",
        schedule: "Isheduli",
        dosage: "Idosi",
        starts: "Iqala",
        ends: "Iyaphela",
        optionalNotes: "Amanothi angazikhethela esiguli",
        signAndPrescribe: "Sayina bese ubhala iresiphi",
        issuing: "Kukhishwa iresiphi...",
        viewPrescription: "Buka iresiphi",
        addImagesToGallery: "Engeza izithombe egalari",
        uploadFromGallery: "Layisha egalarini",
        takePhoto: "Thatha isithombe",
        timeInterval: "Isikhawu sesikhathi",
        qrCode: "Ikhodi ye-QR",
        issueFirstForQr: "Khipha iresiphi kuqala ukuze uvule i-QR eqinisekiswayo.",
        scheduleUnavailable: "Isheduli ayitholakali",
        prescriber: "Umnikezeli weresiphi",
        poweredBy:
          "Inikwe amandla yi-AfriMed™. Umnikezeli weresiphi usalokhu enesibopho sezimiso zokwelashwa.",
        errors: {
          appointmentNotFound: "I-aphoyintimenti yaleli resiphi ayitholakalanga.",
          recordLinkageMissing: "Ukuxhumana kwerekhodi likadokotela nesiguli kulahlekile kule resiphi.",
          authLinkageMissing: "Ukuxhumana kwe-auth kukadokotela nesiguli kulahlekile kule resiphi.",
          idMissing: "Iresiphi ikhishiwe kodwa ayibuyisanga i-ID.",
          issueFailed: "Asikwazanga ukukhipha iresiphi.",
        },
      },
      checkout: {
        title: "Ukukhokhela ifamasi",
        openFolaShort: "Fola",
        openFola: "Vula i-Fola handoff",
        feedbackSubtitle: "Bamba lesi sinyathelo sokukhokha ukuze i-AfriMed ivule kabusha umongo oqondile womhloli.",
        sponsor: {
          title: "Inkokhelo yomxhasi",
          headline: "Sebenzisa isixhumanisi somxhasi esivikelekile",
          body: "Dala isixhumanisi somxhasi esiphethwe yi-Stripe ukuze ilungu lomndeni noma umxhasi akhokhe esuka kwenye imakethe, bese i-AfriMed ibuyisela inkokhelo kurekhodi yefamasi.",
          prepare: "Lungisa inkokhelo yomxhasi",
          prefill: "Ukugcwaliswa kweresiphi",
        },
        card: {
          title: "Imininingwane yokukhokha",
          headline: "Ukukhokha ngekhadi",
          body: "Khokhela igatsha lefamasi elifunwe manje ukuze ukudluliswa komuthi kuqhubeke ngaphandle kokulandela ngesandla.",
          loading: "Kulayishwa ifomu lekhadi elivikelekile…",
          remember: "Khumbula imininingwane yekhadi lesikweletu ngokuzayo",
          processing: "Kuyacutshungulwa…",
          payNow: "Khokha ifamasi manje",
          refresh: "Layisha kabusha imininingwane yokukhokha",
        },
        summary: {
          prescription: "Iresiphi",
          pharmacy: "Ifamasi ekhishayo",
          awaitingBranch: "Igatsha alikakhethwa",
          deliveryHelper: "Ikhotheshini yokulethwa ilungiswe yifamasi.",
          pickupHelper: "Ikhotheshini yokulanda ilungiswe yifamasi.",
          subtotal: "Ingqikithi yomuthi",
          delivery: "Ukulethwa",
          total: "Ingqikithi",
          totalHelper: "Imali yepulatifomu ye-AfriMed icutshungulwa ngemuva futhi ayengezwa phezu kwaleli nani lesiguli.",
          state: "Isimo sokugcwaliswa",
          mode: "Indlela",
          modeHelper: "Sebenzisa i-Fola handoff uma ifamasi idinga ukucaciselwa ngaphambi kokukhulula.",
        },
        state: {
          paid: "Ikhokhiwe",
          paidHelper: "Buyela emininingwaneni yeresiphi ukuze ubone ukukhululwa nokulanda.",
          refundPending: "Imbuyiselo ilindile",
          refundPendingHelper: "Le nkokhelo yefamasi iyabuyiselwa.",
          refunded: "Ibuyisiwe",
          refundedHelper: "Khetha enye ifamasi uma le resiphi isadinga ukugcwaliswa.",
          paymentReady: "Inkokhelo isilungile",
          paymentReadyHelper: "Ifamasi ilungise ikhotheshini. Qedela inkokhelo ukuze uqinisekise i-oda.",
          awaitingQuote: "Ikhotheshini ilindile",
          awaitingQuoteHelper: "Buyela emininingwaneni yeresiphi uma ifamasi isilungise amanani.",
        },
        status: {
          preparing: "Kulungiswa ukukhokhela ifamasi…",
          restoringSponsor: "Kubuyiselwa inkokhelo yomxhasi futhi kuyananiswa i-ledger yefamasi…",
          awaitingQuoteBody: "Ifamasi ayikakalungisi ikhotheshini ekhokhekayo yale resiphi. Vula imininingwane yeresiphi futhi uma ifamasi isiqinisekisile i-subtotal nokugcwaliswa.",
          alreadyPaid: "Le resiphi isivele ikhokhiwe. Ungabuyela emininingwaneni yeresiphi ukuze ubone isimo senkokhelo nembuyiselo samanje.",
          alreadyReversing: "Le nkokhelo yefamasi isivele ibuyiselwa. Buyela emininingwaneni yeresiphi ukuze ubone isimo sembuyiselo samanje.",
          alreadyRefunded: "Le nkokhelo yefamasi isivele ibuyisiwe.",
          preparingCard: "Kulungiswa ukukhokha ngekhadi okuvikelekile…",
        },
        errors: {
          signInAgain: "Sicela ungene futhi ukuze uqhubeke.",
          accessDenied: "Awunalo ilungelo lokukhokhela le resiphi.",
          load: "Asikwazanga ukulayisha inkokhelo yale resiphi okwamanje.",
          notConfigured: "Indlela yokukhokha ye-Stripe ayikakalungiselelwa kule ndawo.",
          stripeLoad: "Indlela yokukhokha ye-Stripe ayikwazanga ukulayisha okwamanje.",
          sessionExpired: "Iseshini iphelelwe yisikhathi. Sicela ungene futhi.",
          quoteNotReady: "Le resiphi ayikabi nayo ikhotheshini yefamasi elungele ukukhokhwa.",
          formLoading: "Ifomu lekhadi elivikelekile lisalayisha. Sicela ulayishe kabusha imininingwane yokukhokha.",
          secureCheckout: "Ukukhokha okuvikelekile akulungiswanga kahle. Layisha kabusha imininingwane yokukhokha bese uzama futhi.",
          prepareIntent: "I-Stripe ayikwazanga ukulungisa le payment intent.",
          paymentFailed: "Inkokhelo ayikwazanga ukuqedwa.",
          processing: "Inkokhelo yakho isacutshungulwa. Sicela ulinde umzuzwana bese uzama futhi.",
          referenceMissing: "Inkokhelo iqediwe kodwa ireferensi yenkokhelo ibingekho.",
          sponsorRestore: "Inkokhelo yomxhasi iqediwe, kodwa i-AfriMed ayikwazanga ukubuyisela inkokhelo yefamasi okwamanje.",
          intentMissing: "I-Stripe ayikwazanga ukuthola le payment intent yefamasi kulesi siphequluli. Layisha kabusha imininingwane yokukhokha bese uzama futhi.",
          payoutReconnect: "Ukuxhumeka kwephayout yefamasi kudinga ukubuyiselwa ngaphambi kokuthi ukukhokha ngekhadi kuqhubeke.",
          generic: "Inkokhelo kungenzeka ukuthi idlulile, kodwa i-AfriMed ayikwazanga ukuqedela ukukhokha yefamasi kahle.",
          intentMismatch: "I-Stripe ayikwazanga ukuthola le payment intent yefamasi efomini lekhadi elisebenzayo. Layisha kabusha imininingwane yokukhokha bese uzama futhi.",
          intentMismatchWithAccount: "I-Stripe ayikwazanga ukuthola le payment intent yefamasi efomini lekhadi elisebenzayo. I-AfriMed iyidalile ku-akhawunti yepulatifomu {account}. Layisha kabusha imininingwane yokukhokha bese uzama futhi.",
        },
      },
      fulfillment: {
        modePickup: "Ukulanda",
        modeDelivery: "Ukulethwa",
        modePickupLower: "ukulanda",
        modeDeliveryLower: "ukulethwa",
        selectedPharmacy: "Ifamasi ekhethiwe",
        yourSelectedPharmacy: "Ifamasi yakho ekhethiwe",
        theSelectedPharmacy: "Ifamasi ekhethiwe",
        requestedPharmacy: "Ifamasi eceliwe",
        afrimedPharmacy: "Ifamasi ye-AfriMed",
        totalCost: "Izindleko zizonke",
        nearbyPharmacies: "Amakhemisi aseduze",
        signedUpPharmacies: "Amakhemisi abhalisiwe",
        loadingNearby: "Kulayishwa amakhemisi amathathu aseduze abhalisiwe…",
        chooseNearby: "Khetha elinye lamakhemisi amathathu aseduze ukuze uqhubeke.",
        chooseRanked: "Khetha ikhemisi elibhalisiwe ukuze uqhubeke. I-AfriMed izowahlela ngebanga uma indawo isitholakala.",
        noneAvailable: "Okwamanje awekho amagatsha ekhemisi abhalisiwe atholakalayo.",
        distanceMeters: "{count} m kude",
        distanceKm: "{count} km kude",
        locationPending: "Imininingwane yendawo isalindile",
        pickupPending: "Ukulanda kulindile",
        medicineSubtotal: "Ingqikithi yomuthi",
        total: "Ingqikithi",
        quoteIncludesDelivery: "Le khotheshini ifaka ukulethwa.",
        quotePreparedForPickup: "Le khotheshini ilungiselelwe ukulanda.",
        quotedOn: "Ikhotshwe ngo-{date}.",
        banner: {
          ready: "{pharmacy} imake le resiphi njengelungele ukulandwa.",
          paid: "Inkokhelo iqinisekisiwe. {pharmacy} ilungiselela ukukhulula ukuze kulandwe.",
          awaitingPayment: "{pharmacy} ibeke intengo yale resiphi.",
          preparing: "{pharmacy} ilungisa le resiphi.",
          reviewing: "{pharmacy} ibuyekeza le resiphi.",
          rejected: "{pharmacy} ayikwazanga ukugcwalisa le resiphi.",
          chooseBranch: "Khetha igatsha lefamasi elibhalisiwe ukuze uqhubeke.",
          handling: "{pharmacy} iphethe le resiphi.",
          requestPending: "{pharmacy} ilungisa ikhotheshini.",
          chooseBranchForMode: "Khetha igatsha lefamasi elibhalisiwe ukuze le resiphi ithunyelwe ukuze ilandwe noma ilethwe.",
        },
        paymentReadyBody: "Inkokhelo isilungile. Qedela ukukhokha ukuze uqinisekise leli oda lefamasi futhi uvumele igatsha likhulule ukulanda.",
        paymentConfirmedBody: "Inkokhelo iqinisekisiwe. {pharmacy} yazisiwe futhi izokhulula leli oda uma selilungele ukulandwa.",
        readyBody: "{pharmacy} imake le resiphi njengelungele ukulandwa.",
        preparingBody: "{pharmacy} yamukele le resiphi futhi iyayilungisa.",
        reviewingBody: "{pharmacy} yazisiwe futhi ibuyekeza le resiphi.",
        rejectedBody: "{pharmacy} ayikwazanga ukugcwalisa le resiphi. Sicela ukhethe enye ifamasi.",
        requestedQuoteBody: "{pharmacy} iceliwe ukuba ilungise ikhotheshini ye-{mode}.",
        loadingBranches: "Kulayishwa amagatsha efamasi atholakalayo…",
        selectBranchDistance: "Khetha igatsha okufanele lilungise le resiphi. Amagatsha ane-geodata azohlelelwa kuqala ngebanga langempela.",
        selectBranchCountry: "Khetha igatsha okufanele lilungise le resiphi. I-AfriMed isebenzisa ukuhleleka kwezwe elifanayo kuze kutholakale indawo.",
      },
      patientFallback: "Isiguli",
      patientAge: "Iminyaka engu-{count}",
      risk: {
        normal: "Okuvamile",
        caution: "Qaphela",
        critical: "Kubucayi",
      },
      errors: {
        sessionUnavailable: "Iseshini ayitholakali.",
        partialData: "Ezinye izingxenye zedashboard azikwazanga ukulayishwa.",
        load: "Idashboard ayikwazanga ukulayishwa.",
      },
    },
    settings: {
      home: {
        title: "Izilungiselelo",
        userFallback: "Umsebenzisi",
        loginSecurity: "Ukungena nokuvikeleka",
        language: "Ulimi",
        availability: "Ukutholakala",
        notifications: "Izaziso",
        preferences: "Okuncanyelwayo",
        legal: "Ezomthetho",
        faq: "Imibuzo evame ukubuzwa",
        logoutDialog: {
          title: "Uqinisekile ukuthi ufuna ukuphuma?",
          body: "Uzodinga ukungena futhi ukuze uqhubeke.",
        },
      },
      language: {
        title: "Ulimi",
        availableNow: "Lutholakala manje",
        availableNowCopy:
          "Khetha ulimi lwe-AfriMed oluzosebenza kule divayisi nakule akhawunti.",
        comingSoonTitle: "Kuyeza maduze",
        comingSoonCopy:
          "Izilimi zaseNingizimu ne-Afrika zilungiselelwa ngokucophelela ukuze zisetshenziswe kahle kwezempilo.",
        changedTo: "Ulimi lushintshelwe ku-{language}",
      },
    },
    verify: {
      phoneOtp: {
        title: "Faka ikhodi yokuqinisekisa",
        copy: "Sikuthumelele ikhodi enamadijithi angu-6 ku",
        resend: "Thumela futhi ikhodi",
        invalidCode: "Ikhodi ayilungile.",
      },
    },
  },
  tn: {
    messages: {
      loadingConversation: "Go laisa puisano...",
      noMessagesYet: "Ga go melaetsa e e leng teng.",
    },
    fola: {
      widget: {
        placeholder: "Botsa Fola sengwe le sengwe",
      },
    },
  },
};
